export const TRANSLATIONS = {
    LOGOUT: "logout",
    GOHOME: "gohome",
    NOT_FOUND: "notFound",
    ROLE: "role",
    MY_PROFILE: "myProfile",
    DELETE_ACCOUNT: "deleteAccount",
    PREMIUM: "premium",
    MY_ACCOUNT: "myAccount",
    MY_ACCOUNT_SUBTITLE: "myAccountSubtitle",
    MY_ACCOUNT_NAME_HINT: "myAccountNameHint",
    MY_ACCOUNT_LANGUAGE_LABEL: "myAccountLanguageLabel",
    PROFILE_DISPLAY_NAME_LABEL: "profileDisplayNameLabel",
    PROFILE_PHOTO_URL_LABEL: "profilePhotoUrlLabel",
    PROFILE_SAVE_CHANGES: "profileSaveChanges",
    PROFILE_UPDATED_MESSAGE: "profileUpdatedMessage",
    CANCEL: "cancel",
    BACK: "back",
    DELETE_ITEM_CONFIRM_TITLE: "deleteItemConfirmTitle",
    DELETE_ITEM_CONFIRM_KEEP: "deleteItemConfirmKeep",
    DELETE_ITEM_CONFIRM_DELETE: "deleteItemConfirmDelete",
    TOAST_DISMISS_LABEL: "toastDismissLabel",
    USER_NAME:"userName",
    COUNTRY: "country",
    PASSWORD: "password",
    CONFIRM_PASSWORD: "confirmPassword",
    EMAIL: "email",
    REGISTER: "register",
    REGISTER_TITLE: "registerTitle",
    LAYOUT_HEADER_SIGN_UP: "layoutHeaderSignUp",
    REGISTERING: "registering",
    SETTINGS: "settings",
    USER_NAME_TWO: 'userNameTwo',
    USERNAME_MESSAGE_TWO: 'userNameMessageTwo',
    COUNTRY_PLACEHOLDER: 'countryPlaceholder',
    COMPLETE_PROFILE_TITLE: 'completeProfileTitle',
    COMPLETE_PROFILE_SUBTITLE: 'completeProfileSubtitle',
    COMPLETE_PROFILE_PHONE_LABEL: 'completeProfilePhoneLabel',
    COMPLETE_PROFILE_SUBMIT: 'completeProfileSubmit',
    COMPLETE_PROFILE_ERROR_FALLBACK: 'completeProfileErrorFallback',
    AGE_VERIFICATION_TITLE: 'ageVerificationTitle',
    AGE_VERIFICATION_INTRO: 'ageVerificationIntro',
    AGE_VERIFICATION_START_BUTTON: 'ageVerificationStartButton',
    AGE_VERIFICATION_SCAN_INSTRUCTIONS: 'ageVerificationScanInstructions',
    AGE_VERIFICATION_WAITING: 'ageVerificationWaiting',
    AGE_VERIFICATION_SUCCESS_TITLE: 'ageVerificationSuccessTitle',
    AGE_VERIFICATION_SUCCESS_DESC: 'ageVerificationSuccessDesc',
    AGE_VERIFICATION_CONTINUE_BUTTON: 'ageVerificationContinueButton',
    AGE_VERIFICATION_EXPIRED: 'ageVerificationExpired',
    AGE_VERIFICATION_RETRY_BUTTON: 'ageVerificationRetryButton',
    EMAIL_VALID_MESSAGE: 'emailValidMessage',
    LOGIN_TITLE: "loginTitle",
    LOG_IN: "logIn",
    LOGGING_IN: "loggingIn",
    FORGOT_PASSWORD: "forgotPassword",
    NO_ACCOUNT: "noAccount",
    REGISTER_HERE: "registerHere",
    CONTINUE_WITH: "continueWith",
    CONTINUE_WITH_GOOGLE: "continueWithGoogle",
    CONTINUE_WITH_MICROSOFT: "continueWithMicrosoft",
    CONTINUE_WITH_GITHUB: "continueWithGithub",
    CONTINUE_WITH_FACEBOOK: "continueWithFacebook",
    HOMEPAGE_HERO_TITLE: "homepageHeroTitle",
    HOMEPAGE_HERO_SUBTITLE: "homepageHeroSubtitle",
    HOMEPAGE_HERO_PRIMARY_CTA: "homepageHeroPrimaryCta",
    HOMEPAGE_HERO_SECONDARY_CTA: "homepageHeroSecondaryCta",
    HOMEPAGE_SEARCH_DATE_START_PLACEHOLDER: "homepageSearchDateStartPlaceholder",
    HOMEPAGE_SEARCH_DATE_END_PLACEHOLDER: "homepageSearchDateEndPlaceholder",
    HOMEPAGE_SEARCH_AVAILABILITY_NOW: "homepageSearchAvailabilityNow",
    HOMEPAGE_SEARCH_AVAILABILITY_PLUS_2H: "homepageSearchAvailabilityPlus2h",
    HOMEPAGE_SEARCH_AVAILABILITY_PLUS_3H: "homepageSearchAvailabilityPlus3h",
    HOMEPAGE_SEARCH_AVAILABILITY_CUSTOM: "homepageSearchAvailabilityCustom",
    HOMEPAGE_SEARCH_AVAILABILITY_CUSTOM_PLACEHOLDER: "homepageSearchAvailabilityCustomPlaceholder",
    HOMEPAGE_SEARCH_AVAILABILITY_CLEAR: "homepageSearchAvailabilityClear",
    HOMEPAGE_SEARCH_LABEL_WHERE: "homepageSearchLabelWhere",
    HOMEPAGE_SEARCH_LABEL_WHEN: "homepageSearchLabelWhen",
    HOMEPAGE_SEARCH_WHEN_PLACEHOLDER: "homepageSearchWhenPlaceholder",
    HOMEPAGE_SEARCH_WHEN_CONFIRM_BUTTON: "homepageSearchWhenConfirmButton",
    HOMEPAGE_SEARCH_LABEL_MODE: "homepageSearchLabelMode",
    HOMEPAGE_SEARCH_LABEL_CATEGORY: "homepageSearchLabelCategory",
    HOMEPAGE_SEARCH_CATEGORY_PLACEHOLDER: "homepageSearchCategoryPlaceholder",
    HOMEPAGE_SEARCH_CATEGORY_EMPTY: "homepageSearchCategoryEmpty",
    HOMEPAGE_SEARCH_BUTTON: "homepageSearchButton",
    HOMEPAGE_SEARCH_SUMMARY_PLACEHOLDER: "homepageSearchSummaryPlaceholder",
    HOMEPAGE_SEARCH_OVERLAY_CLOSE: "homepageSearchOverlayClose",
    HOMEPAGE_SEARCH_NEAR_ME_LABEL: "homepageSearchNearMeLabel",
    HOMEPAGE_SEARCH_NEAR_ME_UNSUPPORTED: "homepageSearchNearMeUnsupported",
    HOMEPAGE_SEARCH_NEAR_ME_DENIED: "homepageSearchNearMeDenied",
    HOMEPAGE_DISCOVERY_FEATURED_TITLE: "homepageDiscoveryFeaturedTitle",
    HOMEPAGE_DISCOVERY_TOP_RATED_TITLE: "homepageDiscoveryTopRatedTitle",
    HOMEPAGE_DISCOVERY_NEAR_YOU_TITLE: "homepageDiscoveryNearYouTitle",
    HOMEPAGE_FEATURE_AUTH_TITLE: "homepageFeatureAuthTitle",
    HOMEPAGE_FEATURE_AUTH_DESCRIPTION: "homepageFeatureAuthDescription",
    HOMEPAGE_FEATURE_OAUTH_TITLE: "homepageFeatureOAuthTitle",
    HOMEPAGE_FEATURE_OAUTH_DESCRIPTION: "homepageFeatureOAuthDescription",
    HOMEPAGE_FEATURE_PAYMENTS_TITLE: "homepageFeaturePaymentsTitle",
    HOMEPAGE_FEATURE_PAYMENTS_DESCRIPTION: "homepageFeaturePaymentsDescription",

    HOMEPAGE_HOW_IT_WORKS_TITLE: "homepageHowItWorksTitle",
    HOMEPAGE_HOW_IT_WORKS_STEP1_TITLE: "homepageHowItWorksStep1Title",
    HOMEPAGE_HOW_IT_WORKS_STEP1_DESCRIPTION: "homepageHowItWorksStep1Description",
    HOMEPAGE_HOW_IT_WORKS_STEP2_TITLE: "homepageHowItWorksStep2Title",
    HOMEPAGE_HOW_IT_WORKS_STEP2_DESCRIPTION: "homepageHowItWorksStep2Description",
    HOMEPAGE_HOW_IT_WORKS_STEP3_TITLE: "homepageHowItWorksStep3Title",
    HOMEPAGE_HOW_IT_WORKS_STEP3_DESCRIPTION: "homepageHowItWorksStep3Description",

    HOMEPAGE_FAQ_TITLE: "homepageFaqTitle",
    HOMEPAGE_FAQ_Q1: "homepageFaqQ1",
    HOMEPAGE_FAQ_A1: "homepageFaqA1",
    HOMEPAGE_FAQ_Q2: "homepageFaqQ2",
    HOMEPAGE_FAQ_A2: "homepageFaqA2",
    HOMEPAGE_FAQ_Q3: "homepageFaqQ3",
    HOMEPAGE_FAQ_A3: "homepageFaqA3",
    HOMEPAGE_FAQ_Q4: "homepageFaqQ4",
    HOMEPAGE_FAQ_A4: "homepageFaqA4",
    HOMEPAGE_FAQ_Q5: "homepageFaqQ5",
    HOMEPAGE_FAQ_A5: "homepageFaqA5",
    HOMEPAGE_FAQ_Q6: "homepageFaqQ6",
    HOMEPAGE_FAQ_A6: "homepageFaqA6",

    HOMEPAGE_FINAL_CTA_TITLE: "homepageFinalCtaTitle",
    HOMEPAGE_FINAL_CTA_SUBTITLE: "homepageFinalCtaSubtitle",
    HOMEPAGE_FINAL_CTA_BUTTON: "homepageFinalCtaButton",



    USER_NAME_MESSAGE:"userNameMessage",
    COUNTRY_MESSAGE: "countryMessage",
    COUNTRY_SELECT_MESSAGE: "countrySelectMessage",
    PASSWORD_MESSAGE: "passwordMessage",
    CONFIRM_PASSWORD_MESSAGE: "confirmPasswordMessage",
    EMAIL_MESSAGE: "emailMessage",
    REGISTER_MESSAGE: "registerMessage",
    PASSWORDS_NOT_MATCH_MESSAGE: "passwordsNotMatchMessage",

    // ===== HEAVY_DUTY_MACHINERY SPACE (publish/edit form) =====
    HEAVY_DUTY_MACHINERY_SPACE_NEW_TITLE: "heavyDutyMachinerySpaceNewTitle",
    HEAVY_DUTY_MACHINERY_SPACE_EDIT_TITLE: "heavyDutyMachinerySpaceEditTitle",
    HEAVY_DUTY_MACHINERY_SPACE_TITLE_LABEL: "heavyDutyMachinerySpaceTitleLabel",
    HEAVY_DUTY_MACHINERY_SPACE_DESCRIPTION_LABEL: "heavyDutyMachinerySpaceDescriptionLabel",
    HEAVY_DUTY_MACHINERY_SPACE_DESCRIPTION_PLACEHOLDER: "heavyDutyMachinerySpaceDescriptionPlaceholder",
    HEAVY_DUTY_MACHINERY_SPACE_LOCATION_LABEL: "heavyDutyMachinerySpaceLocationLabel",
    HEAVY_DUTY_MACHINERY_SPACE_LOCATION_PLACEHOLDER: "heavyDutyMachinerySpaceLocationPlaceholder",
    HEAVY_DUTY_MACHINERY_SPACE_HOST_CURRENCY_LABEL: "heavyDutyMachinerySpaceHostCurrencyLabel",
    HEAVY_DUTY_MACHINERY_SPACE_HOST_CURRENCY_PLACEHOLDER: "heavyDutyMachinerySpaceHostCurrencyPlaceholder",
    HEAVY_DUTY_MACHINERY_SPACE_HOST_CURRENCY_HELP: "heavyDutyMachinerySpaceHostCurrencyHelp",
    HEAVY_DUTY_MACHINERY_SPACE_LOCATION_NOT_SELECTED: "heavyDutyMachinerySpaceLocationNotSelected",
    HEAVY_DUTY_MACHINERY_SPACE_COUNTRY_LABEL: "heavyDutyMachinerySpaceCountryLabel",
    HEAVY_DUTY_MACHINERY_SPACE_PRIVATE_ADDRESS_LABEL: "heavyDutyMachinerySpacePrivateAddressLabel",
    HEAVY_DUTY_MACHINERY_SPACE_PRIVATE_ADDRESS_HELP: "heavyDutyMachinerySpacePrivateAddressHelp",
    HEAVY_DUTY_MACHINERY_SPACE_CATEGORY_LABEL: "heavyDutyMachinerySpaceCategoryLabel",
    HEAVY_DUTY_MACHINERY_SPACE_WEIGHT_TONS_LABEL: "heavyDutyMachinerySpaceWeightTonsLabel",
    HEAVY_DUTY_MACHINERY_SPACE_POWER_HP_LABEL: "heavyDutyMachinerySpacePowerHpLabel",
    HEAVY_DUTY_MACHINERY_SPACE_REACH_METERS_LABEL: "heavyDutyMachinerySpaceReachMetersLabel",
    HEAVY_DUTY_MACHINERY_SPACE_MANUFACTURER_BRAND_LABEL: "heavyDutyMachinerySpaceManufacturerBrandLabel",
    HEAVY_DUTY_MACHINERY_SPACE_MODEL_NAME_LABEL: "heavyDutyMachinerySpaceModelNameLabel",
    HEAVY_DUTY_MACHINERY_SPACE_YEAR_MANUFACTURED_LABEL: "heavyDutyMachinerySpaceYearManufacturedLabel",
    HEAVY_DUTY_MACHINERY_SPACE_ENGINE_HOURS_LABEL: "heavyDutyMachinerySpaceEngineHoursLabel",
    HEAVY_DUTY_MACHINERY_SPACE_OVERTIME_HOUR_RATE_LABEL: "heavyDutyMachinerySpaceOvertimeHourRateLabel",
    HEAVY_DUTY_MACHINERY_SPACE_DEPOSIT_AMOUNT_LABEL: "heavyDutyMachinerySpaceDepositAmountLabel",
    HEAVY_DUTY_MACHINERY_SPACE_RENTAL_AVAILABILITY_LABEL: "heavyDutyMachinerySpaceRentalAvailabilityLabel",
    HEAVY_DUTY_MACHINERY_SPACE_PRICE_PER_KM_DELIVERY_LABEL: "heavyDutyMachinerySpacePricePerKmDeliveryLabel",
    HEAVY_DUTY_MACHINERY_SPACE_FIXED_DISPATCH_FEE_LABEL: "heavyDutyMachinerySpaceFixedDispatchFeeLabel",
    HEAVY_DUTY_MACHINERY_SPACE_MAX_DELIVERY_RADIUS_KM_LABEL: "heavyDutyMachinerySpaceMaxDeliveryRadiusKmLabel",
    HEAVY_DUTY_MACHINERY_SPACE_MIN_RENTAL_DAYS_FOR_DELIVERY_LABEL: "heavyDutyMachinerySpaceMinRentalDaysForDeliveryLabel",
    HEAVY_DUTY_MACHINERY_SPACE_RESTRICT_DELIVERY_TO_SAME_COUNTRY_LABEL: "heavyDutyMachinerySpaceRestrictDeliveryToSameCountryLabel",
    HEAVY_DUTY_MACHINERY_SPACE_RESTRICT_DELIVERY_TO_SAME_COUNTRY_HELP: "heavyDutyMachinerySpaceRestrictDeliveryToSameCountryHelp",
    HEAVY_DUTY_MACHINERY_SPACE_DEFERRED_BOOKING_LABEL: "heavyDutyMachinerySpaceDeferredBookingLabel",
    HEAVY_DUTY_MACHINERY_SPACE_DEFERRED_BOOKING_HELP: "heavyDutyMachinerySpaceDeferredBookingHelp",
    HEAVY_DUTY_MACHINERY_SPACE_CHARGE_STAFF_TIME_FOR_DELIVERY_LABEL: "heavyDutyMachinerySpaceChargeStaffTimeForDeliveryLabel",
    HEAVY_DUTY_MACHINERY_SPACE_CHARGE_STAFF_TIME_FOR_DELIVERY_HELP: "heavyDutyMachinerySpaceChargeStaffTimeForDeliveryHelp",
    HEAVY_DUTY_MACHINERY_SPACE_DELIVERY_VEHICLE_LABEL: "heavyDutyMachinerySpaceDeliveryVehicleLabel",
    HEAVY_DUTY_MACHINERY_SPACE_DELIVERY_VEHICLE_HELP: "heavyDutyMachinerySpaceDeliveryVehicleHelp",
    HEAVY_DUTY_MACHINERY_SPACE_ACCESS_TYPE_LABEL: "heavyDutyMachinerySpaceAccessTypeLabel",
    HEAVY_DUTY_MACHINERY_SPACE_RENTAL_MODE_LABEL: "heavyDutyMachinerySpaceRentalModeLabel",
    HEAVY_DUTY_MACHINERY_SPACE_PRICE_PER_HOUR_LABEL: "heavyDutyMachinerySpacePricePerHourLabel",
    HEAVY_DUTY_MACHINERY_SPACE_PRICE_PER_NIGHT_LABEL: "heavyDutyMachinerySpacePricePerNightLabel",
    HEAVY_DUTY_MACHINERY_SPACE_MAX_OPERATORS_LABEL: "heavyDutyMachinerySpaceMaxOperatorsLabel",
    HEAVY_DUTY_MACHINERY_SPACE_MAX_OPERATORS_HELP: "heavyDutyMachinerySpaceMaxOperatorsHelp",
    HEAVY_DUTY_MACHINERY_OPERATOR_ASSIGNMENT_LABEL: "heavyDutyMachineryOperatorAssignmentLabel",
    HEAVY_DUTY_MACHINERY_OPERATOR_ASSIGNMENT_HELP: "heavyDutyMachineryOperatorAssignmentHelp",
    HEAVY_DUTY_MACHINERY_OPERATOR_ASSIGNMENT_QUALIFIED_BADGE: "heavyDutyMachineryOperatorAssignmentQualifiedBadge",
    HEAVY_DUTY_MACHINERY_OPERATOR_ASSIGNMENT_EMPTY_TITLE: "heavyDutyMachineryOperatorAssignmentEmptyTitle",
    HEAVY_DUTY_MACHINERY_OPERATOR_ASSIGNMENT_EMPTY_DESCRIPTION: "heavyDutyMachineryOperatorAssignmentEmptyDescription",
    HEAVY_DUTY_MACHINERY_OPERATOR_ASSIGNMENT_EMPTY_CTA: "heavyDutyMachineryOperatorAssignmentEmptyCta",
    HEAVY_DUTY_MACHINERY_SPACE_PARKING_LABEL: "heavyDutyMachinerySpaceParkingLabel",
    HEAVY_DUTY_MACHINERY_SPACE_PHOTOS_LABEL: "heavyDutyMachinerySpacePhotosLabel",
    HEAVY_DUTY_MACHINERY_SPACE_VIDEOS_LABEL: "heavyDutyMachinerySpaceVideosLabel",
    HEAVY_DUTY_MACHINERY_SPACE_PUBLISH_BUTTON: "heavyDutyMachinerySpacePublishButton",
    HEAVY_DUTY_MACHINERY_SPACE_SAVE_CHANGES_BUTTON: "heavyDutyMachinerySpaceSaveChangesButton",
    HEAVY_DUTY_MACHINERY_SPACE_SAVED_MESSAGE: "heavyDutyMachinerySpaceSavedMessage",
    HEAVY_DUTY_MACHINERY_SPACE_PUBLISHED_MESSAGE: "heavyDutyMachinerySpacePublishedMessage",
    HEAVY_DUTY_MACHINERY_SPACE_NOT_FOUND: "heavyDutyMachinerySpaceNotFound",
    HEAVY_DUTY_MACHINERY_SPACE_NOT_FOUND_DESCRIPTION: "heavyDutyMachinerySpaceNotFoundDescription",
    HEAVY_DUTY_MACHINERY_SPACE_SAVE_ERROR: "heavyDutyMachinerySpaceSaveError",
    HEAVY_DUTY_MACHINERY_SPACE_PRICE_UNIT_NIGHT: "heavyDutyMachinerySpacePriceUnitNight",
    HEAVY_DUTY_MACHINERY_SPACE_PRICE_UNIT_HOUR: "heavyDutyMachinerySpacePriceUnitHour",
    HEAVY_DUTY_MACHINERY_SPACE_PRICE_UNIT_DAY_PASS: "heavyDutyMachinerySpacePriceUnitDayPass",
    HEAVY_DUTY_MACHINERY_SPACE_CARD_NEW_BADGE: "heavyDutyMachinerySpaceCardNewBadge",
    HEAVY_DUTY_MACHINERY_SPACE_CARD_WET_HIRE_BADGE: "heavyDutyMachinerySpaceCardWetHireBadge",
    HEAVY_DUTY_MACHINERY_SPACE_CARD_FAVORITE_LABEL: "heavyDutyMachinerySpaceCardFavoriteLabel",
    HEAVY_DUTY_MACHINERY_SPACE_CARD_AVAILABLE_LABEL: "heavyDutyMachinerySpaceCardAvailableLabel",
    HEAVY_DUTY_MACHINERY_SPACE_CARD_AVAILABLE_FROM_LABEL: "heavyDutyMachinerySpaceCardAvailableFromLabel",
    HEAVY_DUTY_MACHINERY_SPACE_LOCATION_SUMMARY_LABEL: "heavyDutyMachinerySpaceLocationSummaryLabel",
    HEAVY_DUTY_MACHINERY_SPACE_TEMPERATURE_RANGE_LABEL: "heavyDutyMachinerySpaceTemperatureRangeLabel",
    HEAVY_DUTY_MACHINERY_SPACE_PRICE_LABEL: "heavyDutyMachinerySpacePriceLabel",
    HEAVY_DUTY_MACHINERY_SPACE_EXACT_ADDRESS_LABEL: "heavyDutyMachinerySpaceExactAddressLabel",
    HEAVY_DUTY_MACHINERY_SPACE_RESERVE_BUTTON: "heavyDutyMachinerySpaceReserveButton",
    HEAVY_DUTY_MACHINERY_SPACE_RESERVE_NOW_BUTTON: "heavyDutyMachinerySpaceReserveNowButton",
    HEAVY_DUTY_MACHINERY_SPACE_CARD_EDIT_BUTTON: "heavyDutyMachinerySpaceCardEditButton",
    HEAVY_DUTY_MACHINERY_SPACE_CARD_DELETE_BUTTON: "heavyDutyMachinerySpaceCardDeleteButton",
    HEAVY_DUTY_MACHINERY_SPACE_CARD_DELETE_CONFIRM_TITLE: "heavyDutyMachinerySpaceCardDeleteConfirmTitle",
    HEAVY_DUTY_MACHINERY_SPACE_CARD_DELETE_SHEET_KEEP: "heavyDutyMachinerySpaceCardDeleteSheetKeep",
    HEAVY_DUTY_MACHINERY_SPACE_CARD_DELETE_SHEET_CONFIRM: "heavyDutyMachinerySpaceCardDeleteSheetConfirm",
    LOCATION_LEVEL_COUNTRY: "locationLevelCountry",
    LOCATION_LEVEL_REGION: "locationLevelRegion",
    LOCATION_LEVEL_PROVINCE: "locationLevelProvince",
    LOCATION_LEVEL_CITY_TOWN: "locationLevelCityTown",
    LOCATION_LEVEL_DISTRICT: "locationLevelDistrict",
    LOCATION_LEVEL_NEIGHBOURHOOD: "locationLevelNeighbourhood",
    LOCATION_LEVEL_POSTAL_CODE_AREA: "locationLevelPostalCodeArea",
    HEAVY_DUTY_MACHINERY_FIELD_REQUIRED: "heavyDutyMachineryFieldRequired",

    HEAVY_DUTY_MACHINERY_SPACE_SECTION_BASICS: "heavyDutyMachinerySpaceSectionBasics",
    HEAVY_DUTY_MACHINERY_SPACE_SECTION_LOCATION: "heavyDutyMachinerySpaceSectionLocation",
    HEAVY_DUTY_MACHINERY_SPACE_SECTION_WATER: "heavyDutyMachinerySpaceSectionWater",
    HEAVY_DUTY_MACHINERY_SPACE_SECTION_AMBIANCE: "heavyDutyMachinerySpaceSectionAmbiance",
    HEAVY_DUTY_MACHINERY_SPACE_SECTION_AMENITIES: "heavyDutyMachinerySpaceSectionAmenities",
    HEAVY_DUTY_MACHINERY_SPACE_SECTION_ACCESS_PRICING: "heavyDutyMachinerySpaceSectionAccessPricing",
    HEAVY_DUTY_MACHINERY_SPACE_SECTION_RULES: "heavyDutyMachinerySpaceSectionRules",
    HEAVY_DUTY_MACHINERY_SPACE_SECTION_MEDIA: "heavyDutyMachinerySpaceSectionMedia",

    // ===== HEAVY_DUTY_MACHINERY SPACE enum/checklist option labels =====
    HEAVY_DUTY_MACHINERY_OPT_CATEGORY_EXCAVATOR: "heavyDutyMachineryOptCategoryExcavator",
    HEAVY_DUTY_MACHINERY_OPT_CATEGORY_SCISSOR_LIFT: "heavyDutyMachineryOptCategoryScissorLift",
    HEAVY_DUTY_MACHINERY_OPT_CATEGORY_SKID_STEER_LOADER: "heavyDutyMachineryOptCategorySkidSteerLoader",
    HEAVY_DUTY_MACHINERY_OPT_CATEGORY_DUMPER: "heavyDutyMachineryOptCategoryDumper",
    HEAVY_DUTY_MACHINERY_OPT_CATEGORY_TELEHANDLER: "heavyDutyMachineryOptCategoryTelehandler",
    HEAVY_DUTY_MACHINERY_OPT_CATEGORY_DOZER: "heavyDutyMachineryOptCategoryDozer",
    HEAVY_DUTY_MACHINERY_OPT_CATEGORY_WHEEL_LOADER: "heavyDutyMachineryOptCategoryWheelLoader",
    HEAVY_DUTY_MACHINERY_OPT_CATEGORY_TUNNEL_BORING_MACHINE: "heavyDutyMachineryOptCategoryTunnelBoringMachine",
    HEAVY_DUTY_MACHINERY_OPT_CATEGORY_CRANE: "heavyDutyMachineryOptCategoryCrane",
    HEAVY_DUTY_MACHINERY_OPT_CATEGORY_OTHER: "heavyDutyMachineryOptCategoryOther",

    HEAVY_DUTY_MACHINERY_OPT_HIRE_DRY: "heavyDutyMachineryOptHireDry",
    HEAVY_DUTY_MACHINERY_OPT_HIRE_WET_HOST: "heavyDutyMachineryOptHireWetHost",
    HEAVY_DUTY_MACHINERY_OPT_HIRE_WET_THIRD_PARTY: "heavyDutyMachineryOptHireWetThirdParty",
    HEAVY_DUTY_MACHINERY_OPT_HIRE_DELIVERY: "heavyDutyMachineryOptHireDelivery",

    HEAVY_DUTY_MACHINERY_OPT_ACCESS_SELF_CHECKIN: "heavyDutyMachineryOptAccessSelfCheckin",
    HEAVY_DUTY_MACHINERY_OPT_ACCESS_HOST_GREETS: "heavyDutyMachineryOptAccessHostGreets",
    HEAVY_DUTY_MACHINERY_OPT_ACCESS_HOST_PRESENT_THROUGHOUT: "heavyDutyMachineryOptAccessHostPresentThroughout",
    HEAVY_DUTY_MACHINERY_OPT_ACCESS_ONSITE_STAFF: "heavyDutyMachineryOptAccessOnsiteStaff",

    HEAVY_DUTY_MACHINERY_OPT_RENTAL_HOURLY: "heavyDutyMachineryOptRentalHourly",
    HEAVY_DUTY_MACHINERY_OPT_RENTAL_OVERNIGHT: "heavyDutyMachineryOptRentalOvernight",
    HEAVY_DUTY_MACHINERY_OPT_RENTAL_BOTH: "heavyDutyMachineryOptRentalBoth",
    HEAVY_DUTY_MACHINERY_OPT_RENTAL_DAY_PASS: "heavyDutyMachineryOptRentalDayPass",

    HEAVY_DUTY_MACHINERY_OPT_PARKING_ONSITE_PRIVATE: "heavyDutyMachineryOptParkingOnsitePrivate",
    HEAVY_DUTY_MACHINERY_OPT_PARKING_ONSITE_DRIVE_IN: "heavyDutyMachineryOptParkingOnsiteDriveIn",
    HEAVY_DUTY_MACHINERY_OPT_PARKING_NEARBY_STREET: "heavyDutyMachineryOptParkingNearbyStreet",
    HEAVY_DUTY_MACHINERY_OPT_PARKING_NEARBY_PAID: "heavyDutyMachineryOptParkingNearbyPaid",
    HEAVY_DUTY_MACHINERY_OPT_PARKING_NONE: "heavyDutyMachineryOptParkingNone",

    HEAVY_DUTY_MACHINERY_OPT_CANCELLATION_FLEXIBLE: "heavyDutyMachineryOptCancellationFlexible",
    HEAVY_DUTY_MACHINERY_OPT_CANCELLATION_MODERATE: "heavyDutyMachineryOptCancellationModerate",
    HEAVY_DUTY_MACHINERY_OPT_CANCELLATION_STRICT: "heavyDutyMachineryOptCancellationStrict",

    HEAVY_DUTY_MACHINERY_OPT_TIMEZONE_MADRID: "heavyDutyMachineryOptTimezoneMadrid",
    HEAVY_DUTY_MACHINERY_OPT_TIMEZONE_CANARY: "heavyDutyMachineryOptTimezoneCanary",
    HEAVY_DUTY_MACHINERY_OPT_TIMEZONE_LISBON: "heavyDutyMachineryOptTimezoneLisbon",
    HEAVY_DUTY_MACHINERY_OPT_TIMEZONE_LONDON: "heavyDutyMachineryOptTimezoneLondon",
    HEAVY_DUTY_MACHINERY_OPT_TIMEZONE_PARIS: "heavyDutyMachineryOptTimezoneParis",
    HEAVY_DUTY_MACHINERY_OPT_TIMEZONE_BERLIN: "heavyDutyMachineryOptTimezoneBerlin",
    HEAVY_DUTY_MACHINERY_OPT_TIMEZONE_ROME: "heavyDutyMachineryOptTimezoneRome",
    HEAVY_DUTY_MACHINERY_OPT_TIMEZONE_MEXICO_CITY: "heavyDutyMachineryOptTimezoneMexicoCity",
    HEAVY_DUTY_MACHINERY_OPT_TIMEZONE_BOGOTA: "heavyDutyMachineryOptTimezoneBogota",
    HEAVY_DUTY_MACHINERY_OPT_TIMEZONE_BUENOS_AIRES: "heavyDutyMachineryOptTimezoneBuenosAires",
    HEAVY_DUTY_MACHINERY_OPT_TIMEZONE_SANTIAGO: "heavyDutyMachineryOptTimezoneSantiago",

    HEAVY_DUTY_MACHINERY_SPACE_SECTION_BOOKING_RULES: "heavyDutyMachinerySpaceSectionBookingRules",
    HEAVY_DUTY_MACHINERY_SPACE_DAILY_SCHEDULE_GROUP_LABEL: "heavyDutyMachinerySpaceDailyScheduleGroupLabel",
    HEAVY_DUTY_MACHINERY_SPACE_HOURLY_SCHEDULE_GROUP_LABEL: "heavyDutyMachinerySpaceHourlyScheduleGroupLabel",
    HEAVY_DUTY_MACHINERY_SPACE_BUFFER_MINUTES_LABEL: "heavyDutyMachinerySpaceBufferMinutesLabel",
    HEAVY_DUTY_MACHINERY_SPACE_MIN_ADVANCE_BOOKING_HOURS_LABEL: "heavyDutyMachinerySpaceMinAdvanceBookingHoursLabel",
    HEAVY_DUTY_MACHINERY_SPACE_MAX_ADVANCE_BOOKING_DAYS_LABEL: "heavyDutyMachinerySpaceMaxAdvanceBookingDaysLabel",
    HEAVY_DUTY_MACHINERY_SPACE_MIN_BOOKING_DURATION_LABEL: "heavyDutyMachinerySpaceMinBookingDurationLabel",
    HEAVY_DUTY_MACHINERY_SPACE_MAX_BOOKING_DURATION_LABEL: "heavyDutyMachinerySpaceMaxBookingDurationLabel",
    HEAVY_DUTY_MACHINERY_SPACE_SLOT_GRANULARITY_LABEL: "heavyDutyMachinerySpaceSlotGranularityLabel",
    HEAVY_DUTY_MACHINERY_SPACE_CANCELLATION_POLICY_LABEL: "heavyDutyMachinerySpaceCancellationPolicyLabel",
    HEAVY_DUTY_MACHINERY_SPACE_CANCELLATION_FREE_UNTIL: "heavyDutyMachinerySpaceCancellationFreeUntil",
    HEAVY_DUTY_MACHINERY_SPACE_CANCELLATION_BEFORE_BOOKING_SUFFIX: "heavyDutyMachinerySpaceCancellationBeforeBookingSuffix",
    HEAVY_DUTY_MACHINERY_SPACE_CANCELLATION_NON_REFUNDABLE: "heavyDutyMachinerySpaceCancellationNonRefundable",
    HEAVY_DUTY_MACHINERY_SPACE_TIMEZONE_LABEL: "heavyDutyMachinerySpaceTimezoneLabel",
    HEAVY_DUTY_MACHINERY_SPACE_WELCOME_MESSAGE_LABEL: "heavyDutyMachinerySpaceWelcomeMessageLabel",
    HEAVY_DUTY_MACHINERY_SPACE_WELCOME_MESSAGE_HELP: "heavyDutyMachinerySpaceWelcomeMessageHelp",
    HEAVY_DUTY_MACHINERY_SPACE_WELCOME_MESSAGE_PLACEHOLDER: "heavyDutyMachinerySpaceWelcomeMessagePlaceholder",

    HEAVY_DUTY_MACHINERY_MANAGE_AVAILABILITY_BUTTON: "heavyDutyMachineryManageAvailabilityButton",
    HEAVY_DUTY_MACHINERY_AVAILABILITY_TITLE: "heavyDutyMachineryAvailabilityTitle",
    HEAVY_DUTY_MACHINERY_TAB_WEEKLY_SCHEDULE: "heavyDutyMachineryTabWeeklySchedule",
    HEAVY_DUTY_MACHINERY_TAB_CALENDAR: "heavyDutyMachineryTabCalendar",

    HEAVY_DUTY_MACHINERY_DAY_SUNDAY: "heavyDutyMachineryDaySunday",
    HEAVY_DUTY_MACHINERY_DAY_MONDAY: "heavyDutyMachineryDayMonday",
    HEAVY_DUTY_MACHINERY_DAY_TUESDAY: "heavyDutyMachineryDayTuesday",
    HEAVY_DUTY_MACHINERY_DAY_WEDNESDAY: "heavyDutyMachineryDayWednesday",
    HEAVY_DUTY_MACHINERY_DAY_THURSDAY: "heavyDutyMachineryDayThursday",
    HEAVY_DUTY_MACHINERY_DAY_FRIDAY: "heavyDutyMachineryDayFriday",
    HEAVY_DUTY_MACHINERY_DAY_SATURDAY: "heavyDutyMachineryDaySaturday",

    HEAVY_DUTY_MACHINERY_SCHEDULE_CLOSED_LABEL: "heavyDutyMachineryScheduleClosedLabel",
    HEAVY_DUTY_MACHINERY_SCHEDULE_24H_LABEL: "heavyDutyMachinerySchedule24hLabel",
    HEAVY_DUTY_MACHINERY_SCHEDULE_ADD_SLOT: "heavyDutyMachineryScheduleAddSlot",
    HEAVY_DUTY_MACHINERY_SCHEDULE_SAVE: "heavyDutyMachineryScheduleSave",
    HEAVY_DUTY_MACHINERY_SCHEDULE_SAVED: "heavyDutyMachineryScheduleSaved",
    HEAVY_DUTY_MACHINERY_SCHEDULE_SAVE_ERROR: "heavyDutyMachineryScheduleSaveError",

    HEAVY_DUTY_MACHINERY_AVAILABILITY_LOAD_ERROR: "heavyDutyMachineryAvailabilityLoadError",
    HEAVY_DUTY_MACHINERY_SPACE_LOAD_ERROR: "heavyDutyMachinerySpaceLoadError",

    HEAVY_DUTY_MACHINERY_EXCEPTION_TYPE_LABEL: "heavyDutyMachineryExceptionTypeLabel",
    HEAVY_DUTY_MACHINERY_EXCEPTION_TYPE_FULLY_BLOCKED: "heavyDutyMachineryExceptionTypeFullyBlocked",
    HEAVY_DUTY_MACHINERY_EXCEPTION_TYPE_CUSTOM_HOURS: "heavyDutyMachineryExceptionTypeCustomHours",
    HEAVY_DUTY_MACHINERY_EXCEPTION_TYPE_EXTRA_AVAILABILITY: "heavyDutyMachineryExceptionTypeExtraAvailability",
    HEAVY_DUTY_MACHINERY_EXCEPTION_REASON_LABEL: "heavyDutyMachineryExceptionReasonLabel",
    HEAVY_DUTY_MACHINERY_EXCEPTION_SLOTS_LABEL: "heavyDutyMachineryExceptionSlotsLabel",
    HEAVY_DUTY_MACHINERY_EXCEPTION_SAVE: "heavyDutyMachineryExceptionSave",
    HEAVY_DUTY_MACHINERY_EXCEPTION_SAVED: "heavyDutyMachineryExceptionSaved",
    HEAVY_DUTY_MACHINERY_EXCEPTION_SAVE_ERROR: "heavyDutyMachineryExceptionSaveError",
    HEAVY_DUTY_MACHINERY_EXCEPTION_DELETE: "heavyDutyMachineryExceptionDelete",
    HEAVY_DUTY_MACHINERY_EXCEPTION_DELETE_CONFIRM: "heavyDutyMachineryExceptionDeleteConfirm",
    HEAVY_DUTY_MACHINERY_EXCEPTION_DELETED: "heavyDutyMachineryExceptionDeleted",
    HEAVY_DUTY_MACHINERY_EXCEPTION_DELETE_ERROR: "heavyDutyMachineryExceptionDeleteError",

    HEAVY_DUTY_MACHINERY_BOOKING_SECTION_TITLE: "heavyDutyMachineryBookingSectionTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_STEP_DATES_TITLE: "heavyDutyMachineryBookingStepDatesTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_STEP_MODE_TITLE: "heavyDutyMachineryBookingStepModeTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_STEP_DELIVERY_TITLE: "heavyDutyMachineryBookingStepDeliveryTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_STEP_INSURANCE_TITLE: "heavyDutyMachineryBookingStepInsuranceTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_STEP_ACCESSORIES_TITLE: "heavyDutyMachineryBookingStepAccessoriesTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_STEP_REVIEW_TITLE: "heavyDutyMachineryBookingStepReviewTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_STEP_REVIEW_DESCRIPTION: "heavyDutyMachineryBookingStepReviewDescription",
    HEAVY_DUTY_MACHINERY_BOOKING_STEP_REVIEW_DESCRIPTION_QUOTE: "heavyDutyMachineryBookingStepReviewDescriptionQuote",
    HEAVY_DUTY_MACHINERY_BOOKING_STEP_INDICATOR: "heavyDutyMachineryBookingStepIndicator",
    HEAVY_DUTY_MACHINERY_BOOKING_STEP_BACK: "heavyDutyMachineryBookingStepBack",
    HEAVY_DUTY_MACHINERY_BOOKING_STEP_NEXT: "heavyDutyMachineryBookingStepNext",
    HEAVY_DUTY_MACHINERY_BOOKING_SUMMARY_PICK_DATES_HINT: "heavyDutyMachineryBookingSummaryPickDatesHint",
    HEAVY_DUTY_MACHINERY_BOOKING_SUMMARY_ESTIMATE_NOTICE: "heavyDutyMachineryBookingSummaryEstimateNotice",
    HEAVY_DUTY_MACHINERY_BOOKING_SUMMARY_VIEW_BREAKDOWN: "heavyDutyMachineryBookingSummaryViewBreakdown",
    HEAVY_DUTY_MACHINERY_BOOKING_SUMMARY_SHEET_TITLE: "heavyDutyMachineryBookingSummarySheetTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_DATE_LABEL: "heavyDutyMachineryBookingDateLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_LOADING_SLOTS: "heavyDutyMachineryBookingLoadingSlots",
    HEAVY_DUTY_MACHINERY_BOOKING_NO_SLOTS: "heavyDutyMachineryBookingNoSlots",
    HEAVY_DUTY_MACHINERY_BOOKING_NO_SLOTS_DESCRIPTION: "heavyDutyMachineryBookingNoSlotsDescription",
    HEAVY_DUTY_MACHINERY_BOOKING_SELECT_WINDOW_LABEL: "heavyDutyMachineryBookingSelectWindowLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_START_LABEL: "heavyDutyMachineryBookingStartLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_DURATION_LABEL: "heavyDutyMachineryBookingDurationLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_DURATION_MINUTES_SUFFIX: "heavyDutyMachineryBookingDurationMinutesSuffix",
    HEAVY_DUTY_MACHINERY_BOOKING_DURATION_TOO_SHORT_ERROR: "heavyDutyMachineryBookingDurationTooShortError",
    HEAVY_DUTY_MACHINERY_BOOKING_DURATION_TOO_LONG_ERROR: "heavyDutyMachineryBookingDurationTooLongError",
    HEAVY_DUTY_MACHINERY_BOOKING_WAIVER_LABEL: "heavyDutyMachineryBookingWaiverLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_WAIVER_REQUIRED: "heavyDutyMachineryBookingWaiverRequired",
    HEAVY_DUTY_MACHINERY_BOOKING_LOGIN_REQUIRED: "heavyDutyMachineryBookingLoginRequired",
    HEAVY_DUTY_MACHINERY_BOOKING_SUBMIT: "heavyDutyMachineryBookingSubmit",
    HEAVY_DUTY_MACHINERY_BOOKING_SUBMIT_QUOTE: "heavyDutyMachineryBookingSubmitQuote",
    HEAVY_DUTY_MACHINERY_BOOKING_SUCCESS: "heavyDutyMachineryBookingSuccess",
    HEAVY_DUTY_MACHINERY_BOOKING_ERROR: "heavyDutyMachineryBookingError",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFLICT_ERROR: "heavyDutyMachineryBookingConflictError",
    HEAVY_DUTY_MACHINERY_BOOKING_MIXED_CURRENCY_ERROR: "heavyDutyMachineryBookingMixedCurrencyError",
    HEAVY_DUTY_MACHINERY_BOOKING_PRICE_LABEL: "heavyDutyMachineryBookingPriceLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_RENTAL_MODE_LABEL: "heavyDutyMachineryBookingRentalModeLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_PAYMENT_STEP_TITLE: "heavyDutyMachineryBookingPaymentStepTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_PAYMENT_SUMMARY_TITLE: "heavyDutyMachineryBookingPaymentSummaryTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_PAY_BUTTON: "heavyDutyMachineryBookingPayButton",
    HEAVY_DUTY_MACHINERY_BOOKING_PAYMENT_ERROR: "heavyDutyMachineryBookingPaymentError",
    HEAVY_DUTY_MACHINERY_BOOKING_OVERTIME_CHARGE_NOTICE: "heavyDutyMachineryBookingOvertimeChargeNotice",
    HEAVY_DUTY_MACHINERY_BOOKING_DEPOSIT_AMOUNT_LABEL: "heavyDutyMachineryBookingDepositAmountLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_DEPOSIT_NOTICE: "heavyDutyMachineryBookingDepositNotice",
    HEAVY_DUTY_MACHINERY_BOOKING_PRICE_HOST_CURRENCY_NOTICE: "heavyDutyMachineryBookingPriceHostCurrencyNotice",
    HEAVY_DUTY_MACHINERY_BOOKING_OPERATION_MODE_LABEL: "heavyDutyMachineryBookingOperationModeLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_OPERATOR_SELECT_LABEL: "heavyDutyMachineryBookingOperatorSelectLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_OPERATOR_RATE_SUFFIX: "heavyDutyMachineryBookingOperatorRateSuffix",
    HEAVY_DUTY_MACHINERY_BOOKING_OPERATOR_LOADING: "heavyDutyMachineryBookingOperatorLoading",
    HEAVY_DUTY_MACHINERY_BOOKING_OPERATOR_EMPTY_TITLE: "heavyDutyMachineryBookingOperatorEmptyTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_OPERATOR_EMPTY_DESCRIPTION: "heavyDutyMachineryBookingOperatorEmptyDescription",
    HEAVY_DUTY_MACHINERY_BOOKING_OPERATOR_UNAVAILABLE_LABEL: "heavyDutyMachineryBookingOperatorUnavailableLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_OPERATOR_AVAILABLE_FROM_LABEL: "heavyDutyMachineryBookingOperatorAvailableFromLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_BASE_PRICE_LABEL: "heavyDutyMachineryBookingBasePriceLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_OPERATOR_COST_LABEL: "heavyDutyMachineryBookingOperatorCostLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_MODE_LABEL: "heavyDutyMachineryBookingDeliveryModeLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_SELF_PICKUP_OPTION: "heavyDutyMachineryBookingSelfPickupOption",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_OPTION: "heavyDutyMachineryBookingDeliveryOption",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_LOCATION_LABEL: "heavyDutyMachineryBookingDeliveryLocationLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_LOCATION_HELP: "heavyDutyMachineryBookingDeliveryLocationHelp",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_LOCATION_REQUIRED: "heavyDutyMachineryBookingDeliveryLocationRequired",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_INSTRUCTIONS_LABEL: "heavyDutyMachineryBookingDeliveryInstructionsLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_INSTRUCTIONS_PLACEHOLDER: "heavyDutyMachineryBookingDeliveryInstructionsPlaceholder",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_PHOTOS_LABEL: "heavyDutyMachineryBookingDeliveryPhotosLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_VIDEO_LABEL: "heavyDutyMachineryBookingDeliveryVideoLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_VIDEO_HELP: "heavyDutyMachineryBookingDeliveryVideoHelp",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_COST_LABEL: "heavyDutyMachineryBookingDeliveryCostLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_COST_PENDING: "heavyDutyMachineryBookingDeliveryCostPending",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_COST_UNAVAILABLE: "heavyDutyMachineryBookingDeliveryCostUnavailable",
    HEAVY_DUTY_MACHINERY_BOOKING_RETURN_PICKUP_LABEL: "heavyDutyMachineryBookingReturnPickupLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_RETURN_PICKUP_HELP: "heavyDutyMachineryBookingReturnPickupHelp",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_DISTANCE_SUBLINE: "heavyDutyMachineryBookingDeliveryDistanceSubline",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_DISTANCE_SUBLINE_TWO_LEGS: "heavyDutyMachineryBookingDeliveryDistanceSublineTwoLegs",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_FIXED_FEE_SUBLINE: "heavyDutyMachineryBookingDeliveryFixedFeeSubline",
    HEAVY_DUTY_MACHINERY_BOOKING_DELIVERY_FIXED_FEE_SUBLINE_TWO_LEGS: "heavyDutyMachineryBookingDeliveryFixedFeeSublineTwoLegs",
    HEAVY_DUTY_MACHINERY_BOOKING_INSURANCE_MODE_LABEL: "heavyDutyMachineryBookingInsuranceModeLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_INSURANCE_NONE_OPTION: "heavyDutyMachineryBookingInsuranceNoneOption",
    HEAVY_DUTY_MACHINERY_BOOKING_INSURANCE_PLATFORM_OPTION: "heavyDutyMachineryBookingInsurancePlatformOption",
    HEAVY_DUTY_MACHINERY_BOOKING_INSURANCE_HOST_OPTION: "heavyDutyMachineryBookingInsuranceHostOption",
    HEAVY_DUTY_MACHINERY_BOOKING_INSURANCE_HELP: "heavyDutyMachineryBookingInsuranceHelp",
    HEAVY_DUTY_MACHINERY_BOOKING_INSURANCE_HOST_HELP: "heavyDutyMachineryBookingInsuranceHostHelp",
    HEAVY_DUTY_MACHINERY_BOOKING_INSURANCE_COST_LABEL: "heavyDutyMachineryBookingInsuranceCostLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_INSURANCE_COST_PENDING: "heavyDutyMachineryBookingInsuranceCostPending",
    HEAVY_DUTY_MACHINERY_BOOKING_SELECT_DAY_LABEL: "heavyDutyMachineryBookingSelectDayLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_SLOTS_FOR_DAY_LABEL: "heavyDutyMachineryBookingSlotsForDayLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_CHECKIN_LABEL: "heavyDutyMachineryBookingCheckinLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_CHECKOUT_LABEL: "heavyDutyMachineryBookingCheckoutLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_SELECT_CHECKIN_PROMPT: "heavyDutyMachineryBookingSelectCheckinPrompt",
    HEAVY_DUTY_MACHINERY_BOOKING_SELECT_CHECKOUT_PROMPT: "heavyDutyMachineryBookingSelectCheckoutPrompt",
    HEAVY_DUTY_MACHINERY_BOOKING_FIRST_DAY_LABEL: "heavyDutyMachineryBookingFirstDayLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_LAST_DAY_LABEL: "heavyDutyMachineryBookingLastDayLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_DAYS_SUFFIX: "heavyDutyMachineryBookingDaysSuffix",
    HEAVY_DUTY_MACHINERY_BOOKING_DAY_SUFFIX: "heavyDutyMachineryBookingDaySuffix",
    HEAVY_DUTY_MACHINERY_BOOKING_LEGEND_SELECTED: "heavyDutyMachineryBookingLegendSelected",
    HEAVY_DUTY_MACHINERY_BOOKING_LEGEND_UNAVAILABLE: "heavyDutyMachineryBookingLegendUnavailable",
    HEAVY_DUTY_MACHINERY_BOOKING_OVERNIGHT_RANGE_UNAVAILABLE: "heavyDutyMachineryBookingOvernightRangeUnavailable",
    HEAVY_DUTY_MACHINERY_BOOKING_TIMELINE_DRAG_HINT: "heavyDutyMachineryBookingTimelineDragHint",
    HEAVY_DUTY_MACHINERY_BOOKING_TIMELINE_LEGEND_BUFFER: "heavyDutyMachineryBookingTimelineLegendBuffer",
    HEAVY_DUTY_MACHINERY_BOOKING_TIMELINE_LEGEND_BOOKED: "heavyDutyMachineryBookingTimelineLegendBooked",
    HEAVY_DUTY_MACHINERY_BOOKING_TIMELINE_LEGEND_TOO_SOON: "heavyDutyMachineryBookingTimelineLegendTooSoon",
    HEAVY_DUTY_MACHINERY_BOOKING_TIMELINE_LEGEND_SELECTION: "heavyDutyMachineryBookingTimelineLegendSelection",
    HEAVY_DUTY_MACHINERY_BOOKING_TIMELINE_RESET_BUTTON: "heavyDutyMachineryBookingTimelineResetButton",
    HEAVY_DUTY_MACHINERY_BOOKING_HOURS_SUFFIX: "heavyDutyMachineryBookingHoursSuffix",
    HEAVY_DUTY_MACHINERY_BOOKING_CONTINUE_BUTTON: "heavyDutyMachineryBookingContinueButton",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMING_TITLE: "heavyDutyMachineryBookingConfirmingTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMING_MESSAGE_1: "heavyDutyMachineryBookingConfirmingMessage1",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMING_MESSAGE_2: "heavyDutyMachineryBookingConfirmingMessage2",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMING_MESSAGE_3: "heavyDutyMachineryBookingConfirmingMessage3",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMING_FAILED_TITLE: "heavyDutyMachineryBookingConfirmingFailedTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMING_FAILED_DESCRIPTION: "heavyDutyMachineryBookingConfirmingFailedDescription",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMING_FAILED_REASON_LABEL: "heavyDutyMachineryBookingConfirmingFailedReasonLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMING_RETRY_BUTTON: "heavyDutyMachineryBookingConfirmingRetryButton",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMING_TIMEOUT_TITLE: "heavyDutyMachineryBookingConfirmingTimeoutTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMING_TIMEOUT_DESCRIPTION: "heavyDutyMachineryBookingConfirmingTimeoutDescription",
    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMING_TIMEOUT_BUTTON: "heavyDutyMachineryBookingConfirmingTimeoutButton",

    HEAVY_DUTY_MACHINERY_SEARCH_TITLE: "heavyDutyMachinerySearchTitle",
    HEAVY_DUTY_MACHINERY_SEARCH_CITY_PLACEHOLDER: "heavyDutyMachinerySearchCityPlaceholder",
    HEAVY_DUTY_MACHINERY_SEARCH_RADIUS_LABEL: "heavyDutyMachinerySearchRadiusLabel",
    HEAVY_DUTY_MACHINERY_SEARCH_RADIUS_HINT: "heavyDutyMachinerySearchRadiusHint",
    HEAVY_DUTY_MACHINERY_SEARCH_RADIUS_VALUE: "heavyDutyMachinerySearchRadiusValue",
    HEAVY_DUTY_MACHINERY_SEARCH_RENTAL_MODE_PLACEHOLDER: "heavyDutyMachinerySearchRentalModePlaceholder",
    HEAVY_DUTY_MACHINERY_SEARCH_PRICE_LABEL: "heavyDutyMachinerySearchPriceLabel",
    HEAVY_DUTY_MACHINERY_SEARCH_VERIFIED_ONLY: "heavyDutyMachinerySearchVerifiedOnly",
    HEAVY_DUTY_MACHINERY_SEARCH_RENTAL_MODALITIES_LABEL: "heavyDutyMachinerySearchRentalModalitiesLabel",
    HEAVY_DUTY_MACHINERY_SEARCH_WET_HIRE_ONLY_LABEL: "heavyDutyMachinerySearchWetHireOnlyLabel",
    HEAVY_DUTY_MACHINERY_SEARCH_NO_RESULTS: "heavyDutyMachinerySearchNoResults",
    HEAVY_DUTY_MACHINERY_SEARCH_NO_RESULTS_DESCRIPTION: "heavyDutyMachinerySearchNoResultsDescription",
    HEAVY_DUTY_MACHINERY_SEARCH_RESULTS_SUFFIX: "heavyDutyMachinerySearchResultsSuffix",
    HEAVY_DUTY_MACHINERY_SEARCH_RESULTS_SUFFIX_SINGULAR: "heavyDutyMachinerySearchResultsSuffixSingular",

    // ===== Map explore's Operators/Accessories tabs (no dates/rental mode, so their own "no results" hint can't mention either) =====
    MAP_SEARCH_NO_RESULTS_DESCRIPTION: "mapSearchNoResultsDescription",
    HOMEPAGE_SEARCH_LABEL_CATEGORY_ACCESSORY: "homepageSearchLabelCategoryAccessory",
    HOMEPAGE_SEARCH_CATEGORY_PLACEHOLDER_ACCESSORY: "homepageSearchCategoryPlaceholderAccessory",
    HOMEPAGE_SEARCH_LABEL_CATEGORY_OPERATOR: "homepageSearchLabelCategoryOperator",
    HOMEPAGE_SEARCH_CATEGORY_PLACEHOLDER_OPERATOR: "homepageSearchCategoryPlaceholderOperator",
    OPERATORS_SEARCH_RESULTS_SUFFIX: "operatorsSearchResultsSuffix",
    OPERATORS_SEARCH_RESULTS_SUFFIX_SINGULAR: "operatorsSearchResultsSuffixSingular",
    ACCESSORIES_SEARCH_RESULTS_SUFFIX: "accessoriesSearchResultsSuffix",
    ACCESSORIES_SEARCH_RESULTS_SUFFIX_SINGULAR: "accessoriesSearchResultsSuffixSingular",
    HEAVY_DUTY_MACHINERY_SEARCH_FILTERS_TITLE: "heavyDutyMachinerySearchFiltersTitle",
    HEAVY_DUTY_MACHINERY_SEARCH_FILTERS_OVERLAY_CLOSE: "heavyDutyMachinerySearchFiltersOverlayClose",
    HEAVY_DUTY_MACHINERY_SEARCH_CLEAR_FILTERS: "heavyDutyMachinerySearchClearFilters",
    HEAVY_DUTY_MACHINERY_SEARCH_MIN_PLACEHOLDER: "heavyDutyMachinerySearchMinPlaceholder",
    HEAVY_DUTY_MACHINERY_SEARCH_MAX_PLACEHOLDER: "heavyDutyMachinerySearchMaxPlaceholder",
    HEAVY_DUTY_MACHINERY_ACCESSORY_FILTER_MACHINE_WEIGHT_LABEL: "heavyDutyMachineryAccessoryFilterMachineWeightLabel",
    HEAVY_DUTY_MACHINERY_SEARCH_SECTION_MACHINERY: "heavyDutyMachinerySearchSectionMachinery",
    HEAVY_DUTY_MACHINERY_SEARCH_SECTION_ACCESS_RULES: "heavyDutyMachinerySearchSectionAccessRules",
    HEAVY_DUTY_MACHINERY_SEARCH_BRAND_PLACEHOLDER: "heavyDutyMachinerySearchBrandPlaceholder",
    HEAVY_DUTY_MACHINERY_SEARCH_SECTION_QUALITY: "heavyDutyMachinerySearchSectionQuality",
    HEAVY_DUTY_MACHINERY_SEARCH_LOAD_ERROR: "heavyDutyMachinerySearchLoadError",
    HEAVY_DUTY_MACHINERY_SEARCH_SHOW_RESULTS_BUTTON: "heavyDutyMachinerySearchShowResultsButton",
    HEAVY_DUTY_MACHINERY_SEARCH_MAP_UNAVAILABLE: "heavyDutyMachinerySearchMapUnavailable",
    HEAVY_DUTY_MACHINERY_SEARCH_HIDE_MAP: "heavyDutyMachinerySearchHideMap",
    HEAVY_DUTY_MACHINERY_SEARCH_SHOW_MAP: "heavyDutyMachinerySearchShowMap",
    HEAVY_DUTY_MACHINERY_SEARCH_THIS_AREA_BUTTON: "heavyDutyMachinerySearchThisAreaButton",
    HEAVY_DUTY_MACHINERY_SEARCH_MAP_SATELLITE_BUTTON: "heavyDutyMachinerySearchMapSatelliteButton",
    HEAVY_DUTY_MACHINERY_SEARCH_MAP_ROAD_BUTTON: "heavyDutyMachinerySearchMapRoadButton",
    HEAVY_DUTY_MACHINERY_SEARCH_MAP_FULLSCREEN_BUTTON: "heavyDutyMachinerySearchMapFullscreenButton",
    HEAVY_DUTY_MACHINERY_SEARCH_MAP_EXIT_FULLSCREEN_BUTTON: "heavyDutyMachinerySearchMapExitFullscreenButton",
    HEAVY_DUTY_MACHINERY_SEARCH_MAP_LOCATE_BUTTON: "heavyDutyMachinerySearchMapLocateButton",
    HEAVY_DUTY_MACHINERY_SEARCH_MAP_LOCATE_ERROR: "heavyDutyMachinerySearchMapLocateError",
    HEAVY_DUTY_MACHINERY_SEARCH_MOBILE_MAP_BUTTON: "heavyDutyMachinerySearchMobileMapButton",
    HEAVY_DUTY_MACHINERY_SEARCH_MOBILE_LOADING_MESSAGE: "heavyDutyMachinerySearchMobileLoadingMessage",
    ACCESSORIES_SEARCH_MOBILE_LOADING_MESSAGE: "accessoriesSearchMobileLoadingMessage",
    OPERATORS_SEARCH_MOBILE_LOADING_MESSAGE: "operatorsSearchMobileLoadingMessage",
    HEAVY_DUTY_MACHINERY_SEARCH_MAP_POPUP_CLOSE: "heavyDutyMachinerySearchMapPopupClose",
    NEARBY_OPERATORS_TITLE: "nearbyOperatorsTitle",
    NEARBY_OPERATORS_SUBTITLE_BROWSE: "nearbyOperatorsSubtitleBrowse",
    NEARBY_OPERATORS_SUBTITLE_HIRE: "nearbyOperatorsSubtitleHire",
    NEARBY_OPERATORS_CLOSE: "nearbyOperatorsClose",
    NEARBY_OPERATORS_LOADING: "nearbyOperatorsLoading",
    NEARBY_OPERATORS_DISTANCE: "nearbyOperatorsDistance",
    NEARBY_OPERATORS_UNAVAILABLE: "nearbyOperatorsUnavailable",
    NEARBY_OPERATORS_DEPOSIT_NOTE: "nearbyOperatorsDepositNote",
    NEARBY_OPERATORS_HIRE_CTA: "nearbyOperatorsHireCta",
    NEARBY_OPERATORS_BROWSE_NOTE: "nearbyOperatorsBrowseNote",
    NEARBY_OPERATORS_HIRE_NOTE: "nearbyOperatorsHireNote",
    NEARBY_OPERATORS_TRIGGER_TITLE: "nearbyOperatorsTriggerTitle",
    NEARBY_OPERATORS_TRIGGER_TITLE_SINGULAR: "nearbyOperatorsTriggerTitleSingular",
    NEARBY_OPERATORS_TRIGGER_FROM: "nearbyOperatorsTriggerFrom",
    SERVICE_CATEGORY_OPERATOR_HINT_TITLE: "serviceCategoryOperatorHintTitle",
    SERVICE_CATEGORY_OPERATOR_HINT_BODY: "serviceCategoryOperatorHintBody",

    HEAVY_DUTY_MACHINERY_PUBLISH_BUTTON: "heavyDutyMachineryPublishButton",
    HEAVY_DUTY_MACHINERY_PUBLISH_CONFIRM: "heavyDutyMachineryPublishConfirm",
    HEAVY_DUTY_MACHINERY_PUBLISH_SUCCESS: "heavyDutyMachineryPublishSuccess",
    HEAVY_DUTY_MACHINERY_PUBLISH_PENDING_REVIEW: "heavyDutyMachineryPublishPendingReview",
    HEAVY_DUTY_MACHINERY_PUBLISH_ERROR: "heavyDutyMachineryPublishError",

    HEAVY_DUTY_MACHINERY_SPACE_STATUS_DRAFT: "heavyDutyMachinerySpaceStatusDraft",
    HEAVY_DUTY_MACHINERY_SPACE_STATUS_PENDING_VERIFICATION: "heavyDutyMachinerySpaceStatusPendingVerification",
    HEAVY_DUTY_MACHINERY_SPACE_STATUS_ACTIVE: "heavyDutyMachinerySpaceStatusActive",
    HEAVY_DUTY_MACHINERY_SPACE_STATUS_PENDING_IMPROVEMENT: "heavyDutyMachinerySpaceStatusPendingImprovement",
    HEAVY_DUTY_MACHINERY_SPACE_STATUS_SUSPENDED: "heavyDutyMachinerySpaceStatusSuspended",

    HEAVY_DUTY_MACHINERY_LIVE_STATUS_AVAILABLE: "heavyDutyMachineryLiveStatusAvailable",
    HEAVY_DUTY_MACHINERY_LIVE_STATUS_RENTED: "heavyDutyMachineryLiveStatusRented",
    HEAVY_DUTY_MACHINERY_LIVE_STATUS_MAINTENANCE: "heavyDutyMachineryLiveStatusMaintenance",

    HEAVY_DUTY_MACHINERY_FLEET_NAV_LABEL: "heavyDutyMachineryFleetNavLabel",
    HEAVY_DUTY_MACHINERY_FLEET_PAGE_TITLE: "heavyDutyMachineryFleetPageTitle",
    HEAVY_DUTY_MACHINERY_FLEET_PAGE_SUBTITLE: "heavyDutyMachineryFleetPageSubtitle",
    HEAVY_DUTY_MACHINERY_FLEET_EMPTY: "heavyDutyMachineryFleetEmpty",
    HEAVY_DUTY_MACHINERY_FLEET_NO_LIVE_DATA: "heavyDutyMachineryFleetNoLiveData",
    HEAVY_DUTY_MACHINERY_FLEET_ENGINE_ON: "heavyDutyMachineryFleetEngineOn",
    HEAVY_DUTY_MACHINERY_FLEET_ENGINE_OFF: "heavyDutyMachineryFleetEngineOff",
    HEAVY_DUTY_MACHINERY_FLEET_ENGINE_HOURS_LABEL: "heavyDutyMachineryFleetEngineHoursLabel",
    HEAVY_DUTY_MACHINERY_FLEET_FUEL_LABEL: "heavyDutyMachineryFleetFuelLabel",
    HEAVY_DUTY_MACHINERY_FLEET_LAST_UPDATE_LABEL: "heavyDutyMachineryFleetLastUpdateLabel",
    HEAVY_DUTY_MACHINERY_FLEET_GEOFENCE_ALERT_LABEL: "heavyDutyMachineryFleetGeofenceAlertLabel",
    BOOKING_REFERENCE_LABEL: "bookingReferenceLabel",
    GEOFENCE_TITLE: "geofenceTitle",
    GEOFENCE_MAP_UNAVAILABLE: "geofenceMapUnavailable",
    GEOFENCE_HOST_HINT: "geofenceHostHint",
    GEOFENCE_SUGGESTION_HINT: "geofenceSuggestionHint",
    GEOFENCE_GUEST_HINT: "geofenceGuestHint",
    GEOFENCE_NONE_HOST: "geofenceNoneHost",
    GEOFENCE_NONE_GUEST: "geofenceNoneGuest",
    GEOFENCE_RADIUS_LABEL: "geofenceRadiusLabel",
    GEOFENCE_CIRCLE_HINT: "geofenceCircleHint",
    GEOFENCE_SHAPE_CIRCLE: "geofenceShapeCircle",
    GEOFENCE_SHAPE_POLYGON: "geofenceShapePolygon",
    GEOFENCE_POLYGON_HINT: "geofencePolygonHint",
    GEOFENCE_POLYGON_COUNT: "geofencePolygonCount",
    GEOFENCE_POLYGON_NEEDS_MORE: "geofencePolygonNeedsMore",
    GEOFENCE_POLYGON_UNDO: "geofencePolygonUndo",
    GEOFENCE_POLYGON_CLEAR: "geofencePolygonClear",
    GEOFENCE_SAVE_BUTTON: "geofenceSaveButton",
    GEOFENCE_EDIT_BUTTON: "geofenceEditButton",
    GEOFENCE_CANCEL_BUTTON: "geofenceCancelButton",
    GEOFENCE_SAVE_ERROR: "geofenceSaveError",
    GEOFENCE_SAVED: "geofenceSaved",
    GEOFENCE_BREACHED_TITLE: "geofenceBreachedTitle",
    GEOFENCE_BREACHED_SINCE: "geofenceBreachedSince",
    GEOFENCE_INSIDE: "geofenceInside",
    GEOFENCE_NO_POSITION: "geofenceNoPosition",
    GEOFENCE_DISTANCE_FROM_CENTER: "geofenceDistanceFromCenter",
    GEOFENCE_ONLY_WHILE_OUT: "geofenceOnlyWhileOut",
    GEOFENCE_EVENTS_TITLE: "geofenceEventsTitle",
    GEOFENCE_EVENT_OPEN: "geofenceEventOpen",
    GEOFENCE_EVENT_RESOLVED: "geofenceEventResolved",
    GEOFENCE_EVENT_MAX: "geofenceEventMax",
    GEOFENCE_MOVE_REQUEST_BUTTON: "geofenceMoveRequestButton",
    GEOFENCE_MOVE_MODAL_TITLE: "geofenceMoveModalTitle",
    GEOFENCE_MOVE_REASON_LABEL: "geofenceMoveReasonLabel",
    GEOFENCE_MOVE_REASON_PLACEHOLDER: "geofenceMoveReasonPlaceholder",
    GEOFENCE_MOVE_SEND: "geofenceMoveSend",
    GEOFENCE_MOVE_SENT: "geofenceMoveSent",
    GEOFENCE_MOVE_ERROR: "geofenceMoveError",
    GEOFENCE_MOVE_PENDING_HOST: "geofenceMovePendingHost",
    GEOFENCE_MOVE_PENDING_GUEST: "geofenceMovePendingGuest",
    GEOFENCE_MOVE_PENDING_DASHED: "geofenceMovePendingDashed",
    GEOFENCE_MOVE_REQUESTED_DASHED: "geofenceMoveRequestedDashed",
    GEOFENCE_MOVE_CURRENT_DASHED: "geofenceMoveCurrentDashed",
    GEOFENCE_MOVE_APPROVE: "geofenceMoveApprove",
    GEOFENCE_MOVE_REJECT: "geofenceMoveReject",
    GEOFENCE_MOVE_REJECT_MODAL: "geofenceMoveRejectModal",
    GEOFENCE_MOVE_REJECTED: "geofenceMoveRejected",
    GEOFENCE_MOVE_APPROVED: "geofenceMoveApproved",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_GEOFENCE_RESOLVED: "heavyDutyMachineryNotifTitleGeofenceResolved",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_GEOFENCE_RESOLVED: "heavyDutyMachineryNotifBodyGeofenceResolved",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_GEOFENCE_ZONE_SET: "heavyDutyMachineryNotifTitleGeofenceZoneSet",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_GEOFENCE_ZONE_SET: "heavyDutyMachineryNotifBodyGeofenceZoneSet",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_GEOFENCE_MOVE_REQUESTED: "heavyDutyMachineryNotifTitleGeofenceMoveRequested",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_GEOFENCE_MOVE_REQUESTED: "heavyDutyMachineryNotifBodyGeofenceMoveRequested",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_GEOFENCE_MOVE_APPROVED: "heavyDutyMachineryNotifTitleGeofenceMoveApproved",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_GEOFENCE_MOVE_APPROVED: "heavyDutyMachineryNotifBodyGeofenceMoveApproved",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_GEOFENCE_MOVE_REJECTED: "heavyDutyMachineryNotifTitleGeofenceMoveRejected",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_GEOFENCE_MOVE_REJECTED: "heavyDutyMachineryNotifBodyGeofenceMoveRejected",

    HEAVY_DUTY_MACHINERY_ACCESSORIES_NAV_LABEL: "heavyDutyMachineryAccessoriesNavLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORIES_PAGE_SUBTITLE: "heavyDutyMachineryAccessoriesPageSubtitle",
    HEAVY_DUTY_MACHINERY_ACCESSORIES_EMPTY_TITLE: "heavyDutyMachineryAccessoriesEmptyTitle",
    HEAVY_DUTY_MACHINERY_ACCESSORIES_EMPTY_DESCRIPTION: "heavyDutyMachineryAccessoriesEmptyDescription",
    HEAVY_DUTY_MACHINERY_ACCESSORIES_CREATE_BUTTON: "heavyDutyMachineryAccessoriesCreateButton",
    HEAVY_DUTY_MACHINERY_ACCESSORY_NAME_LABEL: "heavyDutyMachineryAccessoryNameLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_DESCRIPTION_LABEL: "heavyDutyMachineryAccessoryDescriptionLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_PRICE_PER_DAY_LABEL: "heavyDutyMachineryAccessoryPricePerDayLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_QUANTITY_LABEL: "heavyDutyMachineryAccessoryQuantityLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_INDEPENDENTLY_RENTABLE_LABEL: "heavyDutyMachineryAccessoryIndependentlyRentableLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_PHOTOS_LABEL: "heavyDutyMachineryAccessoryPhotosLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_COMPATIBLE_CATEGORIES_LABEL: "heavyDutyMachineryAccessoryCompatibleCategoriesLabel",
    // ===== Optional mechanical/hydraulic/dimensional specs (§9.45) =====
    HEAVY_DUTY_MACHINERY_ACCESSORY_MECHANICAL_SECTION_TITLE: "heavyDutyMachineryAccessoryMechanicalSectionTitle",
    HEAVY_DUTY_MACHINERY_ACCESSORY_WEIGHT_RANGE_MIN_LABEL: "heavyDutyMachineryAccessoryWeightRangeMinLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_WEIGHT_RANGE_MAX_LABEL: "heavyDutyMachineryAccessoryWeightRangeMaxLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_COUPLER_TYPE_LABEL: "heavyDutyMachineryAccessoryCouplerTypeLabel",
    MACHINERY_ACCESSORY_COUPLER_LEHNHOFF: "machineryAccessoryCouplerLehnhoff",
    MACHINERY_ACCESSORY_COUPLER_CW_VERACHTERT: "machineryAccessoryCouplerCwVerachtert",
    MACHINERY_ACCESSORY_COUPLER_UNIVERSAL_SKID_STEER: "machineryAccessoryCouplerUniversalSkidSteer",
    MACHINERY_ACCESSORY_COUPLER_NORDIC: "machineryAccessoryCouplerNordic",
    MACHINERY_ACCESSORY_COUPLER_PIN_ON: "machineryAccessoryCouplerPinOn",
    MACHINERY_ACCESSORY_COUPLER_OTHER: "machineryAccessoryCouplerOther",
    MACHINERY_ACCESSORY_COUPLER_GENERIC_OPTION: "machineryAccessoryCouplerGenericOption",
    MACHINERY_ACCESSORY_COUPLER_MODEL_LEHNHOFF_MS01: "machineryAccessoryCouplerModelLehnhoffMs01",
    MACHINERY_ACCESSORY_COUPLER_MODEL_LEHNHOFF_MS03: "machineryAccessoryCouplerModelLehnhoffMs03",
    MACHINERY_ACCESSORY_COUPLER_MODEL_LEHNHOFF_MS08: "machineryAccessoryCouplerModelLehnhoffMs08",
    MACHINERY_ACCESSORY_COUPLER_MODEL_CW_VERACHTERT_CW05: "machineryAccessoryCouplerModelCwVerachtertCw05",
    MACHINERY_ACCESSORY_COUPLER_MODEL_CW_VERACHTERT_CW10: "machineryAccessoryCouplerModelCwVerachtertCw10",
    MACHINERY_ACCESSORY_COUPLER_MODEL_CW_VERACHTERT_CW20: "machineryAccessoryCouplerModelCwVerachtertCw20",
    MACHINERY_ACCESSORY_COUPLER_MODEL_NORDIC_S30: "machineryAccessoryCouplerModelNordicS30",
    MACHINERY_ACCESSORY_COUPLER_MODEL_NORDIC_S40: "machineryAccessoryCouplerModelNordicS40",
    MACHINERY_ACCESSORY_COUPLER_MODEL_NORDIC_S60: "machineryAccessoryCouplerModelNordicS60",
    HEAVY_DUTY_MACHINERY_ACCESSORY_HYDRAULIC_SECTION_TITLE: "heavyDutyMachineryAccessoryHydraulicSectionTitle",
    HEAVY_DUTY_MACHINERY_ACCESSORY_REQUIRES_HYDRAULICS_LABEL: "heavyDutyMachineryAccessoryRequiresHydraulicsLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_HYDRAULIC_FLOW_MIN_LABEL: "heavyDutyMachineryAccessoryHydraulicFlowMinLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_HYDRAULIC_FLOW_MAX_LABEL: "heavyDutyMachineryAccessoryHydraulicFlowMaxLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_HYDRAULIC_PRESSURE_MIN_LABEL: "heavyDutyMachineryAccessoryHydraulicPressureMinLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_HYDRAULIC_PRESSURE_MAX_LABEL: "heavyDutyMachineryAccessoryHydraulicPressureMaxLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_HYDRAULIC_LINES_LABEL: "heavyDutyMachineryAccessoryHydraulicLinesLabel",
    MACHINERY_ACCESSORY_HYDRAULIC_LINES_ONE: "machineryAccessoryHydraulicLinesOne",
    MACHINERY_ACCESSORY_HYDRAULIC_LINES_TWO: "machineryAccessoryHydraulicLinesTwo",
    HEAVY_DUTY_MACHINERY_ACCESSORY_REQUIRES_HIGH_FLOW_LABEL: "heavyDutyMachineryAccessoryRequiresHighFlowLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_REQUIRES_CASE_DRAIN_LABEL: "heavyDutyMachineryAccessoryRequiresCaseDrainLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_HYDRAULIC_CONNECTOR_TYPE_LABEL: "heavyDutyMachineryAccessoryHydraulicConnectorTypeLabel",
    MACHINERY_ACCESSORY_HYDRAULIC_CONNECTOR_FLAT_FACE: "machineryAccessoryHydraulicConnectorFlatFace",
    MACHINERY_ACCESSORY_HYDRAULIC_CONNECTOR_THREADED: "machineryAccessoryHydraulicConnectorThreaded",
    MACHINERY_ACCESSORY_HYDRAULIC_CONNECTOR_STANDARD: "machineryAccessoryHydraulicConnectorStandard",
    HEAVY_DUTY_MACHINERY_ACCESSORY_DIMENSIONS_SECTION_TITLE: "heavyDutyMachineryAccessoryDimensionsSectionTitle",
    HEAVY_DUTY_MACHINERY_ACCESSORY_WORKING_WIDTH_LABEL: "heavyDutyMachineryAccessoryWorkingWidthLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_CAPACITY_LABEL: "heavyDutyMachineryAccessoryCapacityLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_OWN_WEIGHT_LABEL: "heavyDutyMachineryAccessoryOwnWeightLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_TYPE_LABEL: "heavyDutyMachineryAccessoryTypeLabel",
    HEAVY_DUTY_MACHINERY_ACCESSORY_TYPE_PICKER_TITLE: "heavyDutyMachineryAccessoryTypePickerTitle",
    HEAVY_DUTY_MACHINERY_ACCESSORY_TYPE_PICKER_PLACEHOLDER: "heavyDutyMachineryAccessoryTypePickerPlaceholder",
    HEAVY_DUTY_MACHINERY_ACCESSORY_ACTIVE_STATUS: "heavyDutyMachineryAccessoryActiveStatus",
    HEAVY_DUTY_MACHINERY_ACCESSORY_INACTIVE_STATUS: "heavyDutyMachineryAccessoryInactiveStatus",
    HEAVY_DUTY_MACHINERY_ACCESSORY_EDIT_BUTTON: "heavyDutyMachineryAccessoryEditButton",
    HEAVY_DUTY_MACHINERY_ACCESSORY_DEACTIVATE_BUTTON: "heavyDutyMachineryAccessoryDeactivateButton",
    HEAVY_DUTY_MACHINERY_ACCESSORY_REACTIVATE_BUTTON: "heavyDutyMachineryAccessoryReactivateButton",
    HEAVY_DUTY_MACHINERY_ACCESSORY_MODAL_CREATE_TITLE: "heavyDutyMachineryAccessoryModalCreateTitle",
    HEAVY_DUTY_MACHINERY_ACCESSORY_MODAL_EDIT_TITLE: "heavyDutyMachineryAccessoryModalEditTitle",
    HEAVY_DUTY_MACHINERY_ACCESSORY_SAVE_BUTTON: "heavyDutyMachineryAccessorySaveButton",
    HEAVY_DUTY_MACHINERY_ACCESSORY_SAVE_SUCCESS: "heavyDutyMachineryAccessorySaveSuccess",
    HEAVY_DUTY_MACHINERY_ACCESSORY_SAVE_ERROR: "heavyDutyMachineryAccessorySaveError",
    HEAVY_DUTY_MACHINERY_ACCESSORY_LOAD_ERROR: "heavyDutyMachineryAccessoryLoadError",
    HEAVY_DUTY_MACHINERY_ACCESSORY_STATUS_UPDATE_ERROR: "heavyDutyMachineryAccessoryStatusUpdateError",

    HEAVY_DUTY_MACHINERY_ACCESSORY_LINK_SECTION_TITLE: "heavyDutyMachineryAccessoryLinkSectionTitle",
    HEAVY_DUTY_MACHINERY_ACCESSORY_LINK_SECTION_SUBTITLE: "heavyDutyMachineryAccessoryLinkSectionSubtitle",
    HEAVY_DUTY_MACHINERY_ACCESSORY_LINK_EMPTY_TITLE: "heavyDutyMachineryAccessoryLinkEmptyTitle",
    HEAVY_DUTY_MACHINERY_ACCESSORY_LINK_EMPTY_DESCRIPTION: "heavyDutyMachineryAccessoryLinkEmptyDescription",
    HEAVY_DUTY_MACHINERY_ACCESSORY_LINK_EMPTY_CTA: "heavyDutyMachineryAccessoryLinkEmptyCta",
    HEAVY_DUTY_MACHINERY_ACCESSORY_LINK_ERROR: "heavyDutyMachineryAccessoryLinkError",
    HEAVY_DUTY_MACHINERY_ACCESSORY_UNLINK_ERROR: "heavyDutyMachineryAccessoryUnlinkError",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLES_NAV_LABEL: "heavyDutyMachineryTransportVehiclesNavLabel",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLES_PAGE_SUBTITLE: "heavyDutyMachineryTransportVehiclesPageSubtitle",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLES_EMPTY_TITLE: "heavyDutyMachineryTransportVehiclesEmptyTitle",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLES_EMPTY_DESCRIPTION: "heavyDutyMachineryTransportVehiclesEmptyDescription",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLES_CREATE_BUTTON: "heavyDutyMachineryTransportVehiclesCreateButton",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_NAME_LABEL: "heavyDutyMachineryTransportVehicleNameLabel",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_LICENSE_PLATE_LABEL: "heavyDutyMachineryTransportVehicleLicensePlateLabel",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_BRAND_LABEL: "heavyDutyMachineryTransportVehicleBrandLabel",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_DESCRIPTION_LABEL: "heavyDutyMachineryTransportVehicleDescriptionLabel",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_FUEL_CONSUMPTION_LABEL: "heavyDutyMachineryTransportVehicleFuelConsumptionLabel",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_ACTIVE_STATUS: "heavyDutyMachineryTransportVehicleActiveStatus",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_INACTIVE_STATUS: "heavyDutyMachineryTransportVehicleInactiveStatus",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_EDIT_BUTTON: "heavyDutyMachineryTransportVehicleEditButton",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_DEACTIVATE_BUTTON: "heavyDutyMachineryTransportVehicleDeactivateButton",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_REACTIVATE_BUTTON: "heavyDutyMachineryTransportVehicleReactivateButton",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_MODAL_CREATE_TITLE: "heavyDutyMachineryTransportVehicleModalCreateTitle",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_MODAL_EDIT_TITLE: "heavyDutyMachineryTransportVehicleModalEditTitle",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_SAVE_BUTTON: "heavyDutyMachineryTransportVehicleSaveButton",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_SAVE_SUCCESS: "heavyDutyMachineryTransportVehicleSaveSuccess",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_SAVE_ERROR: "heavyDutyMachineryTransportVehicleSaveError",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_LOAD_ERROR: "heavyDutyMachineryTransportVehicleLoadError",
    HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_STATUS_UPDATE_ERROR: "heavyDutyMachineryTransportVehicleStatusUpdateError",
    HEAVY_DUTY_MACHINERY_SPACE_DELIVERY_VEHICLE_EMPTY_CTA: "heavyDutyMachinerySpaceDeliveryVehicleEmptyCta",

    HEAVY_DUTY_MACHINERY_INSURANCE_POLICIES_NAV_LABEL: "heavyDutyMachineryInsurancePoliciesNavLabel",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICIES_PAGE_SUBTITLE: "heavyDutyMachineryInsurancePoliciesPageSubtitle",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICIES_EMPTY_TITLE: "heavyDutyMachineryInsurancePoliciesEmptyTitle",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICIES_EMPTY_DESCRIPTION: "heavyDutyMachineryInsurancePoliciesEmptyDescription",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICIES_CREATE_BUTTON: "heavyDutyMachineryInsurancePoliciesCreateButton",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_NAME_LABEL: "heavyDutyMachineryInsurancePolicyNameLabel",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_DESCRIPTION_LABEL: "heavyDutyMachineryInsurancePolicyDescriptionLabel",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_COVERAGE_SUMMARY_LABEL: "heavyDutyMachineryInsurancePolicyCoverageSummaryLabel",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_PRICE_PER_DAY_LABEL: "heavyDutyMachineryInsurancePolicyPricePerDayLabel",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_ACTIVE_STATUS: "heavyDutyMachineryInsurancePolicyActiveStatus",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_INACTIVE_STATUS: "heavyDutyMachineryInsurancePolicyInactiveStatus",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_EDIT_BUTTON: "heavyDutyMachineryInsurancePolicyEditButton",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_DEACTIVATE_BUTTON: "heavyDutyMachineryInsurancePolicyDeactivateButton",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_REACTIVATE_BUTTON: "heavyDutyMachineryInsurancePolicyReactivateButton",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_MODAL_CREATE_TITLE: "heavyDutyMachineryInsurancePolicyModalCreateTitle",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_MODAL_EDIT_TITLE: "heavyDutyMachineryInsurancePolicyModalEditTitle",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_SAVE_BUTTON: "heavyDutyMachineryInsurancePolicySaveButton",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_SAVE_SUCCESS: "heavyDutyMachineryInsurancePolicySaveSuccess",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_SAVE_ERROR: "heavyDutyMachineryInsurancePolicySaveError",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_LOAD_ERROR: "heavyDutyMachineryInsurancePolicyLoadError",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_STATUS_UPDATE_ERROR: "heavyDutyMachineryInsurancePolicyStatusUpdateError",

    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_LINK_SECTION_TITLE: "heavyDutyMachineryInsurancePolicyLinkSectionTitle",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_LINK_SECTION_SUBTITLE: "heavyDutyMachineryInsurancePolicyLinkSectionSubtitle",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_LINK_EMPTY_TITLE: "heavyDutyMachineryInsurancePolicyLinkEmptyTitle",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_LINK_EMPTY_DESCRIPTION: "heavyDutyMachineryInsurancePolicyLinkEmptyDescription",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_LINK_EMPTY_CTA: "heavyDutyMachineryInsurancePolicyLinkEmptyCta",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_LINK_ERROR: "heavyDutyMachineryInsurancePolicyLinkError",
    HEAVY_DUTY_MACHINERY_INSURANCE_POLICY_UNLINK_ERROR: "heavyDutyMachineryInsurancePolicyUnlinkError",

    HEAVY_DUTY_MACHINERY_OPERATORS_NAV_LABEL: "heavyDutyMachineryOperatorsNavLabel",
    HEAVY_DUTY_MACHINERY_OPERATORS_PAGE_SUBTITLE: "heavyDutyMachineryOperatorsPageSubtitle",
    HEAVY_DUTY_MACHINERY_OPERATORS_EMPTY_TITLE: "heavyDutyMachineryOperatorsEmptyTitle",
    HEAVY_DUTY_MACHINERY_OPERATORS_EMPTY_DESCRIPTION: "heavyDutyMachineryOperatorsEmptyDescription",
    HEAVY_DUTY_MACHINERY_OPERATORS_CREATE_BUTTON: "heavyDutyMachineryOperatorsCreateButton",
    HEAVY_DUTY_MACHINERY_OPERATOR_NAME_LABEL: "heavyDutyMachineryOperatorNameLabel",
    HEAVY_DUTY_MACHINERY_OPERATOR_EMAIL_LABEL: "heavyDutyMachineryOperatorEmailLabel",
    HEAVY_DUTY_MACHINERY_OPERATOR_PHONE_LABEL: "heavyDutyMachineryOperatorPhoneLabel",
    HEAVY_DUTY_MACHINERY_OPERATOR_HOURLY_RATE_LABEL: "heavyDutyMachineryOperatorHourlyRateLabel",
    HEAVY_DUTY_MACHINERY_OPERATOR_QUALIFIED_CATEGORIES_LABEL: "heavyDutyMachineryOperatorQualifiedCategoriesLabel",
    HEAVY_DUTY_MACHINERY_OPERATOR_ACTIVE_STATUS: "heavyDutyMachineryOperatorActiveStatus",
    HEAVY_DUTY_MACHINERY_OPERATOR_INACTIVE_STATUS: "heavyDutyMachineryOperatorInactiveStatus",
    HEAVY_DUTY_MACHINERY_OPERATOR_EDIT_BUTTON: "heavyDutyMachineryOperatorEditButton",
    HEAVY_DUTY_MACHINERY_OPERATOR_DEACTIVATE_BUTTON: "heavyDutyMachineryOperatorDeactivateButton",
    HEAVY_DUTY_MACHINERY_OPERATOR_REACTIVATE_BUTTON: "heavyDutyMachineryOperatorReactivateButton",
    HEAVY_DUTY_MACHINERY_OPERATOR_MODAL_CREATE_TITLE: "heavyDutyMachineryOperatorModalCreateTitle",
    HEAVY_DUTY_MACHINERY_OPERATOR_MODAL_EDIT_TITLE: "heavyDutyMachineryOperatorModalEditTitle",
    HEAVY_DUTY_MACHINERY_OPERATOR_SAVE_BUTTON: "heavyDutyMachineryOperatorSaveButton",
    HEAVY_DUTY_MACHINERY_OPERATOR_SAVE_SUCCESS: "heavyDutyMachineryOperatorSaveSuccess",
    HEAVY_DUTY_MACHINERY_OPERATOR_SAVE_ERROR: "heavyDutyMachineryOperatorSaveError",
    HEAVY_DUTY_MACHINERY_OPERATOR_LOAD_ERROR: "heavyDutyMachineryOperatorLoadError",
    HEAVY_DUTY_MACHINERY_OPERATOR_STATUS_UPDATE_ERROR: "heavyDutyMachineryOperatorStatusUpdateError",
    HEAVY_DUTY_MACHINERY_OPERATOR_EMAIL_INVALID: "heavyDutyMachineryOperatorEmailInvalid",

    HEAVY_DUTY_MACHINERY_OPERATOR_DOCUMENTS_TITLE: "heavyDutyMachineryOperatorDocumentsTitle",
    HEAVY_DUTY_MACHINERY_OPERATOR_DOCUMENTS_HINT: "heavyDutyMachineryOperatorDocumentsHint",
    HEAVY_DUTY_MACHINERY_OPERATOR_DOCUMENT_TYPE_LICENSE: "heavyDutyMachineryOperatorDocumentTypeLicense",
    HEAVY_DUTY_MACHINERY_OPERATOR_DOCUMENT_TYPE_PRL: "heavyDutyMachineryOperatorDocumentTypePrl",
    HEAVY_DUTY_MACHINERY_OPERATOR_DOCUMENT_TYPE_OTHER: "heavyDutyMachineryOperatorDocumentTypeOther",
    HEAVY_DUTY_MACHINERY_OPERATOR_DOCUMENT_UPLOAD_BUTTON: "heavyDutyMachineryOperatorDocumentUploadButton",
    HEAVY_DUTY_MACHINERY_OPERATOR_DOCUMENT_UPLOAD_ERROR: "heavyDutyMachineryOperatorDocumentUploadError",
    HEAVY_DUTY_MACHINERY_OPERATOR_DOCUMENT_UPLOAD_SUCCESS: "heavyDutyMachineryOperatorDocumentUploadSuccess",
    HEAVY_DUTY_MACHINERY_OPERATOR_DOCUMENT_DOWNLOAD_ERROR: "heavyDutyMachineryOperatorDocumentDownloadError",
    HEAVY_DUTY_MACHINERY_OPERATOR_DOCUMENT_EMPTY: "heavyDutyMachineryOperatorDocumentEmpty",
    HEAVY_DUTY_MACHINERY_OPERATOR_DOCUMENT_SAVE_FIRST_HINT: "heavyDutyMachineryOperatorDocumentSaveFirstHint",

    // ===== SERVICES (Fase 13) =====
    HEAVY_DUTY_MACHINERY_SERVICES_NAV_LABEL: "heavyDutyMachineryServicesNavLabel",
    HEAVY_DUTY_MACHINERY_SERVICES_PAGE_SUBTITLE: "heavyDutyMachineryServicesPageSubtitle",
    HEAVY_DUTY_MACHINERY_SERVICES_EMPTY_TITLE: "heavyDutyMachineryServicesEmptyTitle",
    HEAVY_DUTY_MACHINERY_SERVICES_EMPTY_DESCRIPTION: "heavyDutyMachineryServicesEmptyDescription",
    HEAVY_DUTY_MACHINERY_SERVICES_CREATE_BUTTON: "heavyDutyMachineryServicesCreateButton",
    HEAVY_DUTY_MACHINERY_SERVICES_LOAD_ERROR: "heavyDutyMachineryServicesLoadError",
    HEAVY_DUTY_MACHINERY_SERVICES_NO_PROVIDER_PROFILE_TITLE: "heavyDutyMachineryServicesNoProviderProfileTitle",
    HEAVY_DUTY_MACHINERY_SERVICES_NO_PROVIDER_PROFILE_DESCRIPTION: "heavyDutyMachineryServicesNoProviderProfileDescription",
    HEAVY_DUTY_MACHINERY_SERVICES_NOT_AVAILABLE_TITLE: "heavyDutyMachineryServicesNotAvailableTitle",
    HEAVY_DUTY_MACHINERY_SERVICES_NOT_AVAILABLE_DESCRIPTION: "heavyDutyMachineryServicesNotAvailableDescription",
    HEAVY_DUTY_MACHINERY_SERVICE_EDIT_BUTTON: "heavyDutyMachineryServiceEditButton",
    HEAVY_DUTY_MACHINERY_SERVICE_ACTIVE_STATUS: "heavyDutyMachineryServiceActiveStatus",
    HEAVY_DUTY_MACHINERY_SERVICE_INACTIVE_STATUS: "heavyDutyMachineryServiceInactiveStatus",
    HEAVY_DUTY_MACHINERY_SERVICE_DEACTIVATE_BUTTON: "heavyDutyMachineryServiceDeactivateButton",
    HEAVY_DUTY_MACHINERY_SERVICE_REACTIVATE_BUTTON: "heavyDutyMachineryServiceReactivateButton",
    HEAVY_DUTY_MACHINERY_SERVICE_STATUS_UPDATE_ERROR: "heavyDutyMachineryServiceStatusUpdateError",

    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_OPERACION_MAQUINARIA: "heavyDutyMachineryOptServiceCategoryOperacionMaquinaria",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_JARDINERIA: "heavyDutyMachineryOptServiceCategoryJardineria",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_TRANSPORTE: "heavyDutyMachineryOptServiceCategoryTransporte",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_MANTENIMIENTO: "heavyDutyMachineryOptServiceCategoryMantenimiento",

    HEAVY_DUTY_MACHINERY_OPT_SERVICE_SECTOR_CONSTRUCCION: "heavyDutyMachineryOptServiceSectorConstruccion",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_SECTOR_INSTALACIONES: "heavyDutyMachineryOptServiceSectorInstalaciones",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_SECTOR_ELECTRICIDAD: "heavyDutyMachineryOptServiceSectorElectricidad",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_SECTOR_RURAL: "heavyDutyMachineryOptServiceSectorRural",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_SECTOR_CARPINTERIA: "heavyDutyMachineryOptServiceSectorCarpinteria",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_SECTOR_OFICIOS_TRADICIONALES: "heavyDutyMachineryOptServiceSectorOficiosTradicionales",

    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_ALBANIL: "heavyDutyMachineryOptServiceCategoryAlbanil",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_ENCOFRADOR: "heavyDutyMachineryOptServiceCategoryEncofrador",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_FERRALLISTA: "heavyDutyMachineryOptServiceCategoryFerrallista",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_ESTRUCTURISTA: "heavyDutyMachineryOptServiceCategoryEstructurista",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_CANTERO_GEMOLOGO_OBRA: "heavyDutyMachineryOptServiceCategoryCanteroGemologoObra",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_MONTADOR_PLACA_YESO_LAMINADO: "heavyDutyMachineryOptServiceCategoryMontadorPlacaYesoLaminado",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_YESERO_REVOCADOR: "heavyDutyMachineryOptServiceCategoryYeseroRevocador",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_PINTOR_OBRA: "heavyDutyMachineryOptServiceCategoryPintorObra",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_SOLADOR_ALICATADOR: "heavyDutyMachineryOptServiceCategorySoladorAlicatador",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_PARQUETISTA_INSTALADOR_SUELOS: "heavyDutyMachineryOptServiceCategoryParquetistaInstaladorSuelos",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_TECHADOR_TEJERO: "heavyDutyMachineryOptServiceCategoryTechadorTejero",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_IMPERMEABILIZADOR: "heavyDutyMachineryOptServiceCategoryImpermeabilizador",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_AISLADOR_TERMICO_ACUSTICO: "heavyDutyMachineryOptServiceCategoryAisladorTermicoAcustico",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_GRUISTA_OPERADOR_GRUA_TORRE: "heavyDutyMachineryOptServiceCategoryGruistaOperadorGruaTorre",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_MAQUINISTA_MOVIMIENTO_TIERRAS: "heavyDutyMachineryOptServiceCategoryMaquinistaMovimientoTierras",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_ENCOFRADOR_POZOS_TUNELADORA: "heavyDutyMachineryOptServiceCategoryEncofradorPozosTuneladora",

    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_FONTANERO: "heavyDutyMachineryOptServiceCategoryFontanero",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_CALEFACTOR_INSTALADOR_TERMICO: "heavyDutyMachineryOptServiceCategoryCalefactorInstaladorTermico",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_INSTALADOR_CLIMATIZACION_RITE: "heavyDutyMachineryOptServiceCategoryInstaladorClimatizacionRite",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_INSTALADOR_AEROTERMIA_GEOTERMIA: "heavyDutyMachineryOptServiceCategoryInstaladorAerotermiaGeotermia",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_GASISTA_TECNICO_GAS: "heavyDutyMachineryOptServiceCategoryGasistaTecnicoGas",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_MANTENEDOR_PISCINAS_HIDRAULICAS: "heavyDutyMachineryOptServiceCategoryMantenedorPiscinasHidraulicas",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_INSTALADOR_REDES_INCENDIOS: "heavyDutyMachineryOptServiceCategoryInstaladorRedesIncendios",

    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_ELECTRICISTA_BAJA_TENSION: "heavyDutyMachineryOptServiceCategoryElectricistaBajaTension",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_ELECTRICISTA_ALTA_TENSION_LINIERO: "heavyDutyMachineryOptServiceCategoryElectricistaAltaTensionLiniero",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_INSTALADOR_FOTOVOLTAICO: "heavyDutyMachineryOptServiceCategoryInstaladorFotovoltaico",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_TECNICO_DOMOTICA_AUTOMATISMOS: "heavyDutyMachineryOptServiceCategoryTecnicoDomoticaAutomatismos",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_TELECOMUNICADOR_ANTENISTA: "heavyDutyMachineryOptServiceCategoryTelecomunicadorAntenista",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_TECNICO_VIDEOVIGILANCIA_ALARMAS: "heavyDutyMachineryOptServiceCategoryTecnicoVideovigilanciaAlarmas",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_BOBINADOR_TECNICO_MOTORES_ELECTRICOS: "heavyDutyMachineryOptServiceCategoryBobinadorTecnicoMotoresElectricos",

    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_JARDINERO: "heavyDutyMachineryOptServiceCategoryJardinero",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_PODADOR_ALTURA_ARBORISTA: "heavyDutyMachineryOptServiceCategoryPodadorAlturaArborista",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_INSTALADOR_SISTEMAS_RIEGO: "heavyDutyMachineryOptServiceCategoryInstaladorSistemasRiego",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_AGRICULTOR_TRABAJOS_AGRICOLAS: "heavyDutyMachineryOptServiceCategoryAgricultorTrabajosAgricolas",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_TRACTORISTA_MAQUINISTA_AGRICOLA: "heavyDutyMachineryOptServiceCategoryTractoristaMaquinistaAgricola",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_MOTOSERRISTA_OPERARIO_FORESTAL: "heavyDutyMachineryOptServiceCategoryMotoserristaOperarioForestal",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_GANADERO: "heavyDutyMachineryOptServiceCategoryGanadero",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_PASTOR: "heavyDutyMachineryOptServiceCategoryPastor",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_APICULTOR: "heavyDutyMachineryOptServiceCategoryApicultor",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_ENOLOGO_BODEGUERO: "heavyDutyMachineryOptServiceCategoryEnologoBodeguero",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_PISCICULTOR: "heavyDutyMachineryOptServiceCategoryPiscicultor",

    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_CARPINTERO_MADERA: "heavyDutyMachineryOptServiceCategoryCarpinteroMadera",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_CARPINTERO_METALICO_ALUMINIO_PVC: "heavyDutyMachineryOptServiceCategoryCarpinteroMetalicoAluminioPvc",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_CERRAJERO: "heavyDutyMachineryOptServiceCategoryCerrajero",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_SOLDADOR: "heavyDutyMachineryOptServiceCategorySoldador",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_FERRALLISTA_ARTESANAL_HERRERO: "heavyDutyMachineryOptServiceCategoryFerrallistaArtesanalHerrero",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_CRISTALERO_CRISTALERA: "heavyDutyMachineryOptServiceCategoryCristaleroCristalera",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_MONTADOR_TOLDOS_PERGOLAS: "heavyDutyMachineryOptServiceCategoryMontadorToldosPergolas",

    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_PIEDRISTA_MARGENERO: "heavyDutyMachineryOptServiceCategoryPiedristaMargenero",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_TEJEDOR_CAIZO_MIMBRERO: "heavyDutyMachineryOptServiceCategoryTejedorCaizoMimbrero",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_POZO_AGUA_POCERO: "heavyDutyMachineryOptServiceCategoryPozoAguaPocero",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_TECNICO_DESATASCOS: "heavyDutyMachineryOptServiceCategoryTecnicoDesatascos",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_MONTADOR_ANDAMIOS: "heavyDutyMachineryOptServiceCategoryMontadorAndamios",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_OPERARIO_LIMPIEZA_FIN_OBRA: "heavyDutyMachineryOptServiceCategoryOperarioLimpiezaFinObra",
    HEAVY_DUTY_MACHINERY_OPT_SERVICE_CATEGORY_DESAMIANTADOR: "heavyDutyMachineryOptServiceCategoryDesamiantador",

    HEAVY_DUTY_MACHINERY_OPT_PRICING_MODE_HOURLY: "heavyDutyMachineryOptPricingModeHourly",
    HEAVY_DUTY_MACHINERY_OPT_PRICING_MODE_FIXED_JOB: "heavyDutyMachineryOptPricingModeFixedJob",
    HEAVY_DUTY_MACHINERY_OPT_PRICING_MODE_BOTH: "heavyDutyMachineryOptPricingModeBoth",

    WIZARD_PHASE_SERVICE_CATEGORY_TITLE: "wizardPhaseServiceCategoryTitle",
    WIZARD_PHASE_SERVICE_CATEGORY_SUBTITLE: "wizardPhaseServiceCategorySubtitle",
    WIZARD_PHASE_SERVICE_LOCATION_TITLE: "wizardPhaseServiceLocationTitle",
    WIZARD_PHASE_SERVICE_LOCATION_SUBTITLE: "wizardPhaseServiceLocationSubtitle",
    WIZARD_PHASE_SERVICE_PRICING_TITLE: "wizardPhaseServicePricingTitle",
    WIZARD_PHASE_SERVICE_PRICING_SUBTITLE: "wizardPhaseServicePricingSubtitle",
    WIZARD_PHASE_SERVICE_EXTRAS_TITLE: "wizardPhaseServiceExtrasTitle",
    WIZARD_PHASE_SERVICE_EXTRAS_SUBTITLE: "wizardPhaseServiceExtrasSubtitle",

    HEAVY_DUTY_MACHINERY_SERVICE_CATEGORY_LABEL: "heavyDutyMachineryServiceCategoryLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_TITLE_LABEL: "heavyDutyMachineryServiceTitleLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_DESCRIPTION_LABEL: "heavyDutyMachineryServiceDescriptionLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_DESCRIPTION_PLACEHOLDER: "heavyDutyMachineryServiceDescriptionPlaceholder",
    HEAVY_DUTY_MACHINERY_SERVICE_COUNTRY_LABEL: "heavyDutyMachineryServiceCountryLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_HOST_CURRENCY_LABEL: "heavyDutyMachineryServiceHostCurrencyLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_PRICING_MODE_LABEL: "heavyDutyMachineryServicePricingModeLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_HOURLY_RATE_LABEL: "heavyDutyMachineryServiceHourlyRateLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_FIXED_JOB_PRICE_LABEL: "heavyDutyMachineryServiceFixedJobPriceLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_DEPOSIT_AMOUNT_LABEL: "heavyDutyMachineryServiceDepositAmountLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_DEPOSIT_MACHINERY_NOTE: "heavyDutyMachineryServiceDepositMachineryNote",

    HEAVY_DUTY_MACHINERY_SERVICE_SAVE_AND_CONTINUE_BUTTON: "heavyDutyMachineryServiceSaveAndContinueButton",
    HEAVY_DUTY_MACHINERY_SERVICE_FINISH_BUTTON: "heavyDutyMachineryServiceFinishButton",
    HEAVY_DUTY_MACHINERY_SERVICE_SAVE_SUCCESS: "heavyDutyMachineryServiceSaveSuccess",
    HEAVY_DUTY_MACHINERY_SERVICE_SAVE_ERROR: "heavyDutyMachineryServiceSaveError",
    HEAVY_DUTY_MACHINERY_SERVICE_NO_PROVIDER_PROFILE_ERROR: "heavyDutyMachineryServiceNoProviderProfileError",
    HEAVY_DUTY_MACHINERY_SERVICE_NOT_FOUND: "heavyDutyMachineryServiceNotFound",
    HEAVY_DUTY_MACHINERY_SERVICE_AVAILABILITY_LOAD_ERROR: "heavyDutyMachineryServiceAvailabilityLoadError",

    HEAVY_DUTY_MACHINERY_SERVICE_COMPATIBILITY_TITLE: "heavyDutyMachineryServiceCompatibilityTitle",
    HEAVY_DUTY_MACHINERY_SERVICE_COMPATIBILITY_HINT: "heavyDutyMachineryServiceCompatibilityHint",
    HEAVY_DUTY_MACHINERY_SERVICE_COMPATIBILITY_CATEGORY_LABEL: "heavyDutyMachineryServiceCompatibilityCategoryLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_COMPATIBILITY_BRAND_LABEL: "heavyDutyMachineryServiceCompatibilityBrandLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_COMPATIBILITY_MODEL_LABEL: "heavyDutyMachineryServiceCompatibilityModelLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_COMPATIBILITY_ADD_BUTTON: "heavyDutyMachineryServiceCompatibilityAddButton",
    HEAVY_DUTY_MACHINERY_SERVICE_COMPATIBILITY_EMPTY: "heavyDutyMachineryServiceCompatibilityEmpty",
    HEAVY_DUTY_MACHINERY_SERVICE_COMPATIBILITY_ANY_BRAND: "heavyDutyMachineryServiceCompatibilityAnyBrand",
    HEAVY_DUTY_MACHINERY_SERVICE_COMPATIBILITY_ADD_ERROR: "heavyDutyMachineryServiceCompatibilityAddError",
    HEAVY_DUTY_MACHINERY_SERVICE_COMPATIBILITY_REMOVE_ERROR: "heavyDutyMachineryServiceCompatibilityRemoveError",

    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ONS_TITLE: "heavyDutyMachineryServiceAddOnsTitle",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ONS_HINT: "heavyDutyMachineryServiceAddOnsHint",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_TITLE_LABEL: "heavyDutyMachineryServiceAddOnTitleLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_PRICE_LABEL: "heavyDutyMachineryServiceAddOnPriceLabel",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_ADD_BUTTON: "heavyDutyMachineryServiceAddOnAddButton",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_EMPTY: "heavyDutyMachineryServiceAddOnEmpty",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_SAVE_ERROR: "heavyDutyMachineryServiceAddOnSaveError",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_ACTIVE_STATUS: "heavyDutyMachineryServiceAddOnActiveStatus",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_INACTIVE_STATUS: "heavyDutyMachineryServiceAddOnInactiveStatus",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_EDIT_BUTTON: "heavyDutyMachineryServiceAddOnEditButton",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_SAVE_BUTTON: "heavyDutyMachineryServiceAddOnSaveButton",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_CANCEL_BUTTON: "heavyDutyMachineryServiceAddOnCancelButton",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_PAUSE_BUTTON: "heavyDutyMachineryServiceAddOnPauseButton",
    HEAVY_DUTY_MACHINERY_SERVICE_ADD_ON_RESUME_BUTTON: "heavyDutyMachineryServiceAddOnResumeButton",
    HEAVY_DUTY_MACHINERY_SERVICES_NO_PROVIDER_PROFILE_BUTTON: "heavyDutyMachineryServicesNoProviderProfileButton",

    // ===== SERVICE PROVIDER ONBOARDING (Fase 13 -- ServiceProviderProfileController) =====
    SERVICE_PROVIDER_ONBOARDING_TITLE: "serviceProviderOnboardingTitle",
    SERVICE_PROVIDER_ONBOARDING_INTRO: "serviceProviderOnboardingIntro",
    SERVICE_PROVIDER_ONBOARDING_STEP_PROFILE: "serviceProviderOnboardingStepProfile",
    SERVICE_PROVIDER_ONBOARDING_STEP_PAYMENTS: "serviceProviderOnboardingStepPayments",
    SERVICE_PROVIDER_ONBOARDING_SUCCESS: "serviceProviderOnboardingSuccess",
    SERVICE_PROVIDER_ONBOARDING_ERROR: "serviceProviderOnboardingError",
    SERVICE_PROVIDER_ONBOARDING_PAYMENTS_INTRO: "serviceProviderOnboardingPaymentsIntro",
    SERVICE_PROVIDER_ONBOARDING_SKIP_STRIPE: "serviceProviderOnboardingSkipStripe",
    SERVICE_PROVIDER_ONBOARDING_ALREADY_VERIFIED: "serviceProviderOnboardingAlreadyVerified",
    SERVICE_PROVIDER_ONBOARDING_DONE_BUTTON: "serviceProviderOnboardingDoneButton",

    SERVICE_PROVIDER_FIELD_FULL_NAME: "serviceProviderFieldFullName",
    SERVICE_PROVIDER_FIELD_DISPLAY_NAME: "serviceProviderFieldDisplayName",
    SERVICE_PROVIDER_FIELD_DISPLAY_NAME_HINT: "serviceProviderFieldDisplayNameHint",
    SERVICE_PROVIDER_FIELD_BIO: "serviceProviderFieldBio",
    SERVICE_PROVIDER_FIELD_SHARED_AVAILABILITY: "serviceProviderFieldSharedAvailability",
    SERVICE_PROVIDER_FIELD_SHARED_AVAILABILITY_HINT: "serviceProviderFieldSharedAvailabilityHint",

    // SERVICE_CARD_FIXED_JOB_PRICE_LABEL is the only survivor of the removed
    // ServiceSearchCard/ServicesSearch pair (see git history) -- ServiceDetail
    // still uses it for its own FixedJob price line.
    SERVICE_CARD_FIXED_JOB_PRICE_LABEL: "serviceCardFixedJobPriceLabel",

    // ===== SERVICE DETAIL + CHECKOUT (Fase 13 -- POST /service-bookings) =====
    SERVICE_DETAIL_LOGIN_REQUIRED: "serviceDetailLoginRequired",
    SERVICE_DETAIL_START_LABEL: "serviceDetailStartLabel",
    SERVICE_DETAIL_DURATION_LABEL: "serviceDetailDurationLabel",
    SERVICE_DETAIL_DURATION_HOURS_SUFFIX: "serviceDetailDurationHoursSuffix",
    SERVICE_DETAIL_DURATION_FIXED_JOB_HINT: "serviceDetailDurationFixedJobHint",
    SERVICE_DETAIL_PRICE_PREVIEW_LABEL: "serviceDetailPricePreviewLabel",
    SERVICE_DETAIL_DEPOSIT_NOTE: "serviceDetailDepositNote",
    SERVICE_DETAIL_CANCELLATION_POLICY_LABEL: "serviceDetailCancellationPolicyLabel",
    SERVICE_DETAIL_WAIVER_LABEL: "serviceDetailWaiverLabel",
    SERVICE_DETAIL_WAIVER_REQUIRED_ERROR: "serviceDetailWaiverRequiredError",
    SERVICE_DETAIL_RESERVE_BUTTON: "serviceDetailReserveButton",
    SERVICE_DETAIL_BOOKING_ERROR: "serviceDetailBookingError",
    SERVICE_DETAIL_SLOT_TAKEN_ERROR: "serviceDetailSlotTakenError",
    SERVICE_DETAIL_INVALID_RANGE_ERROR: "serviceDetailInvalidRangeError",

    HEAVY_DUTY_MACHINERY_BOOKING_SERVICES_LABEL: "heavyDutyMachineryBookingServicesLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_SERVICE_PROVIDER_OWN_STAFF: "heavyDutyMachineryBookingServiceProviderOwnStaff",
    HEAVY_DUTY_MACHINERY_BOOKING_SERVICE_PROVIDER_INDEPENDENT: "heavyDutyMachineryBookingServiceProviderIndependent",
    HEAVY_DUTY_MACHINERY_BOOKING_SERVICE_PROVIDER_OTHER_STAFF: "heavyDutyMachineryBookingServiceProviderOtherStaff",
    HEAVY_DUTY_MACHINERY_BOOKING_SERVICE_STANDALONE_ONLY_LABEL: "heavyDutyMachineryBookingServiceStandaloneOnlyLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_SERVICE_DEPOSIT_BLOCKED_MESSAGE: "heavyDutyMachineryBookingServiceDepositBlockedMessage",

    HEAVY_DUTY_MACHINERY_BOOKING_ACCESSORIES_LABEL: "heavyDutyMachineryBookingAccessoriesLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_ACCESSORIES_COST_LABEL: "heavyDutyMachineryBookingAccessoriesCostLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_ACCESSORIES_ADD_BUTTON: "heavyDutyMachineryBookingAccessoriesAddButton",
    HEAVY_DUTY_MACHINERY_BOOKING_ACCESSORIES_EMPTY_TITLE: "heavyDutyMachineryBookingAccessoriesEmptyTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_ACCESSORIES_EMPTY_DESCRIPTION: "heavyDutyMachineryBookingAccessoriesEmptyDescription",
    HEAVY_DUTY_MACHINERY_BOOKING_ACCESSORIES_EDIT_BUTTON: "heavyDutyMachineryBookingAccessoriesEditButton",
    HEAVY_DUTY_MACHINERY_BOOKING_ACCESSORIES_SHEET_TITLE: "heavyDutyMachineryBookingAccessoriesSheetTitle",
    HEAVY_DUTY_MACHINERY_BOOKING_ACCESSORIES_DONE_BUTTON: "heavyDutyMachineryBookingAccessoriesDoneButton",
    HEAVY_DUTY_MACHINERY_BOOKING_ACCESSORIES_COST_PENDING: "heavyDutyMachineryBookingAccessoriesCostPending",
    HEAVY_DUTY_MACHINERY_BOOKING_ACCESSORY_UNAVAILABLE_LABEL: "heavyDutyMachineryBookingAccessoryUnavailableLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_ACCESSORY_AVAILABLE_FROM_LABEL: "heavyDutyMachineryBookingAccessoryAvailableFromLabel",

    HEAVY_DUTY_MACHINERY_ACTIVE_RENTAL_CARD_TITLE: "heavyDutyMachineryActiveRentalCardTitle",
    HEAVY_DUTY_MACHINERY_ACTIVE_RENTAL_HOURS_CONSUMED_LABEL: "heavyDutyMachineryActiveRentalHoursConsumedLabel",
    HEAVY_DUTY_MACHINERY_ACTIVE_RENTAL_NO_LIVE_DATA: "heavyDutyMachineryActiveRentalNoLiveData",

    HEAVY_DUTY_MACHINERY_DELETE_SUCCESS: "heavyDutyMachineryDeleteSuccess",
    HEAVY_DUTY_MACHINERY_DELETE_ERROR: "heavyDutyMachineryDeleteError",
    HEAVY_DUTY_MACHINERY_MY_SPACES_PAGE_SUBTITLE: "heavyDutyMachineryMySpacesPageSubtitle",
    HEAVY_DUTY_MACHINERY_MY_SPACES_EMPTY: "heavyDutyMachineryMySpacesEmpty",
    HEAVY_DUTY_MACHINERY_MY_SPACES_EMPTY_DESCRIPTION: "heavyDutyMachineryMySpacesEmptyDescription",
    HEAVY_DUTY_MACHINERY_MY_SPACES_LOAD_ERROR: "heavyDutyMachineryMySpacesLoadError",
    HEAVY_DUTY_MACHINERY_MY_SPACES_LOAD_ERROR_DESCRIPTION: "heavyDutyMachineryMySpacesLoadErrorDescription",
    HEAVY_DUTY_MACHINERY_MY_SPACES_RETRY_BUTTON: "heavyDutyMachineryMySpacesRetryButton",

    HEAVY_DUTY_MACHINERY_MY_BOOKINGS_NAV_BUTTON: "heavyDutyMachineryMyBookingsNavButton",
    HEAVY_DUTY_MACHINERY_MY_BOOKINGS_TITLE: "heavyDutyMachineryMyBookingsTitle",
    HEAVY_DUTY_MACHINERY_MY_BOOKINGS_TAB_UPCOMING: "heavyDutyMachineryMyBookingsTabUpcoming",
    HEAVY_DUTY_MACHINERY_MY_BOOKINGS_TAB_PAST: "heavyDutyMachineryMyBookingsTabPast",
    HEAVY_DUTY_MACHINERY_MY_BOOKINGS_EMPTY_UPCOMING: "heavyDutyMachineryMyBookingsEmptyUpcoming",
    HEAVY_DUTY_MACHINERY_MY_BOOKINGS_EMPTY_UPCOMING_DESCRIPTION: "heavyDutyMachineryMyBookingsEmptyUpcomingDescription",
    HEAVY_DUTY_MACHINERY_MY_BOOKINGS_EMPTY_PAST: "heavyDutyMachineryMyBookingsEmptyPast",
    HEAVY_DUTY_MACHINERY_MY_BOOKINGS_EMPTY_PAST_DESCRIPTION: "heavyDutyMachineryMyBookingsEmptyPastDescription",
    HEAVY_DUTY_MACHINERY_MY_BOOKINGS_LOAD_ERROR: "heavyDutyMachineryMyBookingsLoadError",

    HEAVY_DUTY_MACHINERY_FAVORITES_TITLE: "heavyDutyMachineryFavoritesTitle",
    HEAVY_DUTY_MACHINERY_FAVORITES_EMPTY: "heavyDutyMachineryFavoritesEmpty",
    HEAVY_DUTY_MACHINERY_FAVORITES_EMPTY_DESCRIPTION: "heavyDutyMachineryFavoritesEmptyDescription",
    HEAVY_DUTY_MACHINERY_FAVORITES_LOAD_ERROR: "heavyDutyMachineryFavoritesLoadError",
    HEAVY_DUTY_MACHINERY_FAVORITE_LOGIN_REQUIRED: "heavyDutyMachineryFavoriteLoginRequired",
    HEAVY_DUTY_MACHINERY_FAVORITE_ADD_ERROR: "heavyDutyMachineryFavoriteAddError",
    HEAVY_DUTY_MACHINERY_FAVORITE_REMOVE_ERROR: "heavyDutyMachineryFavoriteRemoveError",

    HEAVY_DUTY_MACHINERY_BOOKING_RESUME_PAYMENT_BUTTON: "heavyDutyMachineryBookingResumePaymentButton",
    HEAVY_DUTY_MACHINERY_BOOKING_RESUME_PAYMENT_ERROR: "heavyDutyMachineryBookingResumePaymentError",
    HEAVY_DUTY_MACHINERY_BOOKING_CANCEL_BUTTON: "heavyDutyMachineryBookingCancelButton",
    HEAVY_DUTY_MACHINERY_BOOKING_CANCEL_CONFIRM: "heavyDutyMachineryBookingCancelConfirm",
    HEAVY_DUTY_MACHINERY_BOOKING_CANCEL_SHEET_KEEP: "heavyDutyMachineryBookingCancelSheetKeep",
    HEAVY_DUTY_MACHINERY_BOOKING_CANCEL_REFUND_NOTE: "heavyDutyMachineryBookingCancelRefundNote",
    HEAVY_DUTY_MACHINERY_BOOKING_CANCEL_SHEET_CONFIRM: "heavyDutyMachineryBookingCancelSheetConfirm",
    HEAVY_DUTY_MACHINERY_BOOKING_CANCEL_SUCCESS: "heavyDutyMachineryBookingCancelSuccess",
    HEAVY_DUTY_MACHINERY_BOOKING_CANCEL_ERROR: "heavyDutyMachineryBookingCancelError",
    HEAVY_DUTY_MACHINERY_BOOKING_ADDRESS_LABEL: "heavyDutyMachineryBookingAddressLabel",

    HEAVY_DUTY_MACHINERY_HOST_CANCEL_BUTTON: "heavyDutyMachineryHostCancelButton",
    HEAVY_DUTY_MACHINERY_HOST_CANCEL_MODAL_TITLE: "heavyDutyMachineryHostCancelModalTitle",
    HEAVY_DUTY_MACHINERY_HOST_CANCEL_LABEL: "heavyDutyMachineryHostCancelLabel",
    HEAVY_DUTY_MACHINERY_HOST_CANCEL_PLACEHOLDER: "heavyDutyMachineryHostCancelPlaceholder",
    HEAVY_DUTY_MACHINERY_HOST_CANCEL_CONFIRM_BUTTON: "heavyDutyMachineryHostCancelConfirmButton",
    HEAVY_DUTY_MACHINERY_HOST_CANCEL_REASON_REQUIRED: "heavyDutyMachineryHostCancelReasonRequired",
    HEAVY_DUTY_MACHINERY_HOST_CANCEL_SUCCESS: "heavyDutyMachineryHostCancelSuccess",
    HEAVY_DUTY_MACHINERY_HOST_CANCEL_ERROR: "heavyDutyMachineryHostCancelError",
    HEAVY_DUTY_MACHINERY_HOST_CANCEL_REASON_LABEL: "heavyDutyMachineryHostCancelReasonLabel",

    // ===== Reserva diferida -- host/guest quote-negotiation actions =====
    HEAVY_DUTY_MACHINERY_QUOTE_ACCEPT_BUTTON: "heavyDutyMachineryQuoteAcceptButton",
    QUOTE_BREAKDOWN_TITLE: "quoteBreakdownTitle",
    QUOTE_EDITOR_TITLE_REQUIRED: "quoteEditorTitleRequired",
    QUOTE_EDITOR_LOCKED_HINT: "quoteEditorLockedHint",
    QUOTE_EDITOR_TITLE_PLACEHOLDER: "quoteEditorTitlePlaceholder",
    QUOTE_EDITOR_DESCRIPTION_PLACEHOLDER: "quoteEditorDescriptionPlaceholder",
    QUOTE_EDITOR_REMOVE_LINE: "quoteEditorRemoveLine",
    QUOTE_EDITOR_ADD_LINE: "quoteEditorAddLine",
    QUOTE_EDITOR_TOTAL: "quoteEditorTotal",

    // ===== Presupuesto asistido -- itemised editor + describe-the-job draft =====
    QUOTE_EDITOR_QUANTITY_PLACEHOLDER: "quoteEditorQuantityPlaceholder",
    QUOTE_EDITOR_UNIT_PLACEHOLDER: "quoteEditorUnitPlaceholder",
    QUOTE_EDITOR_UNIT_PRICE_PLACEHOLDER: "quoteEditorUnitPricePlaceholder",
    QUOTE_EDITOR_AMOUNT_PLACEHOLDER: "quoteEditorAmountPlaceholder",
    QUOTE_EDITOR_TO_METERED: "quoteEditorToMetered",
    QUOTE_EDITOR_TO_FLAT: "quoteEditorToFlat",
    QUOTE_EDITOR_ESTIMATED_WARNING: "quoteEditorEstimatedWarning",
    QUOTE_PRICE_SOURCE_ESTIMATED: "quotePriceSourceEstimated",
    QUOTE_PRICE_SOURCE_PROVIDER_RATE: "quotePriceSourceProviderRate",
    QUOTE_DRAFT_TITLE: "quoteDraftTitle",
    QUOTE_DRAFT_DESCRIPTION_PLACEHOLDER: "quoteDraftDescriptionPlaceholder",
    QUOTE_DRAFT_TRADE_PLACEHOLDER: "quoteDraftTradePlaceholder",
    QUOTE_DRAFT_GENERATE: "quoteDraftGenerate",
    QUOTE_DRAFT_REGENERATE: "quoteDraftRegenerate",
    QUOTE_DRAFT_TOO_SHORT: "quoteDraftTooShort",
    QUOTE_DRAFT_ERROR: "quoteDraftError",
    QUOTE_DRAFT_EMPTY: "quoteDraftEmpty",
    QUOTE_DRAFT_UNAVAILABLE: "quoteDraftUnavailable",
    QUOTE_DRAFT_NOTES_TITLE: "quoteDraftNotesTitle",
    QUOTE_DRAFT_CATALOG_HINT: "quoteDraftCatalogHint",
    QUOTE_DRAFT_CATALOG_LINK: "quoteDraftCatalogLink",

    // ===== Dictado y edición por voz =====
    DICTATE_START: "dictateStart",
    DICTATE_STOP: "dictateStop",
    DICTATE_ERROR: "dictateError",
    QUOTE_DRAFT_LISTENING: "quoteDraftListening",
    QUOTE_VOICE_EDIT_TITLE: "quoteVoiceEditTitle",
    QUOTE_VOICE_EDIT_PLACEHOLDER: "quoteVoiceEditPlaceholder",
    QUOTE_VOICE_EDIT_LISTENING: "quoteVoiceEditListening",
    QUOTE_VOICE_EDIT_APPLY: "quoteVoiceEditApply",
    QUOTE_VOICE_EDIT_HINT: "quoteVoiceEditHint",
    QUOTE_VOICE_EDIT_TOO_SHORT: "quoteVoiceEditTooShort",
    QUOTE_VOICE_EDIT_ERROR: "quoteVoiceEditError",
    QUOTE_VOICE_EDIT_APPLIED: "quoteVoiceEditApplied",
    QUOTE_VOICE_EDIT_UNDO: "quoteVoiceEditUndo",

    // ===== Pedir presupuesto a un servicio (sin elegir fecha) =====
    SERVICE_REQUEST_TITLE: "serviceRequestTitle",
    SERVICE_REQUEST_SUBTITLE: "serviceRequestSubtitle",
    SERVICE_REQUEST_SUBTITLE_WITH_SERVICE: "serviceRequestSubtitleWithService",
    SERVICE_REQUEST_DESCRIPTION_LABEL: "serviceRequestDescriptionLabel",
    SERVICE_REQUEST_DESCRIPTION_PLACEHOLDER: "serviceRequestDescriptionPlaceholder",
    SERVICE_REQUEST_LISTENING: "serviceRequestListening",
    SERVICE_REQUEST_DESCRIPTION_TOO_SHORT: "serviceRequestDescriptionTooShort",
    SERVICE_REQUEST_URGENCY_LABEL: "serviceRequestUrgencyLabel",
    SERVICE_REQUEST_URGENCY_FLEXIBLE: "serviceRequestUrgencyFlexible",
    SERVICE_REQUEST_URGENCY_THIS_WEEK: "serviceRequestUrgencyThisWeek",
    SERVICE_REQUEST_URGENCY_URGENT: "serviceRequestUrgencyUrgent",
    SERVICE_REQUEST_WHERE_LABEL: "serviceRequestWhereLabel",
    SERVICE_REQUEST_CITY_PLACEHOLDER: "serviceRequestCityPlaceholder",
    SERVICE_REQUEST_ADDRESS_PLACEHOLDER: "serviceRequestAddressPlaceholder",
    SERVICE_REQUEST_SEND: "serviceRequestSend",
    SERVICE_REQUEST_SENT: "serviceRequestSent",
    SERVICE_REQUEST_SEND_ERROR: "serviceRequestSendError",
    SERVICE_REQUEST_NO_COMMITMENT: "serviceRequestNoCommitment",
    SERVICE_REQUEST_LOAD_ERROR: "serviceRequestLoadError",
    SERVICE_REQUEST_ACTION_ERROR: "serviceRequestActionError",
    SERVICE_REQUESTS_NAV_LABEL: "serviceRequestsNavLabel",
    SERVICE_REQUESTS_TITLE: "serviceRequestsTitle",
    SERVICE_REQUESTS_SIDE_MINE: "serviceRequestsSideMine",
    SERVICE_REQUESTS_SIDE_INCOMING: "serviceRequestsSideIncoming",
    MY_RATE_CATALOG_NAV_LABEL: "myRateCatalogNavLabel",
    SERVICE_REQUESTS_MINE_TITLE: "serviceRequestsMineTitle",
    SERVICE_REQUESTS_INCOMING_TITLE: "serviceRequestsIncomingTitle",
    SERVICE_REQUESTS_FILTER_OPEN: "serviceRequestsFilterOpen",
    SERVICE_REQUESTS_FILTER_ALL: "serviceRequestsFilterAll",
    SERVICE_REQUESTS_EMPTY_MINE: "serviceRequestsEmptyMine",
    SERVICE_REQUESTS_EMPTY_MINE_HINT: "serviceRequestsEmptyMineHint",
    SERVICE_REQUESTS_EMPTY_INCOMING: "serviceRequestsEmptyIncoming",
    SERVICE_REQUESTS_EMPTY_INCOMING_HINT: "serviceRequestsEmptyIncomingHint",
    SERVICE_REQUEST_HOURS_LEFT: "serviceRequestHoursLeft",
    SERVICE_REQUEST_STATUS_SENT: "serviceRequestStatusSent",
    SERVICE_REQUEST_STATUS_QUOTED: "serviceRequestStatusQuoted",
    SERVICE_REQUEST_STATUS_ACCEPTED: "serviceRequestStatusAccepted",
    SERVICE_REQUEST_STATUS_DECLINED: "serviceRequestStatusDeclined",
    SERVICE_REQUEST_STATUS_EXPIRED: "serviceRequestStatusExpired",
    SERVICE_REQUEST_STATUS_CANCELLED: "serviceRequestStatusCancelled",
    SERVICE_REQUEST_STATUS_CONVERTED: "serviceRequestStatusConverted",
    SERVICE_REQUEST_NO_SERVICE_TITLE: "serviceRequestNoServiceTitle",
    SERVICE_REQUEST_CURRENT_QUOTE: "serviceRequestCurrentQuote",
    SERVICE_REQUEST_PROPOSED_WINDOW: "serviceRequestProposedWindow",
    SERVICE_REQUEST_OPEN_CHAT: "serviceRequestOpenChat",
    SERVICE_REQUEST_QUOTE_IT: "serviceRequestQuoteIt",
    SERVICE_REQUEST_REQUOTE: "serviceRequestRequote",
    SERVICE_REQUEST_SEND_QUOTE: "serviceRequestSendQuote",
    SERVICE_REQUEST_QUOTED_TOAST: "serviceRequestQuotedToast",
    SERVICE_REQUEST_WHAT_THEY_ASKED: "serviceRequestWhatTheyAsked",
    SERVICE_REQUEST_WINDOW_LABEL: "serviceRequestWindowLabel",
    SERVICE_REQUEST_ACCEPT: "serviceRequestAccept",
    SERVICE_REQUEST_ACCEPTED_TOAST: "serviceRequestAcceptedToast",
    SERVICE_REQUEST_DECLINE: "serviceRequestDecline",
    SERVICE_REQUEST_DECLINED_TOAST: "serviceRequestDeclinedToast",
    SERVICE_REQUEST_DECLINE_CONFIRM_TITLE: "serviceRequestDeclineConfirmTitle",
    SERVICE_REQUEST_DECLINE_CONFIRM_BODY: "serviceRequestDeclineConfirmBody",
    SERVICE_REQUEST_WITHDRAW: "serviceRequestWithdraw",
    SERVICE_REQUEST_WITHDRAWN_TOAST: "serviceRequestWithdrawnToast",
    SERVICE_REQUEST_WITHDRAW_CONFIRM_TITLE: "serviceRequestWithdrawConfirmTitle",
    SERVICE_REQUEST_WITHDRAW_CONFIRM_BODY: "serviceRequestWithdrawConfirmBody",
    SERVICE_REQUEST_WAITING_FOR_VISIT: "serviceRequestWaitingForVisit",
    SERVICE_REQUEST_CONFIRM_VISIT: "serviceRequestConfirmVisit",
    SERVICE_REQUEST_CONFIRM_VISIT_OK: "serviceRequestConfirmVisitOk",
    SERVICE_REQUEST_CONFIRM_VISIT_WARNING: "serviceRequestConfirmVisitWarning",
    SERVICE_REQUEST_VISIT_CONFIRMED: "serviceRequestVisitConfirmed",
    SERVICE_REQUEST_VISIT_WINDOW_REQUIRED: "serviceRequestVisitWindowRequired",
    SERVICE_REQUEST_VISIT_SERVICE_REQUIRED: "serviceRequestVisitServiceRequired",
    SERVICE_REQUEST_AGREED_PRICE: "serviceRequestAgreedPrice",
    SERVICE_REQUEST_BILL_UNDER: "serviceRequestBillUnder",
    SERVICE_REQUEST_BILL_UNDER_PLACEHOLDER: "serviceRequestBillUnderPlaceholder",
    SERVICE_REQUEST_OPEN_BOOKING: "serviceRequestOpenBooking",
    SERVICE_DETAIL_QUOTE_ONLY_HINT: "serviceDetailQuoteOnlyHint",
    SERVICE_DETAIL_REQUEST_QUOTE_BUTTON: "serviceDetailRequestQuoteButton",
    SERVICE_FORM_REQUEST_MODE_LABEL: "serviceFormRequestModeLabel",
    SERVICE_FORM_REQUEST_MODE_INSTANT: "serviceFormRequestModeInstant",
    SERVICE_FORM_REQUEST_MODE_QUOTE: "serviceFormRequestModeQuote",
    SERVICE_FORM_REQUEST_MODE_HINT: "serviceFormRequestModeHint",

    // ===== El asistente que ayuda al cliente a contar el problema =====
    JOB_CLARIFIER_TITLE: "jobClarifierTitle",
    JOB_CLARIFIER_HINT: "jobClarifierHint",
    JOB_CLARIFIER_ASK: "jobClarifierAsk",
    JOB_CLARIFIER_ERROR: "jobClarifierError",
    JOB_CLARIFIER_NOTHING_TO_ASK: "jobClarifierNothingToAsk",
    JOB_CLARIFIER_DONT_KNOW: "jobClarifierDontKnow",
    JOB_CLARIFIER_SUMMARY_TITLE: "jobClarifierSummaryTitle",
    JOB_CLARIFIER_SUMMARISING: "jobClarifierSummarising",
    JOB_CLARIFIER_SKIPPABLE: "jobClarifierSkippable",
    JOB_PHOTOS_LABEL: "jobPhotosLabel",
    JOB_PHOTOS_HINT: "jobPhotosHint",
    JOB_PHOTOS_ADD: "jobPhotosAdd",
    JOB_PHOTOS_MAX: "jobPhotosMax",
    JOB_PHOTOS_ERROR: "jobPhotosError",
    SERVICE_REQUEST_SUMMARY_LABEL: "serviceRequestSummaryLabel",
    SERVICE_REQUEST_ORIGINAL_LABEL: "serviceRequestOriginalLabel",
    QUOTE_BREAKDOWN_CURRENT_TOTAL: "quoteBreakdownCurrentTotal",
    QUOTE_BREAKDOWN_AMOUNT_TO_PAY: "quoteBreakdownAmountToPay",
    QUOTE_BREAKDOWN_PAY_BUTTON: "quoteBreakdownPayButton",
    QUOTE_ACCEPTED_AWAITING_PAYMENT_TITLE: "quoteAcceptedAwaitingPaymentTitle",
    QUOTE_ACCEPTED_AWAITING_PAYMENT_DESCRIPTION: "quoteAcceptedAwaitingPaymentDescription",
    QUOTE_ACCEPTED_AWAITING_PAYMENT_HOST_DESCRIPTION: "quoteAcceptedAwaitingPaymentHostDescription",
    QUOTE_BREAKDOWN_DEPOSIT_NOTE: "quoteBreakdownDepositNote",
    QUOTE_BREAKDOWN_HISTORY_TITLE: "quoteBreakdownHistoryTitle",
    QUOTE_BREAKDOWN_AUTOMATIC: "quoteBreakdownAutomatic",
    QUOTE_BREAKDOWN_PROPOSED_BY_ME: "quoteBreakdownProposedByMe",
    QUOTE_BREAKDOWN_PROPOSED_BY_THEM: "quoteBreakdownProposedByThem",
    QUOTE_BREAKDOWN_VERSION: "quoteBreakdownVersion",
    QUOTE_BREAKDOWN_DELIVERY_DETAIL: "quoteBreakdownDeliveryDetail",
    QUOTE_BREAKDOWN_DELIVERY_DETAIL_TWO_LEGS: "quoteBreakdownDeliveryDetailTwoLegs",
    QUOTE_BREAKDOWN_VIEW_BUTTON: "quoteBreakdownViewButton",
    QUOTE_AWAITING_HOST_TITLE: "quoteAwaitingHostTitle",
    QUOTE_AWAITING_GUEST_TITLE: "quoteAwaitingGuestTitle",
    QUOTE_AWAITING_GUEST_DESCRIPTION: "quoteAwaitingGuestDescription",
    QUOTE_YOUR_TURN_TITLE: "quoteYourTurnTitle",
    QUOTE_AWAITING_HOST_DESCRIPTION: "quoteAwaitingHostDescription",
    QUOTE_COUNTDOWN_LABEL_THEIRS: "quoteCountdownLabelTheirs",
    QUOTE_COUNTDOWN_LABEL_YOURS: "quoteCountdownLabelYours",
    QUOTE_COUNTDOWN_LABEL_PAY: "quoteCountdownLabelPay",
    QUOTE_COUNTDOWN_LABEL_THEIR_PAY: "quoteCountdownLabelTheirPay",
    QUOTE_COUNTDOWN_EXPIRED: "quoteCountdownExpired",
    QUOTE_COUNTDOWN_EXPIRED_PAY: "quoteCountdownExpiredPay",
    QUOTE_COUNTDOWN_UNIT_HOURS: "quoteCountdownUnitHours",
    QUOTE_COUNTDOWN_UNIT_MINUTES: "quoteCountdownUnitMinutes",
    QUOTE_COUNTDOWN_UNIT_SECONDS: "quoteCountdownUnitSeconds",
    HEAVY_DUTY_MACHINERY_QUOTE_ACCEPT_SUCCESS: "heavyDutyMachineryQuoteAcceptSuccess",
    HEAVY_DUTY_MACHINERY_QUOTE_ACCEPT_ERROR: "heavyDutyMachineryQuoteAcceptError",
    HEAVY_DUTY_MACHINERY_QUOTE_PROPOSE_BUTTON: "heavyDutyMachineryQuoteProposeButton",
    HEAVY_DUTY_MACHINERY_QUOTE_PROPOSE_MODAL_TITLE: "heavyDutyMachineryQuoteProposeModalTitle",
    HEAVY_DUTY_MACHINERY_QUOTE_PROPOSE_AMOUNT_LABEL: "heavyDutyMachineryQuoteProposeAmountLabel",
    HEAVY_DUTY_MACHINERY_QUOTE_PROPOSE_REASON_LABEL: "heavyDutyMachineryQuoteProposeReasonLabel",
    HEAVY_DUTY_MACHINERY_QUOTE_PROPOSE_REASON_PLACEHOLDER: "heavyDutyMachineryQuoteProposeReasonPlaceholder",
    HEAVY_DUTY_MACHINERY_QUOTE_PROPOSE_CONFIRM_BUTTON: "heavyDutyMachineryQuoteProposeConfirmButton",
    HEAVY_DUTY_MACHINERY_QUOTE_PROPOSE_AMOUNT_REQUIRED: "heavyDutyMachineryQuoteProposeAmountRequired",
    HEAVY_DUTY_MACHINERY_QUOTE_PROPOSE_REASON_REQUIRED: "heavyDutyMachineryQuoteProposeReasonRequired",
    HEAVY_DUTY_MACHINERY_QUOTE_PROPOSE_SUCCESS: "heavyDutyMachineryQuoteProposeSuccess",
    HEAVY_DUTY_MACHINERY_QUOTE_PROPOSE_ERROR: "heavyDutyMachineryQuoteProposeError",
    HEAVY_DUTY_MACHINERY_QUOTE_REJECT_BUTTON: "heavyDutyMachineryQuoteRejectButton",
    HEAVY_DUTY_MACHINERY_QUOTE_REJECT_MODAL_TITLE: "heavyDutyMachineryQuoteRejectModalTitle",
    HEAVY_DUTY_MACHINERY_QUOTE_REJECT_LABEL: "heavyDutyMachineryQuoteRejectLabel",
    HEAVY_DUTY_MACHINERY_QUOTE_REJECT_PLACEHOLDER: "heavyDutyMachineryQuoteRejectPlaceholder",
    HEAVY_DUTY_MACHINERY_QUOTE_REJECT_CONFIRM_BUTTON: "heavyDutyMachineryQuoteRejectConfirmButton",
    HEAVY_DUTY_MACHINERY_QUOTE_REJECT_REASON_REQUIRED: "heavyDutyMachineryQuoteRejectReasonRequired",
    HEAVY_DUTY_MACHINERY_QUOTE_REJECT_SUCCESS: "heavyDutyMachineryQuoteRejectSuccess",
    HEAVY_DUTY_MACHINERY_QUOTE_REJECT_ERROR: "heavyDutyMachineryQuoteRejectError",
    HEAVY_DUTY_MACHINERY_BOOKING_CANCEL_QUOTE_BUTTON: "heavyDutyMachineryBookingCancelQuoteButton",
    HEAVY_DUTY_MACHINERY_BOOKING_CANCEL_QUOTE_CONFIRM: "heavyDutyMachineryBookingCancelQuoteConfirm",
    HEAVY_DUTY_MACHINERY_BOOKING_CANCEL_QUOTE_SUCCESS: "heavyDutyMachineryBookingCancelQuoteSuccess",
    HEAVY_DUTY_MACHINERY_BOOKING_CANCEL_QUOTE_ERROR: "heavyDutyMachineryBookingCancelQuoteError",

    HEAVY_DUTY_MACHINERY_BOOKING_STATUS_PENDING: "heavyDutyMachineryBookingStatusPending",
    HEAVY_DUTY_MACHINERY_BOOKING_STATUS_CONFIRMED: "heavyDutyMachineryBookingStatusConfirmed",
    HEAVY_DUTY_MACHINERY_BOOKING_STATUS_COMPLETED: "heavyDutyMachineryBookingStatusCompleted",
    HEAVY_DUTY_MACHINERY_BOOKING_STATUS_CANCELLED: "heavyDutyMachineryBookingStatusCancelled",
    HEAVY_DUTY_MACHINERY_BOOKING_STATUS_HOST_NO_SHOW: "heavyDutyMachineryBookingStatusHostNoShow",
    HEAVY_DUTY_MACHINERY_BOOKING_STATUS_GUEST_NO_SHOW: "heavyDutyMachineryBookingStatusGuestNoShow",
    HEAVY_DUTY_MACHINERY_BOOKING_STATUS_AWAITING_QUOTE: "heavyDutyMachineryBookingStatusAwaitingQuote",
    HEAVY_DUTY_MACHINERY_BOOKING_STATUS_AWAITING_PAYMENT: "heavyDutyMachineryBookingStatusAwaitingPayment",

    // ===== Rental lifecycle timeline (seguimiento de la reserva) =====
    BOOKING_TIMELINE_TITLE: "bookingTimelineTitle",
    BOOKING_TIMELINE_PHASE_QUOTE: "bookingTimelinePhaseQuote",
    BOOKING_TIMELINE_PHASE_QUOTE_DESCRIPTION: "bookingTimelinePhaseQuoteDescription",
    BOOKING_TIMELINE_PHASE_AWAITING_PAYMENT: "bookingTimelinePhaseAwaitingPayment",
    BOOKING_TIMELINE_PHASE_AWAITING_PAYMENT_DESCRIPTION: "bookingTimelinePhaseAwaitingPaymentDescription",
    BOOKING_TIMELINE_PHASE_CONFIRMED: "bookingTimelinePhaseConfirmed",
    BOOKING_TIMELINE_PHASE_CONFIRMED_DESCRIPTION: "bookingTimelinePhaseConfirmedDescription",
    BOOKING_TIMELINE_PHASE_TRANSPORT: "bookingTimelinePhaseTransport",
    BOOKING_TIMELINE_PHASE_TRANSPORT_DESCRIPTION: "bookingTimelinePhaseTransportDescription",
    BOOKING_TIMELINE_PHASE_HANDOVER_DELIVERY: "bookingTimelinePhaseHandoverDelivery",
    BOOKING_TIMELINE_PHASE_HANDOVER_PICKUP: "bookingTimelinePhaseHandoverPickup",
    BOOKING_TIMELINE_PHASE_HANDOVER_DESCRIPTION: "bookingTimelinePhaseHandoverDescription",
    BOOKING_TIMELINE_PHASE_IN_USE: "bookingTimelinePhaseInUse",
    BOOKING_TIMELINE_PHASE_IN_USE_DESCRIPTION: "bookingTimelinePhaseInUseDescription",
    BOOKING_TIMELINE_PHASE_OFF_RENT: "bookingTimelinePhaseOffRent",
    BOOKING_TIMELINE_PHASE_OFF_RENT_DESCRIPTION: "bookingTimelinePhaseOffRentDescription",
    BOOKING_TIMELINE_PHASE_COLLECTION: "bookingTimelinePhaseCollection",
    BOOKING_TIMELINE_PHASE_COLLECTION_DESCRIPTION: "bookingTimelinePhaseCollectionDescription",
    BOOKING_TIMELINE_PHASE_RETURN: "bookingTimelinePhaseReturn",
    BOOKING_TIMELINE_PHASE_RETURN_DESCRIPTION: "bookingTimelinePhaseReturnDescription",
    BOOKING_TIMELINE_PHASE_SETTLEMENT: "bookingTimelinePhaseSettlement",
    BOOKING_TIMELINE_PHASE_SETTLEMENT_DESCRIPTION: "bookingTimelinePhaseSettlementDescription",
    BOOKING_TIMELINE_MONEY_TITLE: "bookingTimelineMoneyTitle",
    BOOKING_TIMELINE_MONEY_GUEST: "bookingTimelineMoneyGuest",
    BOOKING_TIMELINE_MONEY_GUEST_DETAIL: "bookingTimelineMoneyGuestDetail",
    BOOKING_TIMELINE_MONEY_HELD: "bookingTimelineMoneyHeld",
    BOOKING_TIMELINE_MONEY_HELD_DETAIL: "bookingTimelineMoneyHeldDetail",
    BOOKING_TIMELINE_MONEY_PLATFORM: "bookingTimelineMoneyPlatform",
    BOOKING_TIMELINE_MONEY_PLATFORM_DETAIL: "bookingTimelineMoneyPlatformDetail",
    BOOKING_TIMELINE_MONEY_HOST: "bookingTimelineMoneyHost",
    BOOKING_TIMELINE_MONEY_HOST_DETAIL: "bookingTimelineMoneyHostDetail",
    BOOKING_TIMELINE_MONEY_REFUNDED: "bookingTimelineMoneyRefunded",
    BOOKING_TIMELINE_MONEY_REFUNDED_DETAIL: "bookingTimelineMoneyRefundedDetail",
    BOOKING_TIMELINE_DEPOSIT_LABEL: "bookingTimelineDepositLabel",
    BOOKING_TIMELINE_DEPOSIT_DETAIL: "bookingTimelineDepositDetail",
    BOOKING_TIMELINE_NOT_LOADED: "bookingTimelineNotLoaded",
    DISPUTE_STATUS_OPEN: "disputeStatusOpen",
    DISPUTE_STATUS_ANSWERED: "disputeStatusAnswered",
    DISPUTE_STATUS_UNDER_REVIEW: "disputeStatusUnderReview",
    DISPUTE_STATUS_SETTLED: "disputeStatusSettled",
    DISPUTE_STATUS_AUTO_RESOLVED: "disputeStatusAutoResolved",
    DISPUTE_STATUS_RESOLVED: "disputeStatusResolved",
    DISPUTE_STATUS_WITHDRAWN: "disputeStatusWithdrawn",
    DISPUTE_ACTION_RESPOND: "disputeActionRespond",
    DISPUTE_ACTION_OFFER: "disputeActionOffer",
    DISPUTE_ACTION_ACCEPT_OFFER: "disputeActionAcceptOffer",
    DISPUTE_ACTION_ESCALATE: "disputeActionEscalate",
    DISPUTE_ACTION_SPLIT: "disputeActionSplit",
    ADMIN_NAV_DISPUTES: "adminNavDisputes",
    ADMIN_DISPUTES_LOAD_ERROR: "adminDisputesLoadError",
    ADMIN_DISPUTES_RETRY: "adminDisputesRetry",
    ADMIN_DISPUTES_SUBTITLE: "adminDisputesSubtitle",
    ADMIN_DISPUTES_EMPTY_TITLE: "adminDisputesEmptyTitle",
    ADMIN_DISPUTES_EMPTY_DESCRIPTION: "adminDisputesEmptyDescription",
    ADMIN_DISPUTES_COLUMN_BOOKING: "adminDisputesColumnBooking",
    ADMIN_DISPUTES_COLUMN_AGE: "adminDisputesColumnAge",
    ADMIN_DISPUTES_COLUMN_MATERIAL: "adminDisputesColumnMaterial",
    ADMIN_DISPUTES_COLUMN_FILED: "adminDisputesColumnFiled",
    ADMIN_DISPUTES_DAYS: "adminDisputesDays",
    ADMIN_DISPUTES_EVIDENCE_COUNT: "adminDisputesEvidenceCount",
    ADMIN_DISPUTES_OFFER_COUNT: "adminDisputesOfferCount",
    ADMIN_DISPUTES_OPEN_BOOKING: "adminDisputesOpenBooking",
    ADMIN_DISPUTES_DECIDE: "adminDisputesDecide",
    ADMIN_DISPUTES_COLUMN_SETTLEMENT: "adminDisputesColumnSettlement",
    ADMIN_DISPUTES_SETTLEMENT_PAID: "adminDisputesSettlementPaid",
    ADMIN_DISPUTES_SETTLEMENT_STUCK: "adminDisputesSettlementStuck",
    ADMIN_DISPUTES_SETTLEMENT_NOTHING: "adminDisputesSettlementNothing",
    ADMIN_DISPUTES_DECIDE_HINT: "adminDisputesDecideHint",
    ADMIN_DISPUTES_REASON_PLACEHOLDER: "adminDisputesReasonPlaceholder",
    ADMIN_DISPUTE_REASON_REQUIRED: "adminDisputeReasonRequired",
    ADMIN_DISPUTES_CLAIMANT_SAYS: "adminDisputesClaimantSays",
    ADMIN_DISPUTES_RESPONDENT_SAYS: "adminDisputesRespondentSays",
    DISPUTE_ACTION_WITHDRAW: "disputeActionWithdraw",
    DISPUTE_DEFAULT_SILENCE_CLAIMANT: "disputeDefaultSilenceClaimant",
    DISPUTE_DEFAULT_SILENCE_RESPONDENT: "disputeDefaultSilenceRespondent",
    DISPUTE_DEFAULT_SPLIT: "disputeDefaultSplit",
    DISPUTE_DEFAULT_REVIEW: "disputeDefaultReview",
    DISPUTE_HOURS_LEFT: "disputeHoursLeft",
    DISPUTE_DEADLINE_PASSED: "disputeDeadlinePassed",
    DISPUTE_PAGE_TITLE: "disputePageTitle",
    DISPUTE_CLAIMED_LABEL: "disputeClaimedLabel",
    DISPUTE_CURRENT_OFFER_LABEL: "disputeCurrentOfferLabel",
    DISPUTE_RESOLVED_LABEL: "disputeResolvedLabel",
    DISPUTE_WAITING_OTHER: "disputeWaitingOther",
    DISPUTE_UNDER_REVIEW_BODY: "disputeUnderReviewBody",
    DISPUTE_SETTLED_LABEL: "disputeSettledLabel",
    DISPUTE_SETTLED_BODY: "disputeSettledBody",
    DISPUTE_NOT_SETTLED_TITLE: "disputeNotSettledTitle",
    DISPUTE_SETTLED_FROM_DEPOSIT: "disputeSettledFromDeposit",
    DISPUTE_EVIDENCE_TITLE: "disputeEvidenceTitle",
    DISPUTE_EVIDENCE_EMPTY: "disputeEvidenceEmpty",
    DISPUTE_EVIDENCE_ADD: "disputeEvidenceAdd",
    DISPUTE_EVIDENCE_MINE: "disputeEvidenceMine",
    DISPUTE_EVIDENCE_THEIRS: "disputeEvidenceTheirs",
    DISPUTE_EVIDENCE_UPLOAD_ERROR: "disputeEvidenceUploadError",
    DISPUTE_OFFERS_TITLE: "disputeOffersTitle",
    DISPUTE_OFFER_VERSION: "disputeOfferVersion",
    DISPUTE_OFFER_BY_ME: "disputeOfferByMe",
    DISPUTE_OFFER_BY_THEM: "disputeOfferByThem",
    DISPUTE_OPEN_TITLE: "disputeOpenTitle",
    DISPUTE_OPEN_SUBTITLE: "disputeOpenSubtitle",
    DISPUTE_OPEN_AMOUNT_LABEL: "disputeOpenAmountLabel",
    DISPUTE_OPEN_REASON_PLACEHOLDER: "disputeOpenReasonPlaceholder",
    DISPUTE_OPEN_REASON_REQUIRED: "disputeOpenReasonRequired",
    DISPUTE_OPEN_CONFIRM: "disputeOpenConfirm",
    DISPUTE_OPEN_SUCCESS: "disputeOpenSuccess",
    DISPUTE_OPEN_ERROR: "disputeOpenError",
    DISPUTE_RESPOND_TITLE: "disputeRespondTitle",
    DISPUTE_RESPOND_PLACEHOLDER: "disputeRespondPlaceholder",
    DISPUTE_OFFER_TITLE: "disputeOfferTitle",
    DISPUTE_OFFER_SUBTITLE: "disputeOfferSubtitle",
    DISPUTE_OFFER_NOTE_PLACEHOLDER: "disputeOfferNotePlaceholder",
    DISPUTE_ACTION_ERROR: "disputeActionError",
    DISPUTE_ACTION_SUCCESS: "disputeActionSuccess",
    DISPUTE_NOT_LOADED: "disputeNotLoaded",
    DISPUTE_NOT_LOADED_DESCRIPTION: "disputeNotLoadedDescription",
    DISPUTE_OPEN_FROM_BOOKING: "disputeOpenFromBooking",
    DISPUTE_VIEW_BUTTON: "disputeViewButton",
    INSURANCE_POLICY_REAL_SECTION: "insurancePolicyRealSection",
    INSURANCE_POLICY_REAL_SECTION_HINT: "insurancePolicyRealSectionHint",
    INSURANCE_POLICY_INSURER_LABEL: "insurancePolicyInsurerLabel",
    INSURANCE_POLICY_NUMBER_LABEL: "insurancePolicyNumberLabel",
    INSURANCE_POLICY_EXPIRES_LABEL: "insurancePolicyExpiresLabel",
    INSURANCE_POLICY_EXCESS_LABEL: "insurancePolicyExcessLabel",
    INSURANCE_POLICY_EXCESS_HINT: "insurancePolicyExcessHint",
    INSURANCE_POLICY_COVERAGE_LIMIT_LABEL: "insurancePolicyCoverageLimitLabel",
    INSURANCE_POLICY_DOCUMENT_LABEL: "insurancePolicyDocumentLabel",
    INSURANCE_POLICY_DOCUMENT_HINT: "insurancePolicyDocumentHint",
    INSURANCE_POLICY_DOCUMENT_ATTACHED: "insurancePolicyDocumentAttached",
    INSURANCE_POLICY_DOCUMENT_UPLOAD_ERROR: "insurancePolicyDocumentUploadError",
    INSURANCE_VERIFICATION_PENDING: "insuranceVerificationPending",
    INSURANCE_VERIFICATION_VERIFIED: "insuranceVerificationVerified",
    INSURANCE_VERIFICATION_REJECTED: "insuranceVerificationRejected",
    INSURANCE_VERIFICATION_PENDING_HINT: "insuranceVerificationPendingHint",
    INSURANCE_POLICY_EXCESS_ON_CARD: "insurancePolicyExcessOnCard",
    INSURANCE_POLICY_NO_EXCESS_ON_CARD: "insurancePolicyNoExcessOnCard",
    BOOKING_TIMELINE_DEPOSIT_CAPPED: "bookingTimelineDepositCapped",
    BOOKING_TIMELINE_DEPOSIT_COVERAGE_CARD: "bookingTimelineDepositCoverageCard",
    BOOKING_TIMELINE_DEPOSIT_HOLD_UNTIL: "bookingTimelineDepositHoldUntil",
    QUOTE_DEPOSIT_HOLD_NOTICE: "quoteDepositHoldNotice",
    BOOKING_TIMELINE_OVERTIME_LABEL: "bookingTimelineOvertimeLabel",
    BOOKING_TIMELINE_OVERTIME_DETAIL: "bookingTimelineOvertimeDetail",
    BOOKING_TIMELINE_DEPOSIT_RELEASED: "bookingTimelineDepositReleased",
    BOOKING_TIMELINE_DEPOSIT_CAPTURED: "bookingTimelineDepositCaptured",

    LIFECYCLE_NEXT_STEP_TITLE: "lifecycleNextStepTitle",
    LIFECYCLE_START_TRANSPORT: "lifecycleStartTransport",
    LIFECYCLE_START_TRANSPORT_DETAIL: "lifecycleStartTransportDetail",
    LIFECYCLE_DELIVERY_NOTE: "lifecycleDeliveryNote",
    LIFECYCLE_DELIVERY_NOTE_DETAIL: "lifecycleDeliveryNoteDetail",
    LIFECYCLE_REVIEW_DELIVERY_NOTE: "lifecycleReviewDeliveryNote",
    LIFECYCLE_REVIEW_DELIVERY_NOTE_DETAIL: "lifecycleReviewDeliveryNoteDetail",
    LIFECYCLE_DECLARE_OFF_RENT: "lifecycleDeclareOffRent",
    LIFECYCLE_DECLARE_OFF_RENT_DETAIL: "lifecycleDeclareOffRentDetail",
    LIFECYCLE_START_COLLECTION: "lifecycleStartCollection",
    LIFECYCLE_START_COLLECTION_DETAIL: "lifecycleStartCollectionDetail",
    LIFECYCLE_RETURN_NOTE: "lifecycleReturnNote",
    LIFECYCLE_RETURN_NOTE_DETAIL: "lifecycleReturnNoteDetail",
    LIFECYCLE_REVIEW_RETURN_NOTE: "lifecycleReviewReturnNote",
    LIFECYCLE_REVIEW_RETURN_NOTE_DETAIL: "lifecycleReviewReturnNoteDetail",
    LIFECYCLE_ACTION_SUCCESS: "lifecycleActionSuccess",
    LIFECYCLE_ACTION_ERROR: "lifecycleActionError",
    HANDOVER_ACK_TITLE: "handoverAckTitle",
    HANDOVER_ACK_SUBTITLE: "handoverAckSubtitle",
    HANDOVER_ACK_PROMPT: "handoverAckPrompt",
    HANDOVER_ACK_OPEN_BUTTON: "handoverAckOpenButton",
    HANDOVER_ACK_ACCEPTED: "handoverAckAccepted",
    HANDOVER_ACK_ACCEPTED_DETAIL: "handoverAckAcceptedDetail",
    HANDOVER_ACK_ACCEPTED_WITH_REMARKS: "handoverAckAcceptedWithRemarks",
    HANDOVER_ACK_ACCEPTED_WITH_REMARKS_DETAIL: "handoverAckAcceptedWithRemarksDetail",
    HANDOVER_ACK_REJECTED: "handoverAckRejected",
    HANDOVER_ACK_REJECTED_DETAIL: "handoverAckRejectedDetail",
    HANDOVER_ACK_REMARKS_PLACEHOLDER: "handoverAckRemarksPlaceholder",
    HANDOVER_ACK_REMARKS_REQUIRED: "handoverAckRemarksRequired",
    HANDOVER_ACK_CONFIRM: "handoverAckConfirm",
    HANDOVER_ACK_SUCCESS: "handoverAckSuccess",
    HANDOVER_ACK_ERROR: "handoverAckError",
    HANDOVER_SIGNATURE_LABEL: "handoverSignatureLabel",
    HANDOVER_SIGNATURE_CLEAR: "handoverSignatureClear",
    BOOKING_TIMELINE_VIEW_BUTTON: "bookingTimelineViewButton",
    BOOKING_TIMELINE_NOT_LOADED_DESCRIPTION: "bookingTimelineNotLoadedDescription",
    BOOKING_TIMELINE_BACK_BUTTON: "bookingTimelineBackButton",

    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_NAV_BUTTON: "heavyDutyMachineryIncomingBookingsNavButton",
    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_TITLE: "heavyDutyMachineryIncomingBookingsTitle",
    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_EMPTY: "heavyDutyMachineryIncomingBookingsEmpty",
    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_EMPTY_DESCRIPTION: "heavyDutyMachineryIncomingBookingsEmptyDescription",
    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_LOAD_ERROR: "heavyDutyMachineryIncomingBookingsLoadError",
    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_GUEST_LABEL: "heavyDutyMachineryIncomingBookingsGuestLabel",
    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_NEW_BADGE: "heavyDutyMachineryIncomingBookingsNewBadge",
    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_TAB_LIST: "heavyDutyMachineryIncomingBookingsTabList",
    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_TAB_CALENDAR: "heavyDutyMachineryIncomingBookingsTabCalendar",
    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_CALENDAR_LEGEND_FULL_DAY: "heavyDutyMachineryIncomingBookingsCalendarLegendFullDay",
    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_CALENDAR_LEGEND_HOURLY: "heavyDutyMachineryIncomingBookingsCalendarLegendHourly",
    HEAVY_DUTY_MACHINERY_INCOMING_BOOKINGS_CALENDAR_DAY_EMPTY: "heavyDutyMachineryIncomingBookingsCalendarDayEmpty",
    HEAVY_DUTY_MACHINERY_BOOKINGS_FILTER_NO_MATCHES: "heavyDutyMachineryBookingsFilterNoMatches",

    HEAVY_DUTY_MACHINERY_MARK_GUEST_NO_SHOW_BUTTON: "heavyDutyMachineryMarkGuestNoShowButton",
    HEAVY_DUTY_MACHINERY_MARK_GUEST_NO_SHOW_CONFIRM: "heavyDutyMachineryMarkGuestNoShowConfirm",
    HEAVY_DUTY_MACHINERY_MARK_HOST_NO_SHOW_BUTTON: "heavyDutyMachineryMarkHostNoShowButton",
    HEAVY_DUTY_MACHINERY_MARK_HOST_NO_SHOW_CONFIRM: "heavyDutyMachineryMarkHostNoShowConfirm",
    HEAVY_DUTY_MACHINERY_MARK_GUEST_NO_SHOW_SHEET_CONFIRM: "heavyDutyMachineryMarkGuestNoShowSheetConfirm",
    HEAVY_DUTY_MACHINERY_MARK_HOST_NO_SHOW_SHEET_CONFIRM: "heavyDutyMachineryMarkHostNoShowSheetConfirm",
    HEAVY_DUTY_MACHINERY_MARK_NO_SHOW_SUCCESS: "heavyDutyMachineryMarkNoShowSuccess",
    HEAVY_DUTY_MACHINERY_MARK_NO_SHOW_ERROR: "heavyDutyMachineryMarkNoShowError",

    HEAVY_DUTY_MACHINERY_BOOKING_CONFIRMED_ADDRESS_INTRO: "heavyDutyMachineryBookingConfirmedAddressIntro",
    HEAVY_DUTY_MACHINERY_BOOKING_SEARCH_ANOTHER_SLOT: "heavyDutyMachineryBookingSearchAnotherSlot",
    HEAVY_DUTY_MACHINERY_BOOKING_VIEW_MY_BOOKINGS: "heavyDutyMachineryBookingViewMyBookings",

    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_TITLE: "heavyDutyMachineryNotificationsTitle",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_OVERLAY_CLOSE: "heavyDutyMachineryNotificationsOverlayClose",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_MARK_ALL_READ: "heavyDutyMachineryNotificationsMarkAllRead",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_EMPTY: "heavyDutyMachineryNotificationsEmpty",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_EMPTY_DESCRIPTION: "heavyDutyMachineryNotificationsEmptyDescription",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_DELETE_ACTION: "heavyDutyMachineryNotificationsDeleteAction",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_DELETE_ERROR: "heavyDutyMachineryNotificationsDeleteError",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_MARK_ALL_READ_ERROR: "heavyDutyMachineryNotificationsMarkAllReadError",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_DELETE_ALL_ACTION: "heavyDutyMachineryNotificationsDeleteAllAction",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_DELETE_ALL_SHEET_TITLE: "heavyDutyMachineryNotificationsDeleteAllSheetTitle",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_DELETE_ALL_SHEET_KEEP: "heavyDutyMachineryNotificationsDeleteAllSheetKeep",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_DELETE_ALL_SHEET_CONFIRM: "heavyDutyMachineryNotificationsDeleteAllSheetConfirm",
    HEAVY_DUTY_MACHINERY_NOTIFICATIONS_DELETE_ALL_ERROR: "heavyDutyMachineryNotificationsDeleteAllError",
    HEAVY_DUTY_MACHINERY_NOTIF_TIME_JUST_NOW: "heavyDutyMachineryNotifTimeJustNow",
    HEAVY_DUTY_MACHINERY_NOTIF_TIME_MINUTES: "heavyDutyMachineryNotifTimeMinutes",
    HEAVY_DUTY_MACHINERY_NOTIF_TIME_HOURS: "heavyDutyMachineryNotifTimeHours",
    HEAVY_DUTY_MACHINERY_NOTIF_TIME_DAYS: "heavyDutyMachineryNotifTimeDays",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_NEW_BOOKING: "heavyDutyMachineryNotifTitleNewBooking",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_NEW_MESSAGE: "heavyDutyMachineryNotifTitleNewMessage",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_BOOKING_STATUS_CHANGED: "heavyDutyMachineryNotifTitleBookingStatusChanged",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_AUDIT_PASSED: "heavyDutyMachineryNotifTitleAuditPassed",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_AUDIT_FAILED: "heavyDutyMachineryNotifTitleAuditFailed",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_ANNOUNCEMENT: "heavyDutyMachineryNotifTitleAnnouncement",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_PAYOUTS_DISABLED: "heavyDutyMachineryNotifTitlePayoutsDisabled",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_PAYOUTS_RESTORED: "heavyDutyMachineryNotifTitlePayoutsRestored",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_BOOKING_CONFIRMED: "heavyDutyMachineryNotifTitleBookingConfirmed",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_BOOKING_PAYMENT_FAILED: "heavyDutyMachineryNotifTitleBookingPaymentFailed",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_SPACE_APPROVED: "heavyDutyMachineryNotifTitleSpaceApproved",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_SPACE_REJECTED: "heavyDutyMachineryNotifTitleSpaceRejected",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_SPACE_APPROVED: "heavyDutyMachineryNotifBodySpaceApproved",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_SPACE_REJECTED: "heavyDutyMachineryNotifBodySpaceRejected",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_NEW_BOOKING: "heavyDutyMachineryNotifBodyNewBooking",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_NEW_BOOKING_BY: "heavyDutyMachineryNotifBodyNewBookingBy",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_NEW_MESSAGE: "heavyDutyMachineryNotifBodyNewMessage",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_BOOKING_STATUS_CHANGED: "heavyDutyMachineryNotifBodyBookingStatusChanged",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_BOOKING_CANCELLED_BY: "heavyDutyMachineryNotifBodyBookingCancelledBy",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_AUDIT_PASSED: "heavyDutyMachineryNotifBodyAuditPassed",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_AUDIT_FAILED: "heavyDutyMachineryNotifBodyAuditFailed",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_PAYOUTS_DISABLED: "heavyDutyMachineryNotifBodyPayoutsDisabled",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_PAYOUTS_RESTORED: "heavyDutyMachineryNotifBodyPayoutsRestored",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_BOOKING_CONFIRMED: "heavyDutyMachineryNotifBodyBookingConfirmed",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_BOOKING_PAYMENT_FAILED: "heavyDutyMachineryNotifBodyBookingPaymentFailed",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_ADMIN_MESSAGE: "heavyDutyMachineryNotifTitleAdminMessage",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_ADMIN_MESSAGE: "heavyDutyMachineryNotifBodyAdminMessage",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_GEOFENCE_ALERT: "heavyDutyMachineryNotifTitleGeofenceAlert",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_GEOFENCE_ALERT: "heavyDutyMachineryNotifBodyGeofenceAlert",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_OVERTIME_CHARGE_FAILED: "heavyDutyMachineryNotifTitleOvertimeChargeFailed",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_OVERTIME_CHARGE_FAILED: "heavyDutyMachineryNotifBodyOvertimeChargeFailed",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_NEW_QUOTE_REQUEST: "heavyDutyMachineryNotifTitleNewQuoteRequest",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_NEW_QUOTE_REQUEST: "heavyDutyMachineryNotifBodyNewQuoteRequest",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_NEW_QUOTE_REQUEST_BY: "heavyDutyMachineryNotifBodyNewQuoteRequestBy",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_QUOTE_ACCEPTED: "heavyDutyMachineryNotifTitleQuoteAccepted",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_QUOTE_ACCEPTED: "heavyDutyMachineryNotifBodyQuoteAccepted",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_QUOTE_REVISED: "heavyDutyMachineryNotifTitleQuoteRevised",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_QUOTE_REVISED: "heavyDutyMachineryNotifBodyQuoteRevised",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_TRANSPORT_STARTED: "heavyDutyMachineryNotifTitleTransportStarted",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_TRANSPORT_STARTED: "heavyDutyMachineryNotifBodyTransportStarted",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_OFF_RENT_DECLARED: "heavyDutyMachineryNotifTitleOffRentDeclared",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_OFF_RENT_DECLARED: "heavyDutyMachineryNotifBodyOffRentDeclared",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_COLLECTION_STARTED: "heavyDutyMachineryNotifTitleCollectionStarted",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_COLLECTION_STARTED: "heavyDutyMachineryNotifBodyCollectionStarted",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_FUNDS_RELEASED: "heavyDutyMachineryNotifTitleFundsReleased",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_FUNDS_RELEASED: "heavyDutyMachineryNotifBodyFundsReleased",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_FUNDS_RELEASED_AMOUNT: "heavyDutyMachineryNotifBodyFundsReleasedAmount",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_TRANSFER_PENDING: "heavyDutyMachineryNotifTitleTransferPending",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_TRANSFER_PENDING: "heavyDutyMachineryNotifBodyTransferPending",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_BOOKING_REFUNDED: "heavyDutyMachineryNotifTitleBookingRefunded",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_BOOKING_REFUNDED: "heavyDutyMachineryNotifBodyBookingRefunded",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_HOST_DEPOSIT_FUNDED: "heavyDutyMachineryNotifTitleHostDepositFunded",
    HOST_DEPOSIT_TITLE: "hostDepositTitle",
    HOST_EARNINGS_NAV_LABEL: "hostEarningsNavLabel",
    HOST_EARNINGS_PAGE_SUBTITLE: "hostEarningsPageSubtitle",
    HOST_EARNINGS_RANGE_MONTH: "hostEarningsRangeMonth",
    HOST_EARNINGS_RANGE_YEAR: "hostEarningsRangeYear",
    HOST_EARNINGS_RANGE_TRAILING_12: "hostEarningsRangeTrailing12",
    HOST_EARNINGS_RANGE_FROM: "hostEarningsRangeFrom",
    HOST_EARNINGS_RANGE_TO: "hostEarningsRangeTo",
    HOST_EARNINGS_TODAY: "hostEarningsToday",
    HOST_EARNINGS_THIS_MONTH: "hostEarningsThisMonth",
    HOST_EARNINGS_THIS_YEAR: "hostEarningsThisYear",
    HOST_EARNINGS_NET_HINT: "hostEarningsNetHint",
    HOST_EARNINGS_CHART_BARS: "hostEarningsChartBars",
    HOST_EARNINGS_CHART_LINE: "hostEarningsChartLine",
    HOST_EARNINGS_TREND_TITLE: "hostEarningsTrendTitle",
    HOST_EARNINGS_TREND_SUBTITLE: "hostEarningsTrendSubtitle",
    HOST_EARNINGS_TREND_EMPTY: "hostEarningsTrendEmpty",
    HOST_EARNINGS_RANGE_GROSS: "hostEarningsRangeGross",
    HOST_EARNINGS_RANGE_FEE: "hostEarningsRangeFee",
    HOST_EARNINGS_RANGE_NET: "hostEarningsRangeNet",
    HOST_EARNINGS_RANGE_BOOKINGS: "hostEarningsRangeBookings",
    HOST_EARNINGS_RANGE_REFUNDED: "hostEarningsRangeRefunded",
    HOST_EARNINGS_BY_CONCEPT_TITLE: "hostEarningsByConceptTitle",
    HOST_EARNINGS_BY_CONCEPT_SUBTITLE: "hostEarningsByConceptSubtitle",
    HOST_EARNINGS_CONCEPT_BASE: "hostEarningsConceptBase",
    HOST_EARNINGS_CONCEPT_ACCESSORIES: "hostEarningsConceptAccessories",
    HOST_EARNINGS_CONCEPT_DELIVERY: "hostEarningsConceptDelivery",
    HOST_EARNINGS_CONCEPT_INSURANCE: "hostEarningsConceptInsurance",
    HOST_EARNINGS_CONCEPT_OPERATOR: "hostEarningsConceptOperator",
    HOST_EARNINGS_CONCEPT_SERVICE: "hostEarningsConceptService",
    HOST_EARNINGS_BY_MACHINE_TITLE: "hostEarningsByMachineTitle",
    HOST_EARNINGS_BY_MACHINE_SUBTITLE: "hostEarningsByMachineSubtitle",
    HOST_EARNINGS_BY_MACHINE_OTHER: "hostEarningsByMachineOther",
    HOST_EARNINGS_SCOPE_ALL: "hostEarningsScopeAll",
    HOST_EARNINGS_SCOPE_MACHINERY: "hostEarningsScopeMachinery",
    HOST_EARNINGS_SCOPE_SERVICES: "hostEarningsScopeServices",
    HOST_EARNINGS_SCOPE_HINT: "hostEarningsScopeHint",
    HOST_EARNINGS_BY_SERVICE_TITLE: "hostEarningsByServiceTitle",
    HOST_EARNINGS_BY_SERVICE_SUBTITLE: "hostEarningsByServiceSubtitle",
    HOST_EARNINGS_BY_OPERATOR_TITLE: "hostEarningsByOperatorTitle",
    HOST_EARNINGS_BY_OPERATOR_SUBTITLE: "hostEarningsByOperatorSubtitle",
    HOST_EARNINGS_BY_PRICING_MODE_TITLE: "hostEarningsByPricingModeTitle",
    HOST_EARNINGS_BY_PRICING_MODE_SUBTITLE: "hostEarningsByPricingModeSubtitle",
    HOST_EARNINGS_PRICING_MODE_HOURLY: "hostEarningsPricingModeHourly",
    HOST_EARNINGS_PRICING_MODE_FIXED_JOB: "hostEarningsPricingModeFixedJob",
    HOST_EARNINGS_PRICING_MODE_PARTIAL: "hostEarningsPricingModePartial",
    HOST_EARNINGS_BOOKINGS_COUNT: "hostEarningsBookingsCount",
    HOST_EARNINGS_WHERE_TITLE: "hostEarningsWhereTitle",
    HOST_EARNINGS_WHERE_SUBTITLE: "hostEarningsWhereSubtitle",
    HOST_EARNINGS_WHERE_EMPTY: "hostEarningsWhereEmpty",
    HOST_EARNINGS_WHERE_UPCOMING: "hostEarningsWhereUpcoming",
    HOST_EARNINGS_WHERE_UPCOMING_DETAIL: "hostEarningsWhereUpcomingDetail",
    HOST_EARNINGS_WHERE_HELD: "hostEarningsWhereHeld",
    HOST_EARNINGS_WHERE_HELD_DETAIL: "hostEarningsWhereHeldDetail",
    HOST_EARNINGS_WHERE_ON_THE_WAY: "hostEarningsWhereOnTheWay",
    HOST_EARNINGS_WHERE_ON_THE_WAY_DETAIL: "hostEarningsWhereOnTheWayDetail",
    HOST_EARNINGS_WHERE_PAID_OUT: "hostEarningsWherePaidOut",
    HOST_EARNINGS_WHERE_PAID_OUT_DETAIL: "hostEarningsWherePaidOutDetail",
    HOST_EARNINGS_WHERE_STUCK: "hostEarningsWhereStuck",
    HOST_EARNINGS_WHERE_STUCK_DETAIL: "hostEarningsWhereStuckDetail",
    HOST_EARNINGS_MIXED_CURRENCIES: "hostEarningsMixedCurrencies",
    HOST_EARNINGS_EMPTY: "hostEarningsEmpty",
    HOST_EARNINGS_EMPTY_DESCRIPTION: "hostEarningsEmptyDescription",
    HOST_EARNINGS_LOAD_ERROR: "hostEarningsLoadError",
    HOST_EARNINGS_LOAD_ERROR_DESCRIPTION: "hostEarningsLoadErrorDescription",
    HOST_EARNINGS_RETRY_BUTTON: "hostEarningsRetryButton",
    HOST_EARNINGS_FOOTNOTE: "hostEarningsFootnote",
    HOST_DEPOSIT_NAV_LABEL: "hostDepositNavLabel",
    HOST_DEPOSIT_SUBTITLE: "hostDepositSubtitle",
    HOST_DEPOSIT_NOT_REQUIRED: "hostDepositNotRequired",
    HOST_DEPOSIT_BALANCE_LABEL: "hostDepositBalanceLabel",
    HOST_DEPOSIT_MAX_BOOKING_LABEL: "hostDepositMaxBookingLabel",
    HOST_DEPOSIT_EXPOSURE_LABEL: "hostDepositExposureLabel",
    HOST_DEPOSIT_FUNDED_LABEL: "hostDepositFundedLabel",
    HOST_DEPOSIT_LOW_WARNING: "hostDepositLowWarning",
    HOST_DEPOSIT_EXHAUSTED_WARNING: "hostDepositExhaustedWarning",
    HOST_DEPOSIT_CALCULATOR_TITLE: "hostDepositCalculatorTitle",
    HOST_DEPOSIT_CALCULATOR_RESULT: "hostDepositCalculatorResult",
    HOST_DEPOSIT_CALCULATOR_HINT: "hostDepositCalculatorHint",
    HOST_DEPOSIT_TOP_UP_BUTTON: "hostDepositTopUpButton",
    HOST_DEPOSIT_TOP_UP_NOTICE: "hostDepositTopUpNotice",
    HOST_DEPOSIT_TOP_UP_ERROR: "hostDepositTopUpError",
    HOST_DEPOSIT_TOP_UP_DONE: "hostDepositTopUpDone",
    HOST_DEPOSIT_MOVEMENTS_TITLE: "hostDepositMovementsTitle",
    HOST_DEPOSIT_MOVEMENTS_EMPTY: "hostDepositMovementsEmpty",
    HOST_DEPOSIT_CLOSE_BUTTON: "hostDepositCloseButton",
    HOST_DEPOSIT_CLOSE_CONFIRM: "hostDepositCloseConfirm",
    HOST_DEPOSIT_CLOSE_DONE: "hostDepositCloseDone",
    HOST_DEPOSIT_LOAD_ERROR: "hostDepositLoadError",
    HOST_DEPOSIT_SHORTFALL_TITLE: "hostDepositShortfallTitle",
    HOST_DEPOSIT_SHORTFALL_BODY: "hostDepositShortfallBody",
    HOST_DEPOSIT_SHORTFALL_ACTION: "hostDepositShortfallAction",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_HOST_DEPOSIT_FUNDED: "heavyDutyMachineryNotifBodyHostDepositFunded",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_HOST_DEPOSIT_CHARGED: "heavyDutyMachineryNotifTitleHostDepositCharged",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_FUNDS_HELD: "heavyDutyMachineryNotifTitleFundsHeld",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_FUNDS_HELD: "heavyDutyMachineryNotifBodyFundsHeld",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_AUTH_FAILED: "heavyDutyMachineryNotifTitleAuthFailed",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_BOOKING_CHARGED: "heavyDutyMachineryNotifTitleBookingCharged",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_BOOKING_CHARGED: "heavyDutyMachineryNotifBodyBookingCharged",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_AUTH_FAILED: "heavyDutyMachineryNotifBodyAuthFailed",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_HOST_DEPOSIT_CHARGED: "heavyDutyMachineryNotifBodyHostDepositCharged",
    HEAVY_DUTY_MACHINERY_REFUND_ACTION: "heavyDutyMachineryRefundAction",
    HEAVY_DUTY_MACHINERY_REFUND_MODAL_TITLE: "heavyDutyMachineryRefundModalTitle",
    HEAVY_DUTY_MACHINERY_REFUND_MODAL_SUBTITLE: "heavyDutyMachineryRefundModalSubtitle",
    HEAVY_DUTY_MACHINERY_REFUND_AMOUNT_LABEL: "heavyDutyMachineryRefundAmountLabel",
    HEAVY_DUTY_MACHINERY_REFUND_AMOUNT_MAX: "heavyDutyMachineryRefundAmountMax",
    HEAVY_DUTY_MACHINERY_REFUND_REASON_LABEL: "heavyDutyMachineryRefundReasonLabel",
    HEAVY_DUTY_MACHINERY_REFUND_REASON_PLACEHOLDER: "heavyDutyMachineryRefundReasonPlaceholder",
    HEAVY_DUTY_MACHINERY_REFUND_REASON_HELP: "heavyDutyMachineryRefundReasonHelp",
    HEAVY_DUTY_MACHINERY_REFUND_COMMISSION_NOTE: "heavyDutyMachineryRefundCommissionNote",
    HEAVY_DUTY_MACHINERY_REFUND_CONFIRM: "heavyDutyMachineryRefundConfirm",
    HEAVY_DUTY_MACHINERY_REFUND_AMOUNT_REQUIRED: "heavyDutyMachineryRefundAmountRequired",
    HEAVY_DUTY_MACHINERY_REFUND_REASON_REQUIRED: "heavyDutyMachineryRefundReasonRequired",
    HEAVY_DUTY_MACHINERY_REFUND_SUCCESS: "heavyDutyMachineryRefundSuccess",
    HEAVY_DUTY_MACHINERY_REFUND_ERROR: "heavyDutyMachineryRefundError",
    HEAVY_DUTY_MACHINERY_REFUND_NOTHING_LEFT: "heavyDutyMachineryRefundNothingLeft",
    HEAVY_DUTY_MACHINERY_BOOKING_REFUNDED_BADGE: "heavyDutyMachineryBookingRefundedBadge",
    HEAVY_DUTY_MACHINERY_BOOKING_NET_AFTER_REFUND: "heavyDutyMachineryBookingNetAfterRefund",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_DISPUTE_CLOSED_BY_DEADLINE: "heavyDutyMachineryNotifTitleDisputeClosedByDeadline",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_DISPUTE_CLOSED_BY_DEADLINE: "heavyDutyMachineryNotifBodyDisputeClosedByDeadline",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_GENERIC: "heavyDutyMachineryNotifTitleGeneric",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_HANDOVER_ACKNOWLEDGED: "heavyDutyMachineryNotifTitleHandoverAcknowledged",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_HANDOVER_ACKNOWLEDGED: "heavyDutyMachineryNotifBodyHandoverAcknowledged",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_HANDOVER_REJECTED: "heavyDutyMachineryNotifTitleHandoverRejected",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_HANDOVER_REJECTED: "heavyDutyMachineryNotifBodyHandoverRejected",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_DEPOSIT_AUTH_FAILED: "heavyDutyMachineryNotifTitleDepositAuthFailed",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_DEPOSIT_AUTH_FAILED: "heavyDutyMachineryNotifBodyDepositAuthFailed",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_DISPUTE_OPENED: "heavyDutyMachineryNotifTitleDisputeOpened",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_DISPUTE_OPENED: "heavyDutyMachineryNotifBodyDisputeOpened",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_DISPUTE_ANSWERED: "heavyDutyMachineryNotifTitleDisputeAnswered",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_DISPUTE_ANSWERED: "heavyDutyMachineryNotifBodyDisputeAnswered",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_DISPUTE_OFFER: "heavyDutyMachineryNotifTitleDisputeOffer",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_DISPUTE_OFFER: "heavyDutyMachineryNotifBodyDisputeOffer",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_DISPUTE_SETTLED: "heavyDutyMachineryNotifTitleDisputeSettled",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_DISPUTE_SETTLED: "heavyDutyMachineryNotifBodyDisputeSettled",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_DISPUTE_SPLIT: "heavyDutyMachineryNotifTitleDisputeSplit",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_DISPUTE_SPLIT: "heavyDutyMachineryNotifBodyDisputeSplit",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_DISPUTE_WITHDRAWN: "heavyDutyMachineryNotifTitleDisputeWithdrawn",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_DISPUTE_WITHDRAWN: "heavyDutyMachineryNotifBodyDisputeWithdrawn",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_DISPUTE_RESOLVED: "heavyDutyMachineryNotifTitleDisputeResolved",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_DISPUTE_RESOLVED: "heavyDutyMachineryNotifBodyDisputeResolved",

    HEAVY_DUTY_MACHINERY_PAYOUTS_BANNER_TITLE: "heavyDutyMachineryPayoutsBannerTitle",
    HEAVY_DUTY_MACHINERY_PAYOUTS_BANNER_DESCRIPTION: "heavyDutyMachineryPayoutsBannerDescription",
    HEAVY_DUTY_MACHINERY_PAYOUTS_BANNER_CTA: "heavyDutyMachineryPayoutsBannerCta",

    HEAVY_DUTY_MACHINERY_CHAT_BUTTON: "heavyDutyMachineryChatButton",
    HEAVY_DUTY_MACHINERY_CHAT_INPUT_PLACEHOLDER: "heavyDutyMachineryChatInputPlaceholder",
    HEAVY_DUTY_MACHINERY_CHAT_LOAD_ERROR: "heavyDutyMachineryChatLoadError",
    HEAVY_DUTY_MACHINERY_CHAT_SEND_ERROR: "heavyDutyMachineryChatSendError",
    HEAVY_DUTY_MACHINERY_CHAT_NOT_AVAILABLE: "heavyDutyMachineryChatNotAvailable",
    HEAVY_DUTY_MACHINERY_CHAT_NEW_MESSAGE_PILL: "heavyDutyMachineryChatNewMessagePill",
    HEAVY_DUTY_MACHINERY_CHAT_MASKED_CONTENT_NOTICE: "heavyDutyMachineryChatMaskedContentNotice",

    HEAVY_DUTY_MACHINERY_MESSAGES_NAV_BUTTON: "heavyDutyMachineryMessagesNavButton",
    HEAVY_DUTY_MACHINERY_MESSAGES_TITLE: "heavyDutyMachineryMessagesTitle",
    HEAVY_DUTY_MACHINERY_MESSAGES_EMPTY: "heavyDutyMachineryMessagesEmpty",
    HEAVY_DUTY_MACHINERY_MESSAGES_EMPTY_DESCRIPTION: "heavyDutyMachineryMessagesEmptyDescription",
    HEAVY_DUTY_MACHINERY_MESSAGES_LOAD_ERROR: "heavyDutyMachineryMessagesLoadError",
    HEAVY_DUTY_MACHINERY_MESSAGES_SELECT_CONVERSATION_PROMPT: "heavyDutyMachineryMessagesSelectConversationPrompt",
    HEAVY_DUTY_MACHINERY_MESSAGES_BOOKING_PREFIX: "heavyDutyMachineryMessagesBookingPrefix",
    HEAVY_DUTY_MACHINERY_MESSAGES_AUTO_MSG_PENDING: "heavyDutyMachineryMessagesAutoMsgPending",
    HEAVY_DUTY_MACHINERY_MESSAGES_AUTO_MSG_CONFIRMED: "heavyDutyMachineryMessagesAutoMsgConfirmed",
    HEAVY_DUTY_MACHINERY_MESSAGES_AUTO_MSG_COMPLETED: "heavyDutyMachineryMessagesAutoMsgCompleted",
    HEAVY_DUTY_MACHINERY_MESSAGES_AUTO_MSG_CANCELLED: "heavyDutyMachineryMessagesAutoMsgCancelled",
    HEAVY_DUTY_MACHINERY_MESSAGES_AUTO_MSG_NO_SHOW: "heavyDutyMachineryMessagesAutoMsgNoShow",
    HEAVY_DUTY_MACHINERY_MESSAGES_AUTO_MSG_AWAITING_QUOTE: "heavyDutyMachineryMessagesAutoMsgAwaitingQuote",
    HEAVY_DUTY_MACHINERY_MESSAGES_AUTO_MSG_AWAITING_PAYMENT: "heavyDutyMachineryMessagesAutoMsgAwaitingPayment",
    HEAVY_DUTY_MACHINERY_MESSAGES_VIEW_ADDRESS_BUTTON: "heavyDutyMachineryMessagesViewAddressButton",
    HEAVY_DUTY_MACHINERY_MESSAGES_VIEW_DETAILS_BUTTON: "heavyDutyMachineryMessagesViewDetailsButton",
    HEAVY_DUTY_MACHINERY_MESSAGES_ADDRESS_NOT_AVAILABLE: "heavyDutyMachineryMessagesAddressNotAvailable",
    HEAVY_DUTY_MACHINERY_MESSAGES_DETAILS_PANEL_TITLE: "heavyDutyMachineryMessagesDetailsPanelTitle",
    HEAVY_DUTY_MACHINERY_MESSAGES_MAP_PLACEHOLDER: "heavyDutyMachineryMessagesMapPlaceholder",
    HEAVY_DUTY_MACHINERY_MESSAGES_TOTAL_LABEL: "heavyDutyMachineryMessagesTotalLabel",
    HEAVY_DUTY_MACHINERY_MESSAGES_DAY_PASS_LINE_LABEL: "heavyDutyMachineryMessagesDayPassLineLabel",
    HEAVY_DUTY_MACHINERY_MESSAGES_VIEW_BREAKDOWN_BUTTON: "heavyDutyMachineryMessagesViewBreakdownButton",
    HEAVY_DUTY_MACHINERY_SPACE_IDENTIFICATION_GROUP: "heavyDutyMachinerySpaceIdentificationGroup",
    HEAVY_DUTY_MACHINERY_SPACE_IDENTIFICATION_HELP: "heavyDutyMachinerySpaceIdentificationHelp",
    HEAVY_DUTY_MACHINERY_SPACE_SERIAL_NUMBER_LABEL: "heavyDutyMachinerySpaceSerialNumberLabel",
    HEAVY_DUTY_MACHINERY_SPACE_INTERNAL_REFERENCE_LABEL: "heavyDutyMachinerySpaceInternalReferenceLabel",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_TITLE: "heavyDutyMachineryOutOfServiceTitle",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_DESCRIPTION: "heavyDutyMachineryOutOfServiceDescription",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_UNTIL_LABEL: "heavyDutyMachineryOutOfServiceUntilLabel",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_UNTIL_PLACEHOLDER: "heavyDutyMachineryOutOfServiceUntilPlaceholder",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_UNTIL_HELP: "heavyDutyMachineryOutOfServiceUntilHelp",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_REASON_LABEL: "heavyDutyMachineryOutOfServiceReasonLabel",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_REASON_PLACEHOLDER: "heavyDutyMachineryOutOfServiceReasonPlaceholder",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_REASON_HELP: "heavyDutyMachineryOutOfServiceReasonHelp",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_REASON_REQUIRED: "heavyDutyMachineryOutOfServiceReasonRequired",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_CONFIRM: "heavyDutyMachineryOutOfServiceConfirm",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_SUCCESS: "heavyDutyMachineryOutOfServiceSuccess",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_ERROR: "heavyDutyMachineryOutOfServiceError",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_ACTION: "heavyDutyMachineryOutOfServiceAction",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_BADGE: "heavyDutyMachineryOutOfServiceBadge",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_BADGE_UNTIL: "heavyDutyMachineryOutOfServiceBadgeUntil",
    HEAVY_DUTY_MACHINERY_BACK_IN_SERVICE_ACTION: "heavyDutyMachineryBackInServiceAction",
    HEAVY_DUTY_MACHINERY_BACK_IN_SERVICE_SUCCESS: "heavyDutyMachineryBackInServiceSuccess",
    HEAVY_DUTY_MACHINERY_BACK_IN_SERVICE_ERROR: "heavyDutyMachineryBackInServiceError",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_AFFECTED_TITLE: "heavyDutyMachineryOutOfServiceAffectedTitle",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_AFFECTED_DESCRIPTION: "heavyDutyMachineryOutOfServiceAffectedDescription",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_AFFECTED_NONE: "heavyDutyMachineryOutOfServiceAffectedNone",
    HEAVY_DUTY_MACHINERY_OUT_OF_SERVICE_AFFECTED_OPEN: "heavyDutyMachineryOutOfServiceAffectedOpen",
    CHECK_OUT_STILL_OPERATIONAL_TITLE: "checkOutStillOperationalTitle",
    CHECK_OUT_STILL_OPERATIONAL_DESCRIPTION: "checkOutStillOperationalDescription",
    CHECK_OUT_STILL_OPERATIONAL_YES: "checkOutStillOperationalYes",
    CHECK_OUT_STILL_OPERATIONAL_NO: "checkOutStillOperationalNo",
    HEAVY_DUTY_MACHINERY_BOOKING_LOCATION_PICKUP_LABEL: "heavyDutyMachineryBookingLocationPickupLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_LOCATION_ORIGIN_LABEL: "heavyDutyMachineryBookingLocationOriginLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_LOCATION_DELIVERY_LABEL: "heavyDutyMachineryBookingLocationDeliveryLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_LOCATION_ADDRESS_NOT_SET: "heavyDutyMachineryBookingLocationAddressNotSet",
    HEAVY_DUTY_MACHINERY_BOOKING_LOCATION_DELIVERY_POINT_HINT: "heavyDutyMachineryBookingLocationDeliveryPointHint",
    HEAVY_DUTY_MACHINERY_BOOKING_HANDOVER_LABEL: "heavyDutyMachineryBookingHandoverLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_HANDOVER_SELF_PICKUP: "heavyDutyMachineryBookingHandoverSelfPickup",
    HEAVY_DUTY_MACHINERY_BOOKING_HANDOVER_DELIVERY: "heavyDutyMachineryBookingHandoverDelivery",
    HEAVY_DUTY_MACHINERY_BOOKING_HANDOVER_DELIVERY_AND_COLLECTION: "heavyDutyMachineryBookingHandoverDeliveryAndCollection",
    HEAVY_DUTY_MACHINERY_BOOKING_OPERATOR_ROW_LABEL: "heavyDutyMachineryBookingOperatorRowLabel",
    HEAVY_DUTY_MACHINERY_BOOKING_OPERATOR_ROW_NONE: "heavyDutyMachineryBookingOperatorRowNone",
    HEAVY_DUTY_MACHINERY_MESSAGES_YOU_LABEL: "heavyDutyMachineryMessagesYouLabel",
    HEAVY_DUTY_MACHINERY_MESSAGES_TYPING_INDICATOR: "heavyDutyMachineryMessagesTypingIndicator",
    HEAVY_DUTY_MACHINERY_MESSAGES_ADDRESS_MODAL_TITLE: "heavyDutyMachineryMessagesAddressModalTitle",
    HEAVY_DUTY_MACHINERY_MESSAGES_HIDE_ACTION: "heavyDutyMachineryMessagesHideAction",
    HEAVY_DUTY_MACHINERY_MESSAGES_HIDE_CONFIRM_TITLE: "heavyDutyMachineryMessagesHideConfirmTitle",
    HEAVY_DUTY_MACHINERY_MESSAGES_HIDE_CONFIRM_DESCRIPTION: "heavyDutyMachineryMessagesHideConfirmDescription",
    HEAVY_DUTY_MACHINERY_MESSAGES_HIDE_CONFIRM_BUTTON: "heavyDutyMachineryMessagesHideConfirmButton",
    HEAVY_DUTY_MACHINERY_MESSAGES_HIDE_CANCEL_BUTTON: "heavyDutyMachineryMessagesHideCancelButton",
    HEAVY_DUTY_MACHINERY_MESSAGES_HIDE_ERROR: "heavyDutyMachineryMessagesHideError",
    HEAVY_DUTY_MACHINERY_INVOICES_SECTION_TITLE: "heavyDutyMachineryInvoicesSectionTitle",
    HEAVY_DUTY_MACHINERY_INVOICE_TYPE_HOST_TO_GUEST: "heavyDutyMachineryInvoiceTypeHostToGuest",
    HEAVY_DUTY_MACHINERY_INVOICE_TYPE_PLATFORM_COMMISSION: "heavyDutyMachineryInvoiceTypePlatformCommission",
    HEAVY_DUTY_MACHINERY_INVOICE_DOWNLOAD_BUTTON: "heavyDutyMachineryInvoiceDownloadButton",
    HEAVY_DUTY_MACHINERY_INVOICE_DOWNLOAD_ERROR: "heavyDutyMachineryInvoiceDownloadError",
    HEAVY_DUTY_MACHINERY_INVOICE_BUTTON: "heavyDutyMachineryInvoiceButton",
    HEAVY_DUTY_MACHINERY_INVOICE_NOT_AVAILABLE: "heavyDutyMachineryInvoiceNotAvailable",
    HEAVY_DUTY_MACHINERY_INVOICE_KIND_SIMPLIFIED: "heavyDutyMachineryInvoiceKindSimplified",
    HEAVY_DUTY_MACHINERY_INVOICE_KIND_SIMPLIFIED_QUALIFIED: "heavyDutyMachineryInvoiceKindSimplifiedQualified",
    HEAVY_DUTY_MACHINERY_INVOICE_KIND_COMPLETE: "heavyDutyMachineryInvoiceKindComplete",
    HEAVY_DUTY_MACHINERY_INVOICE_ADD_TAX_ID_BUTTON: "heavyDutyMachineryInvoiceAddTaxIdButton",
    HEAVY_DUTY_MACHINERY_INVOICE_ADD_TAX_ID_MODAL_TITLE: "heavyDutyMachineryInvoiceAddTaxIdModalTitle",
    HEAVY_DUTY_MACHINERY_INVOICE_TAX_ID_PLACEHOLDER: "heavyDutyMachineryInvoiceTaxIdPlaceholder",
    HEAVY_DUTY_MACHINERY_INVOICE_TAX_ADDRESS_PLACEHOLDER: "heavyDutyMachineryInvoiceTaxAddressPlaceholder",
    HEAVY_DUTY_MACHINERY_INVOICE_ADD_TAX_ID_SUBMIT: "heavyDutyMachineryInvoiceAddTaxIdSubmit",
    HEAVY_DUTY_MACHINERY_INVOICE_ADD_TAX_ID_CANCEL: "heavyDutyMachineryInvoiceAddTaxIdCancel",
    HEAVY_DUTY_MACHINERY_INVOICE_ADD_TAX_ID_SUCCESS: "heavyDutyMachineryInvoiceAddTaxIdSuccess",
    HEAVY_DUTY_MACHINERY_INVOICE_ADD_TAX_ID_ERROR: "heavyDutyMachineryInvoiceAddTaxIdError",

    HEAVY_DUTY_MACHINERY_SUPPORT_TITLE: "heavyDutyMachinerySupportTitle",
    HEAVY_DUTY_MACHINERY_SUPPORT_EMPTY_TITLE: "heavyDutyMachinerySupportEmptyTitle",
    HEAVY_DUTY_MACHINERY_SUPPORT_EMPTY_DESCRIPTION: "heavyDutyMachinerySupportEmptyDescription",
    HEAVY_DUTY_MACHINERY_SUPPORT_TEAM_LABEL: "heavyDutyMachinerySupportTeamLabel",
    HEAVY_DUTY_MACHINERY_SUPPORT_CLOSED_NOTICE: "heavyDutyMachinerySupportClosedNotice",
    HEAVY_DUTY_MACHINERY_SUPPORT_BANNER_TEXT: "heavyDutyMachinerySupportBannerText",
    HEAVY_DUTY_MACHINERY_SUPPORT_BANNER_TEXT_READ: "heavyDutyMachinerySupportBannerTextRead",
    HEAVY_DUTY_MACHINERY_SUPPORT_BANNER_TEXT_START: "heavyDutyMachinerySupportBannerTextStart",

    REPORT_MODAL_TITLE: "reportModalTitle",
    REPORT_REASON_PLACEHOLDER: "reportReasonPlaceholder",
    REPORT_SUBMIT_BUTTON: "reportSubmitButton",
    REPORT_SUCCESS: "reportSuccess",
    REPORT_ERROR: "reportError",
    REPORT_CANCEL_BUTTON: "reportCancelButton",
    HEAVY_DUTY_MACHINERY_SPACE_REPORT_BUTTON: "heavyDutyMachinerySpaceReportButton",
    HEAVY_DUTY_MACHINERY_SPACE_REPORT_PHOTO_LINK: "heavyDutyMachinerySpaceReportPhotoLink",
    HEAVY_DUTY_MACHINERY_SPACE_REPORT_PHOTO_MODAL_TITLE: "heavyDutyMachinerySpaceReportPhotoModalTitle",
    HEAVY_DUTY_MACHINERY_MESSAGES_REPORT_BUTTON_LABEL: "heavyDutyMachineryMessagesReportButtonLabel",

    HEAVY_DUTY_MACHINERY_REVIEW_LEAVE_BUTTON: "heavyDutyMachineryReviewLeaveButton",
    HEAVY_DUTY_MACHINERY_REVIEW_MODAL_TITLE: "heavyDutyMachineryReviewModalTitle",
    HEAVY_DUTY_MACHINERY_REVIEW_RATING_LABEL: "heavyDutyMachineryReviewRatingLabel",
    HEAVY_DUTY_MACHINERY_REVIEW_COMMENT_LABEL: "heavyDutyMachineryReviewCommentLabel",
    HEAVY_DUTY_MACHINERY_REVIEW_COMMENT_PLACEHOLDER: "heavyDutyMachineryReviewCommentPlaceholder",
    HEAVY_DUTY_MACHINERY_REVIEW_SUBMIT_BUTTON: "heavyDutyMachineryReviewSubmitButton",
    HEAVY_DUTY_MACHINERY_REVIEW_SUBMIT_SUCCESS: "heavyDutyMachineryReviewSubmitSuccess",
    HEAVY_DUTY_MACHINERY_REVIEW_SUBMIT_ERROR: "heavyDutyMachineryReviewSubmitError",
    HEAVY_DUTY_MACHINERY_REVIEW_RATING_REQUIRED: "heavyDutyMachineryReviewRatingRequired",

    HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_BUTTON: "heavyDutyMachineryReviewRespondButton",
    HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_MODAL_TITLE: "heavyDutyMachineryReviewRespondModalTitle",
    HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_LABEL: "heavyDutyMachineryReviewRespondLabel",
    HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_PLACEHOLDER: "heavyDutyMachineryReviewRespondPlaceholder",
    HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_SUBMIT_BUTTON: "heavyDutyMachineryReviewRespondSubmitButton",
    HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_SUCCESS: "heavyDutyMachineryReviewRespondSuccess",
    HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_ERROR: "heavyDutyMachineryReviewRespondError",
    HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_REQUIRED: "heavyDutyMachineryReviewRespondRequired",

    HEAVY_DUTY_MACHINERY_REVIEWS_SECTION_TITLE: "heavyDutyMachineryReviewsSectionTitle",
    HEAVY_DUTY_MACHINERY_REVIEWS_EMPTY: "heavyDutyMachineryReviewsEmpty",
    HEAVY_DUTY_MACHINERY_REVIEWS_EMPTY_DESCRIPTION: "heavyDutyMachineryReviewsEmptyDescription",
    HEAVY_DUTY_MACHINERY_REVIEWS_LOAD_ERROR: "heavyDutyMachineryReviewsLoadError",
    HEAVY_DUTY_MACHINERY_REVIEWS_AVERAGE_LABEL: "heavyDutyMachineryReviewsAverageLabel",
    HEAVY_DUTY_MACHINERY_REVIEWS_COUNT_LABEL: "heavyDutyMachineryReviewsCountLabel",
    HEAVY_DUTY_MACHINERY_REVIEWS_HOST_RESPONSE_LABEL: "heavyDutyMachineryReviewsHostResponseLabel",
    HEAVY_DUTY_MACHINERY_REVIEWS_NIGHTS_SUFFIX: "heavyDutyMachineryReviewsNightsSuffix",
    HEAVY_DUTY_MACHINERY_REVIEWS_NO_RATING_YET: "heavyDutyMachineryReviewsNoRatingYet",

    HEAVY_DUTY_MACHINERY_NAV_EXPLORE: "heavyDutyMachineryNavExplore",
    HEAVY_DUTY_MACHINERY_NAV_HOST_TOOLS: "heavyDutyMachineryNavHostTools",
    HEAVY_DUTY_MACHINERY_NAV_MY_SPACES: "heavyDutyMachineryNavMySpaces",
    HEAVY_DUTY_MACHINERY_NAV_CREATE_SPACE: "heavyDutyMachineryNavCreateSpace",
    HEAVY_DUTY_MACHINERY_ADD_MENU_TITLE: "heavyDutyMachineryAddMenuTitle",
    HEAVY_DUTY_MACHINERY_NAV_MENU_ARIA_LABEL: "heavyDutyMachineryNavMenuAriaLabel",
    HEAVY_DUTY_MACHINERY_NAV_BOOKINGS_SHORT: "heavyDutyMachineryNavBookingsShort",
    HEAVY_DUTY_MACHINERY_NAV_SPACES_SHORT: "heavyDutyMachineryNavSpacesShort",
    HEAVY_DUTY_MACHINERY_NAV_PROFILE: "heavyDutyMachineryNavProfile",
    HEAVY_DUTY_MACHINERY_BOOKINGS_TOGGLE_GUEST: "heavyDutyMachineryBookingsToggleGuest",
    HEAVY_DUTY_MACHINERY_BOOKINGS_TOGGLE_HOST: "heavyDutyMachineryBookingsToggleHost",
    PROFILE_PAGE_TITLE: "profilePageTitle",
    PROFILE_MENU_LANGUAGE_LABEL: "profileMenuLanguageLabel",
    PROFILE_MENU_FAVORITES_LABEL: "profileMenuFavoritesLabel",

    HOST_OPT_ACCOUNT_TYPE_INDIVIDUAL: "hostOptAccountTypeIndividual",
    HOST_OPT_ACCOUNT_TYPE_BUSINESS: "hostOptAccountTypeBusiness",
    HOST_OPT_BUSINESS_CATEGORY_MACHINERY_RENTAL: "hostOptBusinessCategoryMachineryRental",
    HOST_OPT_BUSINESS_CATEGORY_CONSTRUCTION: "hostOptBusinessCategoryConstruction",
    HOST_OPT_BUSINESS_CATEGORY_PUBLIC_WORKS: "hostOptBusinessCategoryPublicWorks",
    HOST_OPT_BUSINESS_CATEGORY_AGRICULTURE_FORESTRY: "hostOptBusinessCategoryAgricultureForestry",
    HOST_OPT_BUSINESS_CATEGORY_LANDSCAPING: "hostOptBusinessCategoryLandscaping",
    HOST_OPT_BUSINESS_CATEGORY_DEMOLITION_RECYCLING: "hostOptBusinessCategoryDemolitionRecycling",
    HOST_OPT_BUSINESS_CATEGORY_MINING_QUARRYING: "hostOptBusinessCategoryMiningQuarrying",
    HOST_OPT_BUSINESS_CATEGORY_TRANSPORT_LOGISTICS: "hostOptBusinessCategoryTransportLogistics",
    HOST_OPT_BUSINESS_CATEGORY_INDUSTRIAL_MAINTENANCE: "hostOptBusinessCategoryIndustrialMaintenance",
    HOST_OPT_BUSINESS_CATEGORY_OTHER: "hostOptBusinessCategoryOther",
    HOST_FIELD_BUSINESS_CATEGORY_OTHER_LABEL: "hostFieldBusinessCategoryOtherLabel",
    HOST_OPT_LANGUAGE_SPANISH: "hostOptLanguageSpanish",
    HOST_OPT_LANGUAGE_ENGLISH: "hostOptLanguageEnglish",
    HOST_OPT_LANGUAGE_FRENCH: "hostOptLanguageFrench",
    HOST_OPT_LANGUAGE_GERMAN: "hostOptLanguageGerman",
    HOST_OPT_LANGUAGE_ITALIAN: "hostOptLanguageItalian",
    HOST_OPT_LANGUAGE_PORTUGUESE: "hostOptLanguagePortuguese",
    HOST_OPT_LANGUAGE_CATALAN: "hostOptLanguageCatalan",
    HOST_OPT_LANGUAGE_BASQUE: "hostOptLanguageBasque",
    HOST_OPT_LANGUAGE_GALICIAN: "hostOptLanguageGalician",
    HOST_OPT_LANGUAGE_DUTCH: "hostOptLanguageDutch",
    HOST_OPT_LANGUAGE_ARABIC: "hostOptLanguageArabic",
    HOST_OPT_LANGUAGE_CHINESE: "hostOptLanguageChinese",
    HOST_OPT_LANGUAGE_JAPANESE: "hostOptLanguageJapanese",
    HOST_OPT_LANGUAGE_RUSSIAN: "hostOptLanguageRussian",
    HOST_OPT_LANGUAGE_POLISH: "hostOptLanguagePolish",
    HOST_OPT_LANGUAGE_SWEDISH: "hostOptLanguageSwedish",
    HOST_OPT_LANGUAGE_UKRAINIAN: "hostOptLanguageUkrainian",
    HOST_OPT_LANGUAGE_SLOVAK: "hostOptLanguageSlovak",

    HOST_ONBOARDING_TITLE: "hostOnboardingTitle",
    HOST_ONBOARDING_INTRO: "hostOnboardingIntro",
    HOST_ONBOARDING_SUCCESS: "hostOnboardingSuccess",
    HOST_ONBOARDING_ERROR: "hostOnboardingError",
    HOST_ONBOARDING_ACCOUNT_TYPE_QUESTION: "hostOnboardingAccountTypeQuestion",
    HOST_ONBOARDING_BUSINESS_CATEGORY_QUESTION: "hostOnboardingBusinessCategoryQuestion",
    HOST_ONBOARDING_BUSINESS_CATEGORY_PLACEHOLDER: "hostOnboardingBusinessCategoryPlaceholder",
    HOST_ONBOARDING_BACK: "hostOnboardingBack",
    HOST_ONBOARDING_CANCEL: "hostOnboardingCancel",
    HOST_ONBOARDING_NEXT: "hostOnboardingNext",
    HOST_ONBOARDING_FINISH: "hostOnboardingFinish",
    HOST_ONBOARDING_STEP_BUSINESS_CATEGORY: "hostOnboardingStepBusinessCategory",
    HOST_ONBOARDING_STEP_LEGAL: "hostOnboardingStepLegal",
    HOST_ONBOARDING_STEP_BUSINESS_DETAILS: "hostOnboardingStepBusinessDetails",
    HOST_ONBOARDING_STEP_PUBLIC: "hostOnboardingStepPublic",

    HOST_FIELD_LEGAL_NAME_INDIVIDUAL: "hostFieldLegalNameIndividual",
    HOST_FIELD_LEGAL_NAME_BUSINESS: "hostFieldLegalNameBusiness",
    HOST_FIELD_TAX_ID_INDIVIDUAL: "hostFieldTaxIdIndividual",
    HOST_FIELD_TAX_ID_BUSINESS: "hostFieldTaxIdBusiness",
    HOST_FIELD_BUSINESS_REGISTRATION_NUMBER: "hostFieldBusinessRegistrationNumber",
    HOST_FIELD_CONTACT_PHONE: "hostFieldContactPhone",
    HOST_FIELD_BILLING_ADDRESS: "hostFieldBillingAddress",
    IDENTITY_LEGAL_STEP_ALREADY_SET_HINT: "identityLegalStepAlreadySetHint",
    HOST_FIELD_INSURANCE_POLICY_NUMBER: "hostFieldInsurancePolicyNumber",
    HOST_FIELD_INSURANCE_POLICY_NUMBER_HINT: "hostFieldInsurancePolicyNumberHint",
    HOST_FIELD_PROFILE_PHOTO: "hostFieldProfilePhoto",
    HOST_FIELD_PUBLIC_HOST_NAME: "hostFieldPublicHostName",
    HOST_FIELD_PUBLIC_HOST_NAME_HINT: "hostFieldPublicHostNameHint",
    HOST_FIELD_PUBLIC_HOST_NAME_PLACEHOLDER: "hostFieldPublicHostNamePlaceholder",
    HOST_FIELD_TAGLINE: "hostFieldTagline",
    HOST_FIELD_LANGUAGES_SPOKEN: "hostFieldLanguagesSpoken",
    HOST_FIELD_PERSONAL_BIO: "hostFieldPersonalBio",
    HOST_FIELD_COMPANY_DESCRIPTION: "hostFieldCompanyDescription",
    HOST_FIELD_FOUNDED_YEAR: "hostFieldFoundedYear",
    HOST_FIELD_TEAM_SIZE: "hostFieldTeamSize",
    HOST_FIELD_TEAM_SIZE_PLACEHOLDER: "hostFieldTeamSizePlaceholder",
    HOST_FIELD_CERTIFICATIONS: "hostFieldCertifications",
    HOST_FIELD_CERTIFICATIONS_PLACEHOLDER: "hostFieldCertificationsPlaceholder",
    HOST_FIELD_BRAND_STORY_TOGGLE: "hostFieldBrandStoryToggle",
    HOST_FIELD_BRAND_STORY: "hostFieldBrandStory",

    HOST_EDIT_LOAD_ERROR: "hostEditLoadError",
    HOST_EDIT_SAVE_SUCCESS: "hostEditSaveSuccess",
    HOST_EDIT_SAVE_ERROR: "hostEditSaveError",
    HOST_EDIT_SAVE_BUTTON: "hostEditSaveButton",
    HOST_EDIT_SECTION_LEGAL: "hostEditSectionLegal",
    HOST_EDIT_SECTION_PUBLIC: "hostEditSectionPublic",
    HOST_EDIT_ACCOUNT_TYPE_LABEL: "hostEditAccountTypeLabel",
    HOST_EDIT_BECOME_HOST_TITLE: "hostEditBecomeHostTitle",
    HOST_EDIT_BECOME_HOST_INTRO: "hostEditBecomeHostIntro",
    HOST_EDIT_BECOME_HOST_CTA: "hostEditBecomeHostCta",

    HOST_VERIFICATION_STATUS_LABEL: "hostVerificationStatusLabel",
    HOST_VERIFICATION_NOT_STARTED: "hostVerificationNotStarted",
    HOST_VERIFICATION_PENDING: "hostVerificationPending",
    HOST_VERIFICATION_VERIFIED: "hostVerificationVerified",
    HOST_VERIFICATION_REJECTED: "hostVerificationRejected",
    HOST_VERIFICATION_START_BUTTON: "hostVerificationStartButton",
    HOST_VERIFICATION_RETRY_BUTTON: "hostVerificationRetryButton",
    HOST_VERIFICATION_START_SUCCESS: "hostVerificationStartSuccess",
    HOST_VERIFICATION_START_ERROR: "hostVerificationStartError",

    HOST_PUBLIC_HOSTING_SINCE_LABEL: "hostPublicHostingSinceLabel",

    HEAVY_DUTY_MACHINERY_SPACE_HOST_LABEL: "heavyDutyMachinerySpaceHostLabel",
    HEAVY_DUTY_MACHINERY_SPACE_HOST_COMPLETED_RENTALS_LABEL: "heavyDutyMachinerySpaceHostCompletedRentalsLabel",
    HEAVY_DUTY_MACHINERY_SPACE_MORE_PHOTOS_SUFFIX: "heavyDutyMachinerySpaceMorePhotosSuffix",
    HEAVY_DUTY_MACHINERY_SPACE_FEATURES_SECTION_TITLE: "heavyDutyMachinerySpaceFeaturesSectionTitle",

    HOST_PROFILE_NAV: "hostProfileNav",

    HOST_PROFILE_SUMMARY_TITLE: "hostProfileSummaryTitle",
    HOST_PROFILE_SUMMARY_SUBTITLE: "hostProfileSummarySubtitle",
    HOST_PROFILE_LEGAL_PRIVATE_BADGE: "hostProfileLegalPrivateBadge",
    HOST_PROFILE_PUBLIC_BADGE: "hostProfilePublicBadge",
    HOST_PROFILE_EDIT_BUTTON: "hostProfileEditButton",
    HOST_PROFILE_NOT_ADDED: "hostProfileNotAdded",
    HOST_PROFILE_NO_REVIEWS_YET: "hostProfileNoReviewsYet",
    HOST_PROFILE_SPACES_ACTIVE_LABEL: "hostProfileSpacesActiveLabel",
    HOST_PROFILE_BOOKINGS_PENDING_LABEL: "hostProfileBookingsPendingLabel",

    DASHBOARD_WELCOME_TITLE: "dashboardWelcomeTitle",

    CHANGE_PASSWORD_WEAK_PASSWORD_WARNING: "changePasswordWeakPasswordWarning",
    CHANGE_PASSWORD_SUCCESS_MESSAGE: "changePasswordSuccessMessage",
    CHANGE_PASSWORD_ERROR_FALLBACK: "changePasswordErrorFallback",
    CHANGE_PASSWORD_TITLE: "changePasswordTitle",
    CHANGE_PASSWORD_SUBTITLE: "changePasswordSubtitle",
    CHANGE_PASSWORD_LOGOUT_ALERT_MESSAGE: "changePasswordLogoutAlertMessage",
    CHANGE_PASSWORD_LOGOUT_ALERT_DESCRIPTION: "changePasswordLogoutAlertDescription",
    CHANGE_PASSWORD_CURRENT_LABEL: "changePasswordCurrentLabel",
    CHANGE_PASSWORD_CURRENT_REQUIRED: "changePasswordCurrentRequired",
    CHANGE_PASSWORD_CURRENT_PLACEHOLDER: "changePasswordCurrentPlaceholder",
    CHANGE_PASSWORD_NEW_LABEL: "changePasswordNewLabel",
    CHANGE_PASSWORD_NEW_REQUIRED: "changePasswordNewRequired",
    CHANGE_PASSWORD_NEW_MIN_LENGTH: "changePasswordNewMinLength",
    CHANGE_PASSWORD_NEW_PATTERN: "changePasswordNewPattern",
    CHANGE_PASSWORD_NEW_PLACEHOLDER: "changePasswordNewPlaceholder",
    CHANGE_PASSWORD_CONFIRM_LABEL: "changePasswordConfirmLabel",
    CHANGE_PASSWORD_CONFIRM_REQUIRED: "changePasswordConfirmRequired",
    CHANGE_PASSWORD_CONFIRM_MISMATCH: "changePasswordConfirmMismatch",
    CHANGE_PASSWORD_CONFIRM_PLACEHOLDER: "changePasswordConfirmPlaceholder",

    PASSWORD_STRENGTH_REQ_LENGTH: "passwordStrengthReqLength",
    PASSWORD_STRENGTH_REQ_UPPERCASE: "passwordStrengthReqUppercase",
    PASSWORD_STRENGTH_REQ_LOWERCASE: "passwordStrengthReqLowercase",
    PASSWORD_STRENGTH_REQ_NUMBER: "passwordStrengthReqNumber",
    PASSWORD_STRENGTH_REQ_SPECIAL: "passwordStrengthReqSpecial",
    PASSWORD_STRENGTH_WEAK: "passwordStrengthWeak",
    PASSWORD_STRENGTH_FAIR: "passwordStrengthFair",
    PASSWORD_STRENGTH_GOOD: "passwordStrengthGood",
    PASSWORD_STRENGTH_STRONG: "passwordStrengthStrong",

    SETTINGS_PAGE_TITLE: "settingsPageTitle",
    SETTINGS_2FA_LOAD_ERROR: "settings2faLoadError",
    SETTINGS_2FA_CARD_TITLE: "settings2faCardTitle",
    SETTINGS_2FA_LOADING: "settings2faLoading",

    // ---- Redesigned Configuración (Settings.tsx + sections/) ----
    SETTINGS_NAV_PERSONAL: "settingsNavPersonal",
    SETTINGS_NAV_SECURITY: "settingsNavSecurity",
    SETTINGS_NAV_PRIVACY: "settingsNavPrivacy",
    SETTINGS_NAV_NOTIFICATIONS: "settingsNavNotifications",
    SETTINGS_NAV_TAXES: "settingsNavTaxes",
    SETTINGS_NAV_PAYMENTS: "settingsNavPayments",
    SETTINGS_NAV_LANGUAGE: "settingsNavLanguage",
    SETTINGS_NAV_CURRENCY: "settingsNavCurrency",
    SETTINGS_NAV_SUPPORT: "settingsNavSupport",
    SETTINGS_NAV_HOST_PROFILE: "settingsNavHostProfile",
    SETTINGS_EDIT_LINK: "settingsEditLink",
    SETTINGS_CHANGE_LINK: "settingsChangeLink",

    SETTINGS_PERSONAL_DISPLAY_NAME_LABEL: "settingsPersonalDisplayNameLabel",
    SETTINGS_PERSONAL_EMAIL_LABEL: "settingsPersonalEmailLabel",
    SETTINGS_PERSONAL_EMAIL_EDIT_HINT: "settingsPersonalEmailEditHint",
    SETTINGS_PERSONAL_PHONE_LABEL: "settingsPersonalPhoneLabel",
    SETTINGS_PERSONAL_COUNTRY_LABEL: "settingsPersonalCountryLabel",
    SETTINGS_PERSONAL_PHOTO_LABEL: "settingsPersonalPhotoLabel",
    SETTINGS_PERSONAL_PHOTO_HINT: "settingsPersonalPhotoHint",

    SETTINGS_OAUTH_CARD_TITLE: "settingsOauthCardTitle",
    SETTINGS_OAUTH_CONNECTED: "settingsOauthConnected",
    SETTINGS_OAUTH_NOT_CONNECTED: "settingsOauthNotConnected",
    SETTINGS_OAUTH_DISCONNECT_BUTTON: "settingsOauthDisconnectButton",
    SETTINGS_OAUTH_UNLINK_CONFIRM: "settingsOauthUnlinkConfirm",
    SETTINGS_OAUTH_UNLINK_SUCCESS: "settingsOauthUnlinkSuccess",
    SETTINGS_OAUTH_UNLINK_ERROR: "settingsOauthUnlinkError",

    SETTINGS_SESSIONS_CARD_TITLE: "settingsSessionsCardTitle",
    SETTINGS_SESSIONS_LOAD_ERROR: "settingsSessionsLoadError",
    SETTINGS_SESSION_CURRENT_LABEL: "settingsSessionCurrentLabel",
    SETTINGS_SESSION_LAST_ACTIVE_LABEL: "settingsSessionLastActiveLabel",
    SETTINGS_SESSION_UNKNOWN_DEVICE: "settingsSessionUnknownDevice",
    SETTINGS_SESSION_REVOKE_BUTTON: "settingsSessionRevokeButton",
    SETTINGS_SESSION_REVOKE_SUCCESS: "settingsSessionRevokeSuccess",
    SETTINGS_SESSION_REVOKE_ERROR: "settingsSessionRevokeError",
    SETTINGS_SESSION_REVOKE_ALL_BUTTON: "settingsSessionRevokeAllButton",
    SETTINGS_SESSION_REVOKE_ALL_CONFIRM: "settingsSessionRevokeAllConfirm",
    SETTINGS_SESSION_REVOKE_ALL_SUCCESS: "settingsSessionRevokeAllSuccess",

    SETTINGS_PRIVACY_MESSAGES_SECTION: "settingsPrivacyMessagesSection",
    SETTINGS_PRIVACY_READ_RECEIPTS_TITLE: "settingsPrivacyReadReceiptsTitle",
    SETTINGS_PRIVACY_READ_RECEIPTS_DESCRIPTION: "settingsPrivacyReadReceiptsDescription",
    SETTINGS_PRIVACY_SPACES_SECTION: "settingsPrivacySpacesSection",
    SETTINGS_PRIVACY_SEARCH_INDEXABLE_TITLE: "settingsPrivacySearchIndexableTitle",
    SETTINGS_PRIVACY_SEARCH_INDEXABLE_DESCRIPTION: "settingsPrivacySearchIndexableDescription",
    SETTINGS_PRIVACY_QUOTE_RESPONSE_WINDOW_TITLE: "settingsPrivacyQuoteResponseWindowTitle",
    SETTINGS_PRIVACY_QUOTE_RESPONSE_WINDOW_DESCRIPTION: "settingsPrivacyQuoteResponseWindowDescription",
    SETTINGS_PRIVACY_QUOTE_RESPONSE_WINDOW_HOURS: "settingsPrivacyQuoteResponseWindowHours",
    SETTINGS_PRIVACY_QUOTE_GUEST_WINDOW_TITLE: "settingsPrivacyQuoteGuestWindowTitle",
    SETTINGS_PRIVACY_QUOTE_GUEST_WINDOW_DESCRIPTION: "settingsPrivacyQuoteGuestWindowDescription",
    SETTINGS_PRIVACY_QUOTE_GUEST_WINDOW_DAYS: "settingsPrivacyQuoteGuestWindowDays",
    SETTINGS_PRIVACY_REVIEWS_SECTION: "settingsPrivacyReviewsSection",
    SETTINGS_PRIVACY_SHOW_LOCATION_TITLE: "settingsPrivacyShowLocationTitle",
    SETTINGS_PRIVACY_SHOW_LOCATION_DESCRIPTION: "settingsPrivacyShowLocationDescription",
    SETTINGS_PRIVACY_SHOW_DURATION_TITLE: "settingsPrivacyShowDurationTitle",
    SETTINGS_PRIVACY_SHOW_DURATION_DESCRIPTION: "settingsPrivacyShowDurationDescription",
    SETTINGS_PRIVACY_GDPR_SECTION: "settingsPrivacyGdprSection",
    SETTINGS_PRIVACY_REQUEST_DATA_BUTTON: "settingsPrivacyRequestDataButton",
    SETTINGS_PRIVACY_COOKIE_PREFERENCES_BUTTON: "settingsPrivacyCookiePreferencesButton",
    SETTINGS_GDPR_EXPORT_SUCCESS: "settingsGdprExportSuccess",
    SETTINGS_GDPR_EXPORT_ERROR: "settingsGdprExportError",

    SETTINGS_COOKIES_MODAL_TITLE: "settingsCookiesModalTitle",
    SETTINGS_COOKIES_MODAL_INTRO: "settingsCookiesModalIntro",
    SETTINGS_COOKIES_SAVE_BUTTON: "settingsCookiesSaveButton",
    SETTINGS_COOKIES_NECESSARY_TITLE: "settingsCookiesNecessaryTitle",
    SETTINGS_COOKIES_NECESSARY_DESCRIPTION: "settingsCookiesNecessaryDescription",
    SETTINGS_COOKIES_ANALYTICS_TITLE: "settingsCookiesAnalyticsTitle",
    SETTINGS_COOKIES_ANALYTICS_DESCRIPTION: "settingsCookiesAnalyticsDescription",
    SETTINGS_COOKIES_BANNER_TEXT: "settingsCookiesBannerText",
    SETTINGS_COOKIES_ACCEPT_ALL_BUTTON: "settingsCookiesAcceptAllButton",
    SETTINGS_COOKIES_NECESSARY_ONLY_BUTTON: "settingsCookiesNecessaryOnlyButton",
    SETTINGS_COOKIES_CUSTOMIZE_BUTTON: "settingsCookiesCustomizeButton",

    SETTINGS_NOTIF_BOOKING_CONFIRMATION_TITLE: "settingsNotifBookingConfirmationTitle",
    SETTINGS_NOTIF_BOOKING_CONFIRMATION_DESCRIPTION: "settingsNotifBookingConfirmationDescription",
    SETTINGS_NOTIF_CHAT_MESSAGE_TITLE: "settingsNotifChatMessageTitle",
    SETTINGS_NOTIF_CHAT_MESSAGE_DESCRIPTION: "settingsNotifChatMessageDescription",
    SETTINGS_NOTIF_BOOKING_REMINDER_TITLE: "settingsNotifBookingReminderTitle",
    SETTINGS_NOTIF_BOOKING_REMINDER_DESCRIPTION: "settingsNotifBookingReminderDescription",
    SETTINGS_NOTIF_PLATFORM_NEWS_TITLE: "settingsNotifPlatformNewsTitle",
    SETTINGS_NOTIF_PLATFORM_NEWS_DESCRIPTION: "settingsNotifPlatformNewsDescription",
    SETTINGS_NOTIF_CHANNEL_EMAIL: "settingsNotifChannelEmail",
    SETTINGS_NOTIF_CHANNEL_PUSH: "settingsNotifChannelPush",
    SETTINGS_NOTIF_CHANNEL_NONE: "settingsNotifChannelNone",
    PUSH_DEVICE_TITLE: "pushDeviceTitle",
    PUSH_DEVICE_DESCRIPTION: "pushDeviceDescription",
    PUSH_DEVICE_UNSUPPORTED: "pushDeviceUnsupported",
    PUSH_DEVICE_INSTALL_FIRST: "pushDeviceInstallFirst",
    PUSH_DEVICE_BLOCKED: "pushDeviceBlocked",
    PUSH_DEVICE_NOT_CONFIGURED: "pushDeviceNotConfigured",
    PUSH_DEVICE_ERROR: "pushDeviceError",

    SETTINGS_TAXES_NOT_HOST: "settingsTaxesNotHost",
    SETTINGS_TAXES_DOCUMENTS_TITLE: "settingsTaxesDocumentsTitle",
    SETTINGS_TAXES_DOCUMENTS_PLACEHOLDER: "settingsTaxesDocumentsPlaceholder",

    SETTINGS_PAYMENTS_TAB_PAYMENTS: "settingsPaymentsTabPayments",
    SETTINGS_PAYMENTS_TAB_PAYOUTS: "settingsPaymentsTabPayouts",
    SETTINGS_PAYMENTS_COMING_SOON: "settingsPaymentsComingSoon",

    SETTINGS_PAYOUTS_NOT_HOST: "settingsPayoutsNotHost",
    SETTINGS_PAYOUTS_STATUS_LABEL: "settingsPayoutsStatusLabel",
    SETTINGS_PAYOUTS_STATUS_NOT_STARTED: "settingsPayoutsStatusNotStarted",
    SETTINGS_PAYOUTS_STATUS_PENDING: "settingsPayoutsStatusPending",
    SETTINGS_PAYOUTS_STATUS_VERIFIED: "settingsPayoutsStatusVerified",
    SETTINGS_PAYOUTS_STATUS_REJECTED: "settingsPayoutsStatusRejected",
    SETTINGS_PAYOUTS_START_BUTTON: "settingsPayoutsStartButton",
    SETTINGS_PAYOUTS_CONTINUE_BUTTON: "settingsPayoutsContinueButton",
    SETTINGS_PAYOUTS_VERIFIED_MESSAGE: "settingsPayoutsVerifiedMessage",
    SETTINGS_PAYOUTS_ERROR: "settingsPayoutsError",

    SETTINGS_TIMEZONE_LABEL: "settingsTimezoneLabel",
    SETTINGS_CURRENCY_LABEL: "settingsCurrencyLabel",
    SETTINGS_CURRENCY_HELP: "settingsCurrencyHelp",

    DELETE_ACCOUNT_CONFIRM_REQUIRED_ERROR: "deleteAccountConfirmRequiredError",
    DELETE_ACCOUNT_SCHEDULED_MESSAGE: "deleteAccountScheduledMessage",
    DELETE_ACCOUNT_ERROR_FALLBACK: "deleteAccountErrorFallback",
    DELETE_ACCOUNT_DANGER_ZONE_TITLE: "deleteAccountDangerZoneTitle",
    DELETE_ACCOUNT_ALERT_MESSAGE: "deleteAccountAlertMessage",
    DELETE_ACCOUNT_ALERT_DESCRIPTION: "deleteAccountAlertDescription",
    DELETE_ACCOUNT_BUTTON: "deleteAccountButton",
    DELETE_ACCOUNT_MODAL_WARNING_MESSAGE: "deleteAccountModalWarningMessage",
    DELETE_ACCOUNT_MODAL_BULLET_1: "deleteAccountModalBullet1",
    DELETE_ACCOUNT_MODAL_BULLET_2: "deleteAccountModalBullet2",
    DELETE_ACCOUNT_MODAL_BULLET_3: "deleteAccountModalBullet3",
    DELETE_ACCOUNT_MODAL_BULLET_4: "deleteAccountModalBullet4",
    DELETE_ACCOUNT_MODAL_BULLET_5: "deleteAccountModalBullet5",
    DELETE_ACCOUNT_PASSWORD_LABEL: "deleteAccountPasswordLabel",
    DELETE_ACCOUNT_PASSWORD_REQUIRED: "deleteAccountPasswordRequired",
    DELETE_ACCOUNT_PASSWORD_PLACEHOLDER: "deleteAccountPasswordPlaceholder",
    DELETE_ACCOUNT_REASON_LABEL: "deleteAccountReasonLabel",
    DELETE_ACCOUNT_REASON_PLACEHOLDER: "deleteAccountReasonPlaceholder",
    DELETE_ACCOUNT_MUST_CONFIRM_ERROR: "deleteAccountMustConfirmError",
    DELETE_ACCOUNT_CHECKBOX_LABEL: "deleteAccountCheckboxLabel",
    DELETE_ACCOUNT_CANCEL_BUTTON: "deleteAccountCancelButton",
    DELETE_ACCOUNT_CONFIRM_BUTTON: "deleteAccountConfirmButton",
    DELETE_ACCOUNT_WAIT_BUTTON: "deleteAccountWaitButton",


    TWO_FA_SETTINGS_SUBTITLE: "twoFaSettingsSubtitle",
    TWO_FA_DISABLE_CONFIRM_TITLE: "twoFaDisableConfirmTitle",
    TWO_FA_DISABLE_CONFIRM_CONTENT: "twoFaDisableConfirmContent",
    TWO_FA_DISABLE_CONFIRM_OK: "twoFaDisableConfirmOk",
    TWO_FA_PASSWORD_REQUIRED_WARNING: "twoFaPasswordRequiredWarning",
    TWO_FA_DISABLED_SUCCESS: "twoFaDisabledSuccess",
    TWO_FA_DISABLE_ERROR_FALLBACK: "twoFaDisableErrorFallback",
    TWO_FA_ENABLED_SWITCH_LABEL: "twoFaEnabledSwitchLabel",
    TWO_FA_DISABLED_SWITCH_LABEL: "twoFaDisabledSwitchLabel",
    TWO_FA_ENABLED_ALERT_MESSAGE: "twoFaEnabledAlertMessage",
    TWO_FA_ENABLED_ALERT_DESCRIPTION: "twoFaEnabledAlertDescription",
    TWO_FA_DISABLED_ALERT_MESSAGE: "twoFaDisabledAlertMessage",
    TWO_FA_DISABLED_ALERT_DESCRIPTION: "twoFaDisabledAlertDescription",
    TWO_FA_HOW_IT_WORKS_TITLE: "twoFaHowItWorksTitle",
    TWO_FA_HOW_STEP_1: "twoFaHowStep1",
    TWO_FA_HOW_STEP_2: "twoFaHowStep2",
    TWO_FA_HOW_STEP_3: "twoFaHowStep3",
    TWO_FA_HOW_STEP_4: "twoFaHowStep4",
    TWO_FA_HOW_STEP_5: "twoFaHowStep5",
    TWO_FA_ENABLE_BUTTON: "twoFaEnableButton",
    TWO_FA_CONFIRM_PASSWORD_MODAL_TITLE: "twoFaConfirmPasswordModalTitle",
    TWO_FA_DISABLE_BUTTON: "twoFaDisableButton",
    TWO_FA_SECURITY_VERIFICATION_MESSAGE: "twoFaSecurityVerificationMessage",
    TWO_FA_SECURITY_VERIFICATION_DESCRIPTION: "twoFaSecurityVerificationDescription",
    TWO_FA_PASSWORD_LABEL: "twoFaPasswordLabel",
    TWO_FA_PASSWORD_PLACEHOLDER: "twoFaPasswordPlaceholder",

    LOGIN_2FA_CODE_WARNING: "login2faCodeWarning",
    LOGIN_2FA_SUCCESS: "login2faSuccess",
    LOGIN_2FA_INVALID_CODE_ERROR: "login2faInvalidCodeError",
    LOGIN_2FA_BACKUP_CODE_WARNING: "login2faBackupCodeWarning",
    LOGIN_2FA_BACKUP_SUCCESS: "login2faBackupSuccess",
    LOGIN_2FA_BACKUP_INVALID: "login2faBackupInvalid",
    LOGIN_2FA_TITLE: "login2faTitle",
    LOGIN_2FA_LOGGING_IN_AS: "login2faLoggingInAs",
    LOGIN_2FA_ALERT_TITLE_CODE: "login2faAlertTitleCode",
    LOGIN_2FA_ALERT_TITLE_BACKUP: "login2faAlertTitleBackup",
    LOGIN_2FA_ALERT_DESCRIPTION_CODE: "login2faAlertDescriptionCode",
    LOGIN_2FA_ALERT_DESCRIPTION_BACKUP: "login2faAlertDescriptionBackup",
    LOGIN_2FA_CODE_LABEL: "login2faCodeLabel",
    LOGIN_2FA_CODE_REFRESH_HINT: "login2faCodeRefreshHint",
    LOGIN_2FA_BACKUP_CODE_LABEL: "login2faBackupCodeLabel",
    LOGIN_2FA_VERIFY_BACKUP_BUTTON: "login2faVerifyBackupButton",
    LOGIN_2FA_USE_AUTHENTICATOR_LINK: "login2faUseAuthenticatorLink",
    LOGIN_2FA_USE_BACKUP_LINK: "login2faUseBackupLink",
    LOGIN_2FA_BACK_TO_LOGIN: "login2faBackToLogin",
    LOGIN_2FA_HELP_TITLE: "login2faHelpTitle",
    LOGIN_2FA_HELP_TIP_1: "login2faHelpTip1",
    LOGIN_2FA_HELP_TIP_2: "login2faHelpTip2",
    LOGIN_2FA_HELP_TIP_3: "login2faHelpTip3",

    ENABLE_2FA_INITIATE_ERROR: "enable2faInitiateError",
    ENABLE_2FA_CODE_WARNING: "enable2faCodeWarning",
    ENABLE_2FA_ENABLED_SUCCESS: "enable2faEnabledSuccess",
    ENABLE_2FA_INVALID_CODE_ERROR: "enable2faInvalidCodeError",
    ENABLE_2FA_KEY_COPIED: "enable2faKeyCopied",
    ENABLE_2FA_CODES_DOWNLOADED: "enable2faCodesDownloaded",
    ENABLE_2FA_CODES_COPIED: "enable2faCodesCopied",
    ENABLE_2FA_STEP1_TITLE: "enable2faStep1Title",
    ENABLE_2FA_STEP1_DESCRIPTION: "enable2faStep1Description",
    ENABLE_2FA_MANUAL_ENTRY_LABEL: "enable2faManualEntryLabel",
    ENABLE_2FA_COPY_BUTTON: "enable2faCopyButton",
    ENABLE_2FA_NEXT_VERIFY_BUTTON: "enable2faNextVerifyButton",
    ENABLE_2FA_STEP2_TITLE: "enable2faStep2Title",
    ENABLE_2FA_STEP2_DESCRIPTION: "enable2faStep2Description",
    ENABLE_2FA_ENTER_CODE_LABEL: "enable2faEnterCodeLabel",
    ENABLE_2FA_BACK_BUTTON: "enable2faBackButton",
    ENABLE_2FA_VERIFY_ENABLE_BUTTON: "enable2faVerifyEnableButton",
    ENABLE_2FA_STEP3_TITLE: "enable2faStep3Title",
    ENABLE_2FA_STEP3_DESCRIPTION: "enable2faStep3Description",
    ENABLE_2FA_BACKUP_CODES_TITLE: "enable2faBackupCodesTitle",
    ENABLE_2FA_BACKUP_CODES_HINT: "enable2faBackupCodesHint",
    ENABLE_2FA_DOWNLOAD_BUTTON: "enable2faDownloadButton",
    ENABLE_2FA_IMPORTANT_ALERT_MESSAGE: "enable2faImportantAlertMessage",
    ENABLE_2FA_IMPORTANT_ALERT_DESCRIPTION: "enable2faImportantAlertDescription",
    ENABLE_2FA_DONE_BUTTON: "enable2faDoneButton",
    ENABLE_2FA_MODAL_TITLE: "enable2faModalTitle",
    ENABLE_2FA_STEPS_SCAN: "enable2faStepsScan",
    ENABLE_2FA_STEPS_VERIFY: "enable2faStepsVerify",
    ENABLE_2FA_STEPS_SAVE: "enable2faStepsSave",

    LOGIN_FORM_INVALID_SERVER_RESPONSE: "loginFormInvalidServerResponse",
    LOGIN_FORM_2FA_PROMPT_INFO: "loginForm2faPromptInfo",
    LOGIN_FORM_ERROR_FALLBACK: "loginFormErrorFallback",
    LOGIN_FORM_ACCOUNT_DELETION_TITLE: "loginFormAccountDeletionTitle",
    LOGIN_FORM_ACCOUNT_DELETION_BODY: "loginFormAccountDeletionBody",
    LOGIN_FORM_ACCOUNT_DELETION_DAYS_REMAINING: "loginFormAccountDeletionDaysRemaining",
    LOGIN_FORM_ACCOUNT_DELETION_CHECK_EMAIL: "loginFormAccountDeletionCheckEmail",
    LOGIN_FORM_ACCOUNT_LOCKED_TITLE: "loginFormAccountLockedTitle",
    LOGIN_FORM_ACCOUNT_LOCKED_DEFAULT_MESSAGE: "loginFormAccountLockedDefaultMessage",
    LOGIN_FORM_ACCOUNT_LOCKED_UNLOCK_IN: "loginFormAccountLockedUnlockIn",
    LOGIN_FORM_ACCOUNT_LOCKED_CONTACT_SUPPORT: "loginFormAccountLockedContactSupport",

    REGISTRATION_LOAD_COUNTRIES_ERROR: "registrationLoadCountriesError",
    REGISTRATION_EMAIL_EXISTS_HELP: "registrationEmailExistsHelp",
    REGISTRATION_ERROR_FALLBACK: "registrationErrorFallback",
    REGISTRATION_ALREADY_HAVE_ACCOUNT: "registrationAlreadyHaveAccount",
    REGISTRATION_LOGIN_HERE_LINK: "registrationLoginHereLink",

    RESET_PASSWORD_MISMATCH_ERROR: "resetPasswordMismatchError",
    RESET_PASSWORD_SUCCESS: "resetPasswordSuccess",
    RESET_PASSWORD_ERROR_FALLBACK: "resetPasswordErrorFallback",
    RESET_PASSWORD_TITLE: "resetPasswordTitle",
    RESET_PASSWORD_NEW_LABEL: "resetPasswordNewLabel",
    RESET_PASSWORD_NEW_REQUIRED: "resetPasswordNewRequired",
    RESET_PASSWORD_CONFIRM_LABEL: "resetPasswordConfirmLabel",
    RESET_PASSWORD_CONFIRM_REQUIRED: "resetPasswordConfirmRequired",
    RESET_PASSWORD_CONFIRM_MISMATCH: "resetPasswordConfirmMismatch",
    RESET_PASSWORD_SUBMIT_BUTTON: "resetPasswordSubmitButton",

    FORGOT_PASSWORD_SENT_SUCCESS: "forgotPasswordSentSuccess",
    FORGOT_PASSWORD_ERROR_FALLBACK: "forgotPasswordErrorFallback",
    FORGOT_PASSWORD_TITLE: "forgotPasswordTitle",
    FORGOT_PASSWORD_SUBMIT_BUTTON: "forgotPasswordSubmitButton",

    OAUTH_GOOGLE_USERINFO_ERROR: "oauthGoogleUserinfoError",
    OAUTH_GOOGLE_SUCCESS: "oauthGoogleSuccess",
    OAUTH_GOOGLE_ERROR_FALLBACK: "oauthGoogleErrorFallback",
    OAUTH_MICROSOFT_SUCCESS: "oauthMicrosoftSuccess",
    OAUTH_MICROSOFT_ERROR_FALLBACK: "oauthMicrosoftErrorFallback",
    OAUTH_FACEBOOK_SUCCESS: "oauthFacebookSuccess",
    OAUTH_FACEBOOK_ERROR_FALLBACK: "oauthFacebookErrorFallback",

    CONFIRM_ACCOUNT_PROCESSING: "confirmAccountProcessing",
    CONFIRM_ACCOUNT_INVALID_PARAMS: "confirmAccountInvalidParams",
    CONFIRM_ACCOUNT_SUCCESS_TITLE: "confirmAccountSuccessTitle",
    CONFIRM_ACCOUNT_SUCCESS_AUTHENTICATED: "confirmAccountSuccessAuthenticated",
    CONFIRM_ACCOUNT_SUCCESS_UNAUTHENTICATED: "confirmAccountSuccessUnauthenticated",
    CONFIRM_ACCOUNT_CTA_EXPLORE: "confirmAccountCtaExplore",
    CONFIRM_ACCOUNT_CTA_LOGIN: "confirmAccountCtaLogin",
    CONFIRM_ACCOUNT_ERROR_TITLE: "confirmAccountErrorTitle",
    CONFIRM_ACCOUNT_ERROR_FALLBACK: "confirmAccountErrorFallback",
    CONFIRM_ACCOUNT_CTA_HOME: "confirmAccountCtaHome",
    CONFIRM_ACCOUNT_REDIRECTING: "confirmAccountRedirecting",

    REGISTER_CHECK_EMAIL_TITLE: "registerCheckEmailTitle",
    REGISTER_CHECK_EMAIL_DESCRIPTION: "registerCheckEmailDescription",
    RESEND_CONFIRMATION_CTA: "resendConfirmationCta",
    RESEND_CONFIRMATION_SUCCESS: "resendConfirmationSuccess",
    RESEND_CONFIRMATION_ERROR_FALLBACK: "resendConfirmationErrorFallback",
    RESEND_CONFIRMATION_RATE_LIMITED: "resendConfirmationRateLimited",
    RESEND_CONFIRMATION_COOLDOWN: "resendConfirmationCooldown",
    LOGIN_EMAIL_NOT_CONFIRMED_TITLE: "loginEmailNotConfirmedTitle",
    LOGIN_EMAIL_NOT_CONFIRMED_DESCRIPTION: "loginEmailNotConfirmedDescription",
    LOGIN_EMAIL_NOT_CONFIRMED_BACK: "loginEmailNotConfirmedBack",

    OAUTH_CALLBACK_ERROR_PREFIX: "oauthCallbackErrorPrefix",
    OAUTH_CALLBACK_CSRF_ERROR: "oauthCallbackCsrfError",
    OAUTH_CALLBACK_INVALID: "oauthCallbackInvalid",
    OAUTH_CALLBACK_ERROR_FALLBACK: "oauthCallbackErrorFallback",
    OAUTH_CALLBACK_COMPLETING: "oauthCallbackCompleting",
    OAUTH_CALLBACK_FAILED_TITLE: "oauthCallbackFailedTitle",
    OAUTH_CALLBACK_BACK_TO_LOGIN: "oauthCallbackBackToLogin",
    OAUTH_CALLBACK_SUCCESS_TITLE: "oauthCallbackSuccessTitle",
    OAUTH_CALLBACK_REDIRECTING: "oauthCallbackRedirecting",

    LAYOUT_LOADING: "layoutLoading",
    APP_FOOTER_TERMS: "appFooterTerms",
    APP_FOOTER_PRIVACY: "appFooterPrivacy",

    // ---- Site footer (SiteFooter, shared by AppFooter + LandingLayout) ----
    FOOTER_SECTION_SUPPORT: "footerSectionSupport",
    FOOTER_LINK_HELP_CENTER: "footerLinkHelpCenter",
    FOOTER_LINK_SAFETY: "footerLinkSafety",
    FOOTER_LINK_CANCELLATION_OPTIONS: "footerLinkCancellationOptions",
    FOOTER_LINK_CONTACT: "footerLinkContact",
    FOOTER_SECTION_HOSTING: "footerSectionHosting",
    FOOTER_LINK_BECOME_HOST: "footerLinkBecomeHost",
    FOOTER_LINK_HOST_RESOURCES: "footerLinkHostResources",
    FOOTER_LINK_HOST_COMMUNITY: "footerLinkHostCommunity",
    FOOTER_LINK_HOST_LIABILITY: "footerLinkHostLiability",
    FOOTER_SECTION_COMPANY: "footerSectionCompany",
    FOOTER_LINK_ABOUT: "footerLinkAbout",
    FOOTER_LINK_HOW_IT_WORKS: "footerLinkHowItWorks",
    FOOTER_LINK_CAREERS: "footerLinkCareers",
    FOOTER_LINK_PRESS: "footerLinkPress",

    // ---- Info pages (InfoPage, one per footer link above except the
    // legal ones and "Publica tu espacio", which is a direct CTA, not a
    // content page) ----
    INFO_HELP_CENTER_TITLE: "infoHelpCenterTitle",
    INFO_HELP_CENTER_BODY_1: "infoHelpCenterBody1",
    INFO_HELP_CENTER_BODY_2: "infoHelpCenterBody2",
    INFO_SAFETY_TITLE: "infoSafetyTitle",
    INFO_SAFETY_BODY_1: "infoSafetyBody1",
    INFO_SAFETY_BODY_2: "infoSafetyBody2",
    INFO_CANCELLATION_OPTIONS_TITLE: "infoCancellationOptionsTitle",
    INFO_CANCELLATION_OPTIONS_BODY_1: "infoCancellationOptionsBody1",
    INFO_CANCELLATION_OPTIONS_BODY_2: "infoCancellationOptionsBody2",
    INFO_CONTACT_TITLE: "infoContactTitle",
    INFO_CONTACT_BODY_1: "infoContactBody1",
    INFO_CONTACT_BODY_2: "infoContactBody2",
    INFO_HOST_RESOURCES_TITLE: "infoHostResourcesTitle",
    INFO_HOST_RESOURCES_BODY_1: "infoHostResourcesBody1",
    INFO_HOST_RESOURCES_BODY_2: "infoHostResourcesBody2",
    INFO_HOST_COMMUNITY_TITLE: "infoHostCommunityTitle",
    INFO_HOST_COMMUNITY_BODY_1: "infoHostCommunityBody1",
    INFO_HOST_COMMUNITY_BODY_2: "infoHostCommunityBody2",
    INFO_HOST_LIABILITY_TITLE: "infoHostLiabilityTitle",
    INFO_HOST_LIABILITY_BODY_1: "infoHostLiabilityBody1",
    INFO_HOST_LIABILITY_BODY_2: "infoHostLiabilityBody2",
    INFO_ABOUT_TITLE: "infoAboutTitle",
    INFO_ABOUT_BODY_1: "infoAboutBody1",
    INFO_ABOUT_BODY_2: "infoAboutBody2",
    INFO_HOW_IT_WORKS_TITLE: "infoHowItWorksTitle",
    INFO_HOW_IT_WORKS_BODY_1: "infoHowItWorksBody1",
    INFO_HOW_IT_WORKS_BODY_2: "infoHowItWorksBody2",
    INFO_CAREERS_TITLE: "infoCareersTitle",
    INFO_CAREERS_BODY_1: "infoCareersBody1",
    INFO_CAREERS_BODY_2: "infoCareersBody2",
    INFO_PRESS_TITLE: "infoPressTitle",
    INFO_PRESS_BODY_1: "infoPressBody1",
    INFO_PRESS_BODY_2: "infoPressBody2",

    PAYMENT_FORM_STRIPE_NOT_LOADED: "paymentFormStripeNotLoaded",
    PAYMENT_FORM_INCOMPLETE_CARD: "paymentFormIncompleteCard",
    PAYMENT_FORM_SUCCESS: "paymentFormSuccess",
    PAYMENT_FORM_UNEXPECTED_ERROR: "paymentFormUnexpectedError",
    PAYMENT_FORM_TITLE: "paymentFormTitle",
    PAYMENT_FORM_AMOUNT_LABEL: "paymentFormAmountLabel",
    PAYMENT_FORM_NAME_LABEL: "paymentFormNameLabel",
    PAYMENT_FORM_ADD_BILLING_INFO: "paymentFormAddBillingInfo",
    PAYMENT_FORM_EMAIL_LABEL: "paymentFormEmailLabel",
    PAYMENT_FORM_ADDRESS_LABEL: "paymentFormAddressLabel",
    PAYMENT_FORM_CITY_LABEL: "paymentFormCityLabel",
    PAYMENT_FORM_STATE_LABEL: "paymentFormStateLabel",
    PAYMENT_FORM_POSTAL_CODE_LABEL: "paymentFormPostalCodeLabel",
    PAYMENT_FORM_COUNTRY_LABEL: "paymentFormCountryLabel",
    PAYMENT_FORM_CARD_NUMBER_LABEL: "paymentFormCardNumberLabel",
    PAYMENT_FORM_EXPIRATION_LABEL: "paymentFormExpirationLabel",
    PAYMENT_FORM_CVC_LABEL: "paymentFormCvcLabel",
    PAYMENT_FORM_PAY_BUTTON: "paymentFormPayButton",

    PHOTO_UPLOAD_SET_MAIN_LABEL: "photoUploadSetMainLabel",
    PHOTO_UPLOAD_MAIN_LABEL: "photoUploadMainLabel",
    PHOTO_UPLOAD_INVALID_TYPE: "photoUploadInvalidType",
    PHOTO_UPLOAD_TOO_LARGE: "photoUploadTooLarge",
    PHOTO_UPLOAD_FAILED: "photoUploadFailed",

    VIDEO_UPLOAD_BUTTON_LABEL: "videoUploadButtonLabel",
    VIDEO_UPLOAD_INVALID_TYPE: "videoUploadInvalidType",
    VIDEO_UPLOAD_TOO_LARGE: "videoUploadTooLarge",
    VIDEO_UPLOAD_FAILED: "videoUploadFailed",

    AVATAR_UPLOAD_INVALID_TYPE: "avatarUploadInvalidType",
    AVATAR_UPLOAD_TOO_LARGE: "avatarUploadTooLarge",
    AVATAR_UPLOAD_FAILED: "avatarUploadFailed",
    AVATAR_CROP_TITLE: "avatarCropTitle",
    AVATAR_CROP_ZOOM_LABEL: "avatarCropZoomLabel",
    AVATAR_CROP_ROTATE_LEFT: "avatarCropRotateLeft",
    AVATAR_CROP_ROTATE_RIGHT: "avatarCropRotateRight",
    AVATAR_CROP_CANCEL: "avatarCropCancel",
    AVATAR_CROP_SAVE: "avatarCropSave",
    AVATAR_CROP_FAILED: "avatarCropFailed",

    EMOJI_PICKER_TOOLTIP: "emojiPickerTooltip",

    // ---- Admin panel (see pages/Admin) ----
    HEAVY_DUTY_MACHINERY_NAV_ADMIN_BUTTON: "heavyDutyMachineryNavAdminButton",

    ADMIN_PAGE_TITLE: "adminPageTitle",
    ADMIN_SESSION_ERROR: "adminSessionError",
    ADMIN_COMING_SOON: "adminComingSoon",

    ADMIN_NAV_DASHBOARD: "adminNavDashboard",
    ADMIN_NAV_USERS: "adminNavUsers",
    ADMIN_NAV_HOSTS: "adminNavHosts",
    HEAVY_DUTY_MACHINERY_OPERATOR_SUSPENDED_BADGE: "heavyDutyMachineryOperatorSuspendedBadge",
    HEAVY_DUTY_MACHINERY_OPERATOR_SUSPENDED_NOTICE: "heavyDutyMachineryOperatorSuspendedNotice",
    HEAVY_DUTY_MACHINERY_OPERATOR_SUSPENDED_NOTICE_NO_REASON: "heavyDutyMachineryOperatorSuspendedNoticeNoReason",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_OPERATOR_SUSPENDED: "heavyDutyMachineryNotifTitleOperatorSuspended",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_OPERATOR_SUSPENDED: "heavyDutyMachineryNotifBodyOperatorSuspended",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_OPERATOR_REINSTATED: "heavyDutyMachineryNotifTitleOperatorReinstated",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_OPERATOR_REINSTATED: "heavyDutyMachineryNotifBodyOperatorReinstated",
    ADMIN_NAV_OPERATORS: "adminNavOperators",
    ADMIN_OPERATORS_SUBTITLE: "adminOperatorsSubtitle",
    ADMIN_OPERATORS_SEARCH_PLACEHOLDER: "adminOperatorsSearchPlaceholder",
    ADMIN_OPERATORS_STATE_FILTER_ALL: "adminOperatorsStateFilterAll",
    ADMIN_OPERATORS_STATE_OFFERABLE: "adminOperatorsStateOfferable",
    ADMIN_OPERATORS_STATE_SUSPENDED: "adminOperatorsStateSuspended",
    ADMIN_OPERATORS_STATE_INACTIVE: "adminOperatorsStateInactive",
    ADMIN_OPERATORS_STATE_UNLINKED: "adminOperatorsStateUnlinked",
    ADMIN_OPERATORS_LOAD_ERROR: "adminOperatorsLoadError",
    ADMIN_OPERATORS_EMPTY_TITLE: "adminOperatorsEmptyTitle",
    ADMIN_OPERATORS_EMPTY_DESCRIPTION: "adminOperatorsEmptyDescription",
    ADMIN_OPERATORS_COL_NAME: "adminOperatorsColName",
    ADMIN_OPERATORS_COL_HOST: "adminOperatorsColHost",
    ADMIN_OPERATORS_COL_CATEGORIES: "adminOperatorsColCategories",
    ADMIN_OPERATORS_COL_STATE: "adminOperatorsColState",
    ADMIN_OPERATORS_COL_MACHINES: "adminOperatorsColMachines",
    ADMIN_OPERATORS_COL_DOCS: "adminOperatorsColDocs",
    ADMIN_OPERATORS_COL_CREATED: "adminOperatorsColCreated",
    ADMIN_OPERATORS_COL_ACTIONS: "adminOperatorsColActions",
    ADMIN_OPERATORS_VIEW_BUTTON: "adminOperatorsViewButton",
    ADMIN_OPERATORS_SUSPEND_BUTTON: "adminOperatorsSuspendButton",
    ADMIN_OPERATORS_SUSPEND_MODAL_TITLE: "adminOperatorsSuspendModalTitle",
    ADMIN_OPERATORS_REINSTATE_BUTTON: "adminOperatorsReinstateButton",
    ADMIN_OPERATORS_REINSTATE_CONFIRM: "adminOperatorsReinstateConfirm",
    ADMIN_OPERATORS_DETAIL_TITLE: "adminOperatorsDetailTitle",
    ADMIN_OPERATORS_DETAIL_EMAIL: "adminOperatorsDetailEmail",
    ADMIN_OPERATORS_DETAIL_PHONE: "adminOperatorsDetailPhone",
    ADMIN_OPERATORS_DETAIL_RATE: "adminOperatorsDetailRate",
    ADMIN_OPERATORS_DETAIL_LINKED: "adminOperatorsDetailLinked",
    ADMIN_OPERATORS_DETAIL_LINKED_NONE: "adminOperatorsDetailLinkedNone",
    ADMIN_OPERATORS_DETAIL_COMPLETED: "adminOperatorsDetailCompleted",
    ADMIN_OPERATORS_DETAIL_UPCOMING: "adminOperatorsDetailUpcoming",
    ADMIN_OPERATORS_DETAIL_SUSPENDED_AT: "adminOperatorsDetailSuspendedAt",
    ADMIN_OPERATORS_DETAIL_SUSPENSION_REASON: "adminOperatorsDetailSuspensionReason",
    ADMIN_OPERATORS_DOCUMENTS_TITLE: "adminOperatorsDocumentsTitle",
    ADMIN_OPERATORS_DOCUMENTS_EMPTY: "adminOperatorsDocumentsEmpty",
    ADMIN_OPERATORS_DOCUMENTS_WARNING: "adminOperatorsDocumentsWarning",
    ADMIN_OPERATORS_DOWNLOAD_ERROR: "adminOperatorsDownloadError",
    ADMIN_NAV_SPACES: "adminNavSpaces",
    ADMIN_NAV_BOOKINGS: "adminNavBookings",
    ADMIN_NAV_REVIEWS: "adminNavReviews",
    ADMIN_NAV_REPORTS: "adminNavReports",
    ADMIN_NAV_PHOTO_MODERATION: "adminNavPhotoModeration",
    ADMIN_NAV_GEO_BLOCKING: "adminNavGeoBlocking",
    ADMIN_NAV_AGE_VERIFICATION: "adminNavAgeVerification",
    ADMIN_NAV_ROLES: "adminNavRoles",
    ADMIN_NAV_AUDIT_LOG: "adminNavAuditLog",
    ADMIN_AUDIT_LOG_LOAD_ERROR: "adminAuditLogLoadError",
    ADMIN_AUDIT_LOG_EMPTY_TITLE: "adminAuditLogEmptyTitle",
    ADMIN_AUDIT_LOG_EMPTY_DESCRIPTION: "adminAuditLogEmptyDescription",
    ADMIN_AUDIT_LOG_COL_DATE: "adminAuditLogColDate",
    ADMIN_AUDIT_LOG_COL_ADMIN: "adminAuditLogColAdmin",
    ADMIN_AUDIT_LOG_COL_ACTION: "adminAuditLogColAction",
    ADMIN_AUDIT_LOG_COL_TARGET: "adminAuditLogColTarget",
    ADMIN_AUDIT_LOG_COL_REASON: "adminAuditLogColReason",
    ADMIN_NAV_GDPR: "adminNavGdpr",
    ADMIN_NAV_ANNOUNCEMENTS: "adminNavAnnouncements",
    ADMIN_NAV_FINANCE: "adminNavFinance",
    ADMIN_NAV_CATALOG: "adminNavCatalog",
    ADMIN_CATALOG_SUBTITLE: "adminCatalogSubtitle",
    ADMIN_CATALOG_TAB_PROVIDERS: "adminCatalogTabProviders",
    ADMIN_CATALOG_TAB_SERVICES: "adminCatalogTabServices",
    ADMIN_CATALOG_TAB_ACCESSORIES: "adminCatalogTabAccessories",
    ADMIN_CATALOG_TAB_TRANSPORT: "adminCatalogTabTransport",
    ADMIN_CATALOG_TAB_INSURANCE: "adminCatalogTabInsurance",
    ADMIN_CATALOG_LOAD_ERROR: "adminCatalogLoadError",
    ADMIN_CATALOG_EMPTY_TITLE: "adminCatalogEmptyTitle",
    ADMIN_CATALOG_EMPTY_DESCRIPTION: "adminCatalogEmptyDescription",
    ADMIN_CATALOG_SEARCH_PLACEHOLDER: "adminCatalogSearchPlaceholder",
    ADMIN_CATALOG_STATE_FILTER_ALL: "adminCatalogStateFilterAll",
    ADMIN_CATALOG_PROVIDER_STATE_SUSPENDED: "adminCatalogProviderStateSuspended",
    ADMIN_CATALOG_PROVIDER_STATE_INDEPENDENT: "adminCatalogProviderStateIndependent",
    ADMIN_CATALOG_PROVIDER_STATE_SHADOW: "adminCatalogProviderStateShadow",
    ADMIN_CATALOG_PROVIDER_SHADOW_BADGE: "adminCatalogProviderShadowBadge",
    ADMIN_CATALOG_PROVIDER_SUSPENDED_BADGE: "adminCatalogProviderSuspendedBadge",
    ADMIN_CATALOG_PROVIDER_SUSPEND_MODAL: "adminCatalogProviderSuspendModal",
    ADMIN_CATALOG_PROVIDER_REINSTATE_CONFIRM: "adminCatalogProviderReinstateConfirm",
    ADMIN_CATALOG_COL_SERVICES: "adminCatalogColServices",
    ADMIN_CATALOG_COL_DOCUMENTS: "adminCatalogColDocuments",
    ADMIN_CATALOG_SERVICE_STATE_BOOKABLE: "adminCatalogServiceStateBookable",
    ADMIN_CATALOG_SERVICE_STATE_HIDDEN: "adminCatalogServiceStateHidden",
    ADMIN_CATALOG_SERVICE_STATE_SHADOW: "adminCatalogServiceStateShadow",
    ADMIN_CATALOG_SERVICE_SHADOW_BADGE: "adminCatalogServiceShadowBadge",
    ADMIN_CATALOG_SERVICE_BOOKABLE_BADGE: "adminCatalogServiceBookableBadge",
    ADMIN_CATALOG_SERVICE_HIDDEN_BADGE: "adminCatalogServiceHiddenBadge",
    ADMIN_CATALOG_COL_CATEGORY: "adminCatalogColCategory",
    ADMIN_CATALOG_COL_PROVIDER: "adminCatalogColProvider",
    ADMIN_CATALOG_COL_PRICE: "adminCatalogColPrice",
    ADMIN_CATALOG_COL_LOCATION: "adminCatalogColLocation",
    ADMIN_CATALOG_ACCESSORY_STATE_ACTIVE: "adminCatalogAccessoryStateActive",
    ADMIN_CATALOG_ACCESSORY_STATE_INACTIVE: "adminCatalogAccessoryStateInactive",
    ADMIN_CATALOG_ACCESSORY_STATE_UNRENTABLE: "adminCatalogAccessoryStateUnrentable",
    ADMIN_CATALOG_ACCESSORY_UNRENTABLE_BADGE: "adminCatalogAccessoryUnrentableBadge",
    ADMIN_CATALOG_ACCESSORY_UNRENTABLE_HINT: "adminCatalogAccessoryUnrentableHint",
    ADMIN_CATALOG_COL_QUANTITY: "adminCatalogColQuantity",
    ADMIN_CATALOG_COL_MACHINES: "adminCatalogColMachines",
    ADMIN_CATALOG_COL_STANDALONE: "adminCatalogColStandalone",
    ADMIN_CATALOG_COL_PLATE: "adminCatalogColPlate",
    ADMIN_CATALOG_COL_CONSUMPTION: "adminCatalogColConsumption",
    ADMIN_CATALOG_INSURANCE_STATE_PENDING: "adminCatalogInsuranceStatePending",
    ADMIN_CATALOG_INSURANCE_STATE_VERIFIED: "adminCatalogInsuranceStateVerified",
    ADMIN_CATALOG_INSURANCE_STATE_REJECTED: "adminCatalogInsuranceStateRejected",
    ADMIN_CATALOG_INSURANCE_STATE_EXPIRED: "adminCatalogInsuranceStateExpired",
    ADMIN_CATALOG_INSURANCE_EXPIRED_BADGE: "adminCatalogInsuranceExpiredBadge",
    ADMIN_CATALOG_INSURANCE_EXPIRED_HINT: "adminCatalogInsuranceExpiredHint",
    ADMIN_CATALOG_COL_INSURER: "adminCatalogColInsurer",
    ADMIN_CATALOG_COL_POLICY_NUMBER: "adminCatalogColPolicyNumber",
    ADMIN_CATALOG_COL_EXPIRES: "adminCatalogColExpires",
    ADMIN_CATALOG_COL_EXCESS: "adminCatalogColExcess",
    ADMIN_CATALOG_COL_DOCUMENT: "adminCatalogColDocument",
    ADMIN_MONEY_SECTION_REFUNDS: "adminMoneySectionRefunds",
    ADMIN_MONEY_NO_REFUNDS: "adminMoneyNoRefunds",
    ADMIN_MONEY_REFUND_SOURCE_PARTIAL: "adminMoneyRefundSourcePartial",
    ADMIN_MONEY_REFUND_SOURCE_CANCELLATION: "adminMoneyRefundSourceCancellation",
    ADMIN_MONEY_REFUND_SOURCE_OUT_OF_BAND: "adminMoneyRefundSourceOutOfBand",
    ADMIN_MONEY_UNLOGGED_REFUNDS: "adminMoneyUnloggedRefunds",
    ADMIN_MONEY_EVENT_REFUNDED: "adminMoneyEventRefunded",
    ADMIN_MONEY_EVENT_REFUND_OUT_OF_BAND: "adminMoneyEventRefundOutOfBand",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_PROVIDER_SUSPENDED: "heavyDutyMachineryNotifTitleProviderSuspended",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_PROVIDER_SUSPENDED: "heavyDutyMachineryNotifBodyProviderSuspended",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_PROVIDER_REINSTATED: "heavyDutyMachineryNotifTitleProviderReinstated",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_PROVIDER_REINSTATED: "heavyDutyMachineryNotifBodyProviderReinstated",
    ADMIN_MONEY_EVENT_BOOKING_CREATED: "adminMoneyEventBookingCreated",
    ADMIN_MONEY_EVENT_AUTH_ATTEMPTED: "adminMoneyEventAuthAttempted",
    ADMIN_MONEY_EVENT_AUTHORIZED: "adminMoneyEventAuthorized",
    ADMIN_MONEY_EVENT_DEPOSIT_AUTHORIZED: "adminMoneyEventDepositAuthorized",
    ADMIN_MONEY_EVENT_DEPOSIT_FAILED: "adminMoneyEventDepositFailed",
    ADMIN_MONEY_EVENT_DEPOSIT_EXPIRES: "adminMoneyEventDepositExpires",
    ADMIN_MONEY_EVENT_DEPOSIT_RELEASE_DUE: "adminMoneyEventDepositReleaseDue",
    ADMIN_MONEY_EVENT_DEPOSIT_RELEASED: "adminMoneyEventDepositReleased",
    ADMIN_MONEY_EVENT_DEPOSIT_CAPTURED: "adminMoneyEventDepositCaptured",
    ADMIN_MONEY_EVENT_TRANSPORT: "adminMoneyEventTransport",
    ADMIN_MONEY_EVENT_HANDOVER: "adminMoneyEventHandover",
    ADMIN_MONEY_EVENT_OFF_RENT: "adminMoneyEventOffRent",
    ADMIN_MONEY_EVENT_COLLECTION: "adminMoneyEventCollection",
    ADMIN_MONEY_EVENT_RETURNED: "adminMoneyEventReturned",
    ADMIN_MONEY_EVENT_FUNDS_RELEASED: "adminMoneyEventFundsReleased",
    ADMIN_MONEY_EVENT_LINE_TRANSFERRED: "adminMoneyEventLineTransferred",
    ADMIN_MONEY_EVENT_LINE_FAILED: "adminMoneyEventLineFailed",
    ADMIN_MONEY_EVENT_INVOICE: "adminMoneyEventInvoice",
    ADMIN_MONEY_EVENT_HOST_DEPOSIT: "adminMoneyEventHostDeposit",
    ADMIN_MONEY_EVENT_DISPUTE_SETTLED: "adminMoneyEventDisputeSettled",
    ADMIN_MONEY_EVENT_DISPUTE_FAILED: "adminMoneyEventDisputeFailed",
    ADMIN_MONEY_LOC_NOT_YET_ASKED: "adminMoneyLocNotYetAsked",
    ADMIN_MONEY_LOC_AUTHORIZED: "adminMoneyLocAuthorized",
    ADMIN_MONEY_LOC_ESCROW: "adminMoneyLocEscrow",
    ADMIN_MONEY_LOC_RELEASED: "adminMoneyLocReleased",
    ADMIN_MONEY_LOC_REFUNDED: "adminMoneyLocRefunded",
    ADMIN_MONEY_LOC_NOTHING: "adminMoneyLocNothing",
    ADMIN_CAPTURE_MODE_IMMEDIATE: "adminCaptureModeImmediate",
    ADMIN_CAPTURE_MODE_ON_ACCEPTANCE: "adminCaptureModeOnAcceptance",
    ADMIN_CAPTURE_MODE_ON_HANDOVER: "adminCaptureModeOnHandover",
    ADMIN_BOOKINGS_CAPTURE_MODE_FILTER_ALL: "adminBookingsCaptureModeFilterAll",
    ADMIN_BOOKINGS_COL_CAPTURE_MODE: "adminBookingsColCaptureMode",
    ADMIN_BOOKINGS_COL_MONEY: "adminBookingsColMoney",
    ADMIN_BOOKINGS_MONEY_BUTTON: "adminBookingsMoneyButton",
    ADMIN_MONEY_TITLE: "adminMoneyTitle",
    ADMIN_MONEY_LOAD_ERROR: "adminMoneyLoadError",
    ADMIN_MONEY_SECTION_AMOUNTS: "adminMoneySectionAmounts",
    ADMIN_MONEY_SECTION_DEPOSIT: "adminMoneySectionDeposit",
    ADMIN_MONEY_SECTION_LINES: "adminMoneySectionLines",
    ADMIN_MONEY_SECTION_INVOICES: "adminMoneySectionInvoices",
    ADMIN_MONEY_SECTION_TIMELINE: "adminMoneySectionTimeline",
    ADMIN_MONEY_TOTAL: "adminMoneyTotal",
    ADMIN_MONEY_REFUNDED: "adminMoneyRefunded",
    ADMIN_MONEY_NET: "adminMoneyNet",
    ADMIN_MONEY_PLATFORM_FEE: "adminMoneyPlatformFee",
    ADMIN_MONEY_HOST_PAYOUT: "adminMoneyHostPayout",
    ADMIN_MONEY_GUEST_CHARGE: "adminMoneyGuestCharge",
    ADMIN_MONEY_EXCHANGE_RATE: "adminMoneyExchangeRate",
    ADMIN_MONEY_PAYMENT_REF: "adminMoneyPaymentRef",
    ADMIN_MONEY_CONNECTED_ACCOUNT: "adminMoneyConnectedAccount",
    ADMIN_MONEY_SAVED_CARD: "adminMoneySavedCard",
    ADMIN_MONEY_SAVED_CARD_YES: "adminMoneySavedCardYes",
    ADMIN_MONEY_SAVED_CARD_NO: "adminMoneySavedCardNo",
    ADMIN_MONEY_RELEASED_AT: "adminMoneyReleasedAt",
    ADMIN_MONEY_OVERTIME: "adminMoneyOvertime",
    ADMIN_MONEY_HOST_DEPOSIT_CHARGED: "adminMoneyHostDepositCharged",
    ADMIN_MONEY_DISPUTE: "adminMoneyDispute",
    ADMIN_MONEY_DISPUTE_STUCK: "adminMoneyDisputeStuck",
    ADMIN_MONEY_LINES_MISMATCH: "adminMoneyLinesMismatch",
    ADMIN_MONEY_NO_REFUND_TIMESTAMP: "adminMoneyNoRefundTimestamp",
    ADMIN_MONEY_NO_INVOICES: "adminMoneyNoInvoices",
    ADMIN_MONEY_NO_LINES: "adminMoneyNoLines",
    ADMIN_DEPOSIT_AMOUNT: "adminDepositAmount",
    ADMIN_DEPOSIT_STATUS: "adminDepositStatus",
    ADMIN_DEPOSIT_COVERAGE: "adminDepositCoverage",
    ADMIN_DEPOSIT_COVERAGE_HOLD: "adminDepositCoverageHold",
    ADMIN_DEPOSIT_COVERAGE_SAVED_CARD: "adminDepositCoverageSavedCard",
    ADMIN_DEPOSIT_COVERAGE_NONE: "adminDepositCoverageNone",
    ADMIN_DEPOSIT_HOLD_EXPIRES: "adminDepositHoldExpires",
    ADMIN_DEPOSIT_HOLD_EXPIRED: "adminDepositHoldExpired",
    ADMIN_DEPOSIT_RELEASE_SCHEDULED: "adminDepositReleaseScheduled",
    ADMIN_DEPOSIT_RELEASED_AT: "adminDepositReleasedAt",
    ADMIN_DEPOSIT_AUTH_FAILED: "adminDepositAuthFailed",
    ADMIN_DEPOSIT_NONE: "adminDepositNone",
    ADMIN_FINANCE_TAB_DEPOSITS: "adminFinanceTabDeposits",
    ADMIN_FINANCE_TAB_HOST_DEPOSITS: "adminFinanceTabHostDeposits",
    ADMIN_DEPOSITS_HELD_NOW: "adminDepositsHeldNow",
    ADMIN_DEPOSITS_EXPIRING: "adminDepositsExpiring",
    ADMIN_DEPOSITS_EXPIRED: "adminDepositsExpired",
    ADMIN_DEPOSITS_FAILED: "adminDepositsFailed",
    ADMIN_DEPOSITS_CAPTURED: "adminDepositsCaptured",
    ADMIN_DEPOSITS_STATE_FILTER_ALL: "adminDepositsStateFilterAll",
    ADMIN_DEPOSITS_STATE_HELD: "adminDepositsStateHeld",
    ADMIN_DEPOSITS_STATE_EXPIRING: "adminDepositsStateExpiring",
    ADMIN_DEPOSITS_STATE_EXPIRED: "adminDepositsStateExpired",
    ADMIN_DEPOSITS_STATE_FAILED: "adminDepositsStateFailed",
    ADMIN_DEPOSITS_STATE_CAPTURED: "adminDepositsStateCaptured",
    ADMIN_DEPOSITS_STATE_RELEASED: "adminDepositsStateReleased",
    ADMIN_DEPOSITS_EMPTY_TITLE: "adminDepositsEmptyTitle",
    ADMIN_DEPOSITS_EMPTY_DESCRIPTION: "adminDepositsEmptyDescription",
    ADMIN_DEPOSITS_COL_RENTAL: "adminDepositsColRental",
    ADMIN_HOST_DEPOSITS_STATE_FILTER_ALL: "adminHostDepositsStateFilterAll",
    ADMIN_HOST_DEPOSITS_STATE_LOW: "adminHostDepositsStateLow",
    ADMIN_HOST_DEPOSITS_STATE_OPEN: "adminHostDepositsStateOpen",
    ADMIN_HOST_DEPOSITS_STATE_CLOSED: "adminHostDepositsStateClosed",
    ADMIN_HOST_DEPOSITS_EMPTY_TITLE: "adminHostDepositsEmptyTitle",
    ADMIN_HOST_DEPOSITS_EMPTY_DESCRIPTION: "adminHostDepositsEmptyDescription",
    ADMIN_HOST_DEPOSITS_COL_BALANCE: "adminHostDepositsColBalance",
    ADMIN_HOST_DEPOSITS_COL_FUNDED: "adminHostDepositsColFunded",
    ADMIN_HOST_DEPOSITS_COL_EXPOSURE: "adminHostDepositsColExposure",
    ADMIN_HOST_DEPOSITS_COL_MAX_BOOKING: "adminHostDepositsColMaxBooking",
    ADMIN_HOST_DEPOSITS_LOW_BADGE: "adminHostDepositsLowBadge",
    ADMIN_HOST_DEPOSITS_CLOSED_BADGE: "adminHostDepositsClosedBadge",
    ADMIN_HOST_DEPOSITS_DETAIL_TITLE: "adminHostDepositsDetailTitle",
    ADMIN_HOST_DEPOSITS_MOVEMENTS: "adminHostDepositsMovements",
    ADMIN_HOST_DEPOSITS_MOVEMENTS_EMPTY: "adminHostDepositsMovementsEmpty",
    ADMIN_HOST_DEPOSITS_LOAD_ERROR: "adminHostDepositsLoadError",
    ADMIN_DASHBOARD_IN_ESCROW: "adminDashboardInEscrow",
    ADMIN_DASHBOARD_DEPOSITS_HELD: "adminDashboardDepositsHeld",
    ADMIN_DASHBOARD_DEPOSITS_EXPIRED: "adminDashboardDepositsExpired",
    ADMIN_DASHBOARD_HOST_DEPOSITS: "adminDashboardHostDeposits",
    ADMIN_DASHBOARD_HOSTS_LOW: "adminDashboardHostsLow",
    ADMIN_DASHBOARD_FEES_THIS_MONTH: "adminDashboardFeesThisMonth",
    ADMIN_DASHBOARD_STUCK_TRANSFERS: "adminDashboardStuckTransfers",
    ADMIN_NAV_MESSAGES: "adminNavMessages",
    ADMIN_NAV_ERP_SYNC: "adminNavErpSync",
    ADMIN_NAV_FEATURE_FLAGS: "adminNavFeatureFlags",
    ADMIN_FEATURE_FLAGS_DESCRIPTION: "adminFeatureFlagsDescription",
    ADMIN_FEATURE_FLAGS_LOAD_ERROR: "adminFeatureFlagsLoadError",
    ADMIN_FEATURE_FLAG_SERVICES_ENABLED_LABEL: "adminFeatureFlagServicesEnabledLabel",
    ADMIN_FEATURE_FLAG_SERVICES_ENABLED_DESCRIPTION: "adminFeatureFlagServicesEnabledDescription",
    ADMIN_NAV_BOOKING_LINES: "adminNavBookingLines",
    ADMIN_BOOKING_LINES_DESCRIPTION: "adminBookingLinesDescription",
    ADMIN_BOOKING_LINES_LOAD_ERROR: "adminBookingLinesLoadError",
    ADMIN_BOOKING_LINES_EMPTY_TITLE: "adminBookingLinesEmptyTitle",
    ADMIN_BOOKING_LINES_EMPTY_DESCRIPTION: "adminBookingLinesEmptyDescription",
    ADMIN_BOOKING_LINES_COL_TITLE: "adminBookingLinesColTitle",
    ADMIN_BOOKING_LINES_COL_TYPE: "adminBookingLinesColType",
    ADMIN_BOOKING_LINES_COL_PROVIDER: "adminBookingLinesColProvider",
    ADMIN_BOOKING_LINES_COL_AMOUNT: "adminBookingLinesColAmount",
    ADMIN_BOOKING_LINES_COL_ATTEMPTS: "adminBookingLinesColAttempts",
    ADMIN_BOOKING_LINES_COL_ERROR: "adminBookingLinesColError",
    ADMIN_BOOKING_LINES_COL_LAST_ATTEMPT: "adminBookingLinesColLastAttempt",
    ADMIN_BOOKING_LINES_RETRY_BUTTON: "adminBookingLinesRetryButton",
    ADMIN_BOOKING_LINES_RETRY_STILL_FAILING: "adminBookingLinesRetryStillFailing",
    ADMIN_BOOKING_LINES_RESOLVE_BUTTON: "adminBookingLinesResolveButton",
    ADMIN_BOOKING_LINES_RESOLVE_MODAL_TITLE: "adminBookingLinesResolveModalTitle",
    ADMIN_ERP_SYNC_DESCRIPTION: "adminErpSyncDescription",
    ADMIN_ERP_SYNC_LOAD_ERROR: "adminErpSyncLoadError",
    ADMIN_ERP_SYNC_EMPTY_TITLE: "adminErpSyncEmptyTitle",
    ADMIN_ERP_SYNC_EMPTY_DESCRIPTION: "adminErpSyncEmptyDescription",
    ADMIN_ERP_SYNC_COL_HOST: "adminErpSyncColHost",
    ADMIN_ERP_SYNC_COL_EVENT_TYPE: "adminErpSyncColEventType",
    ADMIN_ERP_SYNC_COL_ATTEMPTS: "adminErpSyncColAttempts",
    ADMIN_ERP_SYNC_COL_ERROR: "adminErpSyncColError",
    ADMIN_ERP_SYNC_COL_CREATED_AT: "adminErpSyncColCreatedAt",

    ADMIN_MESSAGES_STATUS_FILTER_ALL: "adminMessagesStatusFilterAll",
    ADMIN_MESSAGES_STATUS_OPEN: "adminMessagesStatusOpen",
    ADMIN_MESSAGES_STATUS_CLOSED: "adminMessagesStatusClosed",
    ADMIN_MESSAGES_LOAD_ERROR: "adminMessagesLoadError",
    ADMIN_MESSAGES_EMPTY_TITLE: "adminMessagesEmptyTitle",
    ADMIN_MESSAGES_EMPTY_DESCRIPTION: "adminMessagesEmptyDescription",
    ADMIN_MESSAGES_COL_USER: "adminMessagesColUser",
    ADMIN_MESSAGES_COL_ROLE: "adminMessagesColRole",
    ADMIN_MESSAGES_COL_SUBJECT: "adminMessagesColSubject",
    ADMIN_MESSAGES_COL_LAST_MESSAGE: "adminMessagesColLastMessage",
    ADMIN_MESSAGES_COL_STATUS: "adminMessagesColStatus",
    ADMIN_MESSAGES_ROLE_HOST: "adminMessagesRoleHost",
    ADMIN_MESSAGES_ROLE_GUEST: "adminMessagesRoleGuest",
    ADMIN_MESSAGES_OPEN_BUTTON: "adminMessagesOpenButton",
    ADMIN_MESSAGES_THREAD_TITLE: "adminMessagesThreadTitle",
    ADMIN_MESSAGES_THREAD_EMPTY: "adminMessagesThreadEmpty",
    ADMIN_MESSAGES_CLOSE_BUTTON: "adminMessagesCloseButton",
    ADMIN_MESSAGES_REOPEN_BUTTON: "adminMessagesReopenButton",
    ADMIN_MESSAGES_CLOSED_NOTICE: "adminMessagesClosedNotice",
    ADMIN_MESSAGES_TEAM_LABEL: "adminMessagesTeamLabel",
    ADMIN_MESSAGES_ACTION_ERROR: "adminMessagesActionError",
    ADMIN_MESSAGES_CONTACT_BUTTON: "adminMessagesContactButton",
    ADMIN_MESSAGES_CONTACT_TITLE: "adminMessagesContactTitle",
    ADMIN_MESSAGES_CONTACT_SUBJECT_LABEL: "adminMessagesContactSubjectLabel",
    ADMIN_MESSAGES_CONTACT_MESSAGE_LABEL: "adminMessagesContactMessageLabel",
    ADMIN_MESSAGES_CONTACT_SEND_BUTTON: "adminMessagesContactSendButton",

    ADMIN_REASON_REQUIRED: "adminReasonRequired",
    ADMIN_REASON_PLACEHOLDER: "adminReasonPlaceholder",
    ADMIN_ACTION_SUCCESS: "adminActionSuccess",
    ADMIN_ACTION_ERROR: "adminActionError",
    ADMIN_COMMON_YES: "adminCommonYes",
    ADMIN_COMMON_NO: "adminCommonNo",

    // ---- Espacios (section 4) ----
    ADMIN_SPACES_LOAD_ERROR: "adminSpacesLoadError",
    ADMIN_SPACES_EMPTY_TITLE: "adminSpacesEmptyTitle",
    ADMIN_SPACES_EMPTY_DESCRIPTION: "adminSpacesEmptyDescription",
    ADMIN_SPACES_SEARCH_PLACEHOLDER: "adminSpacesSearchPlaceholder",
    ADMIN_SPACES_STATUS_FILTER_ALL: "adminSpacesStatusFilterAll",
    ADMIN_SPACES_COL_TITLE: "adminSpacesColTitle",
    ADMIN_SPACES_COL_HOST: "adminSpacesColHost",
    ADMIN_SPACES_COL_LOCATION: "adminSpacesColLocation",
    ADMIN_SPACES_COL_STATUS: "adminSpacesColStatus",
    ADMIN_SPACES_COL_BOOKINGS: "adminSpacesColBookings",
    ADMIN_SPACES_COL_CREATED: "adminSpacesColCreated",
    ADMIN_SPACES_COL_ACTIONS: "adminSpacesColActions",
    ADMIN_SPACES_VIEW_BUTTON: "adminSpacesViewButton",
    ADMIN_SPACES_UNPUBLISH_BUTTON: "adminSpacesUnpublishButton",
    ADMIN_SPACES_REACTIVATE_BUTTON: "adminSpacesReactivateButton",
    ADMIN_SPACES_UNPUBLISH_MODAL_TITLE: "adminSpacesUnpublishModalTitle",
    ADMIN_SPACES_REACTIVATE_CONFIRM: "adminSpacesReactivateConfirm",
    ADMIN_SPACES_VERIFIED_BADGE: "adminSpacesVerifiedBadge",
    ADMIN_SPACES_APPROVAL_MODE_LABEL: "adminSpacesApprovalModeLabel",
    ADMIN_SPACES_APPROVAL_MODE_AUTO_DESCRIPTION: "adminSpacesApprovalModeAutoDescription",
    ADMIN_SPACES_IMMEDIATE_BOOKING_LABEL: "adminSpacesImmediateBookingLabel",
    ADMIN_SETTINGS_PROCESSING_FEE_TITLE: "adminSettingsProcessingFeeTitle",
    ADMIN_SETTINGS_PROCESSING_FEE_HELP: "adminSettingsProcessingFeeHelp",
    ADMIN_SETTINGS_PROCESSING_FEE_PERCENT: "adminSettingsProcessingFeePercent",
    ADMIN_SETTINGS_PROCESSING_FEE_FIXED: "adminSettingsProcessingFeeFixed",
    ADMIN_SETTINGS_PROCESSING_FEE_EXAMPLE: "adminSettingsProcessingFeeExample",
    ADMIN_SETTINGS_HOST_DEPOSIT_LABEL: "adminSettingsHostDepositLabel",
    ADMIN_SETTINGS_DEFERRED_CAPTURE_LABEL: "adminSettingsDeferredCaptureLabel",
    ADMIN_SETTINGS_DEFERRED_CAPTURE_ON: "adminSettingsDeferredCaptureOn",
    ADMIN_SETTINGS_DEFERRED_CAPTURE_OFF: "adminSettingsDeferredCaptureOff",
    ADMIN_SETTINGS_DEFERRED_CAPTURE_LEAD: "adminSettingsDeferredCaptureLead",
    ADMIN_SETTINGS_DEFERRED_CAPTURE_LEAD_HELP: "adminSettingsDeferredCaptureLeadHelp",
    HOST_DEFERRED_CAPTURE_LABEL: "hostDeferredCaptureLabel",
    SAVE_CARD_TITLE: "saveCardTitle",
    SAVE_CARD_REASSURANCE: "saveCardReassurance",
    SAVE_CARD_WHEN_CHARGED: "saveCardWhenCharged",
    SAVE_CARD_CONFIRM: "saveCardConfirm",
    SAVE_CARD_NO_CHARGE_NOW: "saveCardNoChargeNow",
    SAVE_CARD_ERROR: "saveCardError",
    HOST_DEFERRED_CAPTURE_HELP: "hostDeferredCaptureHelp",
    ADMIN_SETTINGS_HOST_DEPOSIT_ON: "adminSettingsHostDepositOn",
    ADMIN_SETTINGS_HOST_DEPOSIT_OFF: "adminSettingsHostDepositOff",
    ADMIN_SETTINGS_SAVE: "adminSettingsSave",
    ADMIN_SPACES_IMMEDIATE_BOOKING_ON_DESCRIPTION: "adminSpacesImmediateBookingOnDescription",
    ADMIN_SPACES_IMMEDIATE_BOOKING_OFF_DESCRIPTION: "adminSpacesImmediateBookingOffDescription",
    ADMIN_SPACES_APPROVAL_MODE_MANUAL_DESCRIPTION: "adminSpacesApprovalModeManualDescription",
    ADMIN_SPACES_APPROVE_BUTTON: "adminSpacesApproveButton",
    ADMIN_SPACES_APPROVE_CONFIRM: "adminSpacesApproveConfirm",
    ADMIN_SPACES_REJECT_BUTTON: "adminSpacesRejectButton",
    ADMIN_SPACES_REJECT_MODAL_TITLE: "adminSpacesRejectModalTitle",
    ADMIN_SPACES_PREVIEW_BUTTON: "adminSpacesPreviewButton",
    ADMIN_SPACES_DETAIL_TITLE: "adminSpacesDetailTitle",
    ADMIN_SPACES_DETAIL_HOST_LABEL: "adminSpacesDetailHostLabel",
    ADMIN_SPACES_DETAIL_HOST_EMAIL_LABEL: "adminSpacesDetailHostEmailLabel",
    ADMIN_SPACES_DETAIL_HOST_PHONE_LABEL: "adminSpacesDetailHostPhoneLabel",
    ADMIN_SPACES_DETAIL_ADDRESS_LABEL: "adminSpacesDetailAddressLabel",
    ADMIN_SPACES_DETAIL_RENTAL_MODE_LABEL: "adminSpacesDetailRentalModeLabel",
    ADMIN_SPACES_DETAIL_PRICE_LABEL: "adminSpacesDetailPriceLabel",
    ADMIN_SPACES_DETAIL_SUSPENSION_REASON_LABEL: "adminSpacesDetailSuspensionReasonLabel",
    ADMIN_SPACES_BADGE_TITLE: "adminSpacesBadgeTitle",
    ADMIN_SPACES_BADGE_HINT: "adminSpacesBadgeHint",
    ADMIN_SPACES_BADGE_GRANT_BUTTON: "adminSpacesBadgeGrantButton",
    ADMIN_SPACES_BADGE_REVOKE_BUTTON: "adminSpacesBadgeRevokeButton",
    ADMIN_SPACES_BADGE_GRANT_MODAL_TITLE: "adminSpacesBadgeGrantModalTitle",
    ADMIN_SPACES_BADGE_REVOKE_MODAL_TITLE: "adminSpacesBadgeRevokeModalTitle",

    // ---- Usuarios (section 1) ----
    ADMIN_USERS_LOAD_ERROR: "adminUsersLoadError",
    ADMIN_USERS_EMPTY_TITLE: "adminUsersEmptyTitle",
    ADMIN_USERS_EMPTY_DESCRIPTION: "adminUsersEmptyDescription",
    ADMIN_USERS_SEARCH_PLACEHOLDER: "adminUsersSearchPlaceholder",
    ADMIN_USERS_ROLE_FILTER_ALL: "adminUsersRoleFilterAll",
    ADMIN_USERS_STATUS_FILTER_ALL: "adminUsersStatusFilterAll",
    ADMIN_USERS_STATUS_ACTIVE: "adminUsersStatusActive",
    ADMIN_USERS_STATUS_SUSPENDED: "adminUsersStatusSuspended",
    ADMIN_USERS_COL_NAME: "adminUsersColName",
    ADMIN_USERS_COL_EMAIL: "adminUsersColEmail",
    ADMIN_USERS_COL_ROLE: "adminUsersColRole",
    ADMIN_USERS_COL_STATUS: "adminUsersColStatus",
    ADMIN_USERS_COL_CREATED: "adminUsersColCreated",
    ADMIN_USERS_COL_ACTIONS: "adminUsersColActions",
    ADMIN_USERS_VIEW_BUTTON: "adminUsersViewButton",
    ADMIN_USERS_SUSPEND_BUTTON: "adminUsersSuspendButton",
    ADMIN_USERS_REACTIVATE_BUTTON: "adminUsersReactivateButton",
    ADMIN_USERS_SUSPEND_MODAL_TITLE: "adminUsersSuspendModalTitle",
    ADMIN_USERS_REACTIVATE_CONFIRM: "adminUsersReactivateConfirm",
    ADMIN_USERS_DETAIL_TITLE: "adminUsersDetailTitle",
    ADMIN_USERS_DETAIL_EMAIL_LABEL: "adminUsersDetailEmailLabel",
    ADMIN_USERS_DETAIL_PHONE_LABEL: "adminUsersDetailPhoneLabel",
    ADMIN_USERS_DETAIL_COUNTRY_LABEL: "adminUsersDetailCountryLabel",
    ADMIN_USERS_DETAIL_ROLE_LABEL: "adminUsersDetailRoleLabel",
    ADMIN_USERS_DETAIL_SUSPENDED_REASON_LABEL: "adminUsersDetailSuspendedReasonLabel",
    ADMIN_USERS_DETAIL_SUSPENDED_AT_LABEL: "adminUsersDetailSuspendedAtLabel",
    ADMIN_USERS_DETAIL_BOOKINGS_TITLE: "adminUsersDetailBookingsTitle",
    ADMIN_USERS_DETAIL_BOOKINGS_EMPTY: "adminUsersDetailBookingsEmpty",
    ADMIN_USERS_BOOKING_COL_SPACE: "adminUsersBookingColSpace",
    ADMIN_USERS_BOOKING_COL_DATES: "adminUsersBookingColDates",
    ADMIN_USERS_BOOKING_COL_STATUS: "adminUsersBookingColStatus",
    ADMIN_USERS_BOOKING_COL_PRICE: "adminUsersBookingColPrice",

    // ---- Roles y permisos (section 11) ----
    ADMIN_ROLES_DESCRIPTION: "adminRolesDescription",
    ADMIN_ROLES_LOAD_ERROR: "adminRolesLoadError",
    ADMIN_ROLES_EMPTY_TITLE: "adminRolesEmptyTitle",
    ADMIN_ROLES_EMPTY_DESCRIPTION: "adminRolesEmptyDescription",
    ADMIN_ROLES_SEARCH_PLACEHOLDER: "adminRolesSearchPlaceholder",
    ADMIN_ROLES_COL_NAME: "adminRolesColName",
    ADMIN_ROLES_COL_EMAIL: "adminRolesColEmail",
    ADMIN_ROLES_COL_ROLE: "adminRolesColRole",
    ADMIN_ROLES_COL_CREATED: "adminRolesColCreated",
    ADMIN_ROLES_ROLE_USER: "adminRolesRoleUser",
    ADMIN_ROLES_ROLE_MODERATOR: "adminRolesRoleModerator",
    ADMIN_ROLES_ROLE_ADMIN: "adminRolesRoleAdmin",
    ADMIN_ROLES_CHANGE_CONFIRM_TITLE: "adminRolesChangeConfirmTitle",
    ADMIN_ROLES_CHANGE_CONFIRM_CONTENT: "adminRolesChangeConfirmContent",

    // ---- Verificación de edad (section 12) ----
    ADMIN_AGE_VERIFICATION_LOAD_ERROR: "adminAgeVerificationLoadError",
    ADMIN_AGE_VERIFICATION_EMPTY_TITLE: "adminAgeVerificationEmptyTitle",
    ADMIN_AGE_VERIFICATION_EMPTY_DESCRIPTION: "adminAgeVerificationEmptyDescription",
    ADMIN_AGE_VERIFICATION_SEARCH_PLACEHOLDER: "adminAgeVerificationSearchPlaceholder",
    ADMIN_AGE_VERIFICATION_STATUS_FILTER_ALL: "adminAgeVerificationStatusFilterAll",
    ADMIN_AGE_VERIFICATION_STATUS_VERIFIED: "adminAgeVerificationStatusVerified",
    ADMIN_AGE_VERIFICATION_STATUS_NOT_VERIFIED: "adminAgeVerificationStatusNotVerified",
    ADMIN_AGE_VERIFICATION_COL_NAME: "adminAgeVerificationColName",
    ADMIN_AGE_VERIFICATION_COL_EMAIL: "adminAgeVerificationColEmail",
    ADMIN_AGE_VERIFICATION_COL_STATUS: "adminAgeVerificationColStatus",
    ADMIN_AGE_VERIFICATION_COL_VERIFIED_AT: "adminAgeVerificationColVerifiedAt",
    ADMIN_AGE_VERIFICATION_COL_ACTIONS: "adminAgeVerificationColActions",
    ADMIN_AGE_VERIFICATION_GRANT_BUTTON: "adminAgeVerificationGrantButton",
    ADMIN_AGE_VERIFICATION_REVOKE_BUTTON: "adminAgeVerificationRevokeButton",
    ADMIN_AGE_VERIFICATION_GRANT_MODAL_TITLE: "adminAgeVerificationGrantModalTitle",
    ADMIN_AGE_VERIFICATION_REVOKE_MODAL_TITLE: "adminAgeVerificationRevokeModalTitle",

    ADMIN_SPACE_STATUS_DRAFT: "adminSpaceStatusDraft",
    ADMIN_SPACE_STATUS_PENDING_VERIFICATION: "adminSpaceStatusPendingVerification",
    ADMIN_SPACE_STATUS_ACTIVE: "adminSpaceStatusActive",
    ADMIN_SPACE_STATUS_PENDING_IMPROVEMENT: "adminSpaceStatusPendingImprovement",
    ADMIN_SPACE_STATUS_SUSPENDED: "adminSpaceStatusSuspended",

    // ---- Reservas (section 6) ----
    ADMIN_BOOKINGS_LOAD_ERROR: "adminBookingsLoadError",
    ADMIN_BOOKINGS_EMPTY_TITLE: "adminBookingsEmptyTitle",
    ADMIN_BOOKINGS_EMPTY_DESCRIPTION: "adminBookingsEmptyDescription",
    ADMIN_BOOKINGS_SEARCH_PLACEHOLDER: "adminBookingsSearchPlaceholder",
    ADMIN_BOOKINGS_STATUS_FILTER_ALL: "adminBookingsStatusFilterAll",
    ADMIN_BOOKINGS_COL_SPACE: "adminBookingsColSpace",
    ADMIN_BOOKINGS_COL_HOST: "adminBookingsColHost",
    ADMIN_BOOKINGS_COL_GUEST: "adminBookingsColGuest",
    ADMIN_BOOKINGS_COL_DATES: "adminBookingsColDates",
    ADMIN_BOOKINGS_COL_TOTAL: "adminBookingsColTotal",
    ADMIN_BOOKINGS_COL_STATUS: "adminBookingsColStatus",
    ADMIN_BOOKINGS_COL_PAYMENT: "adminBookingsColPayment",
    ADMIN_BOOKINGS_COL_ACTIONS: "adminBookingsColActions",
    ADMIN_BOOKINGS_VIEW_BUTTON: "adminBookingsViewButton",
    ADMIN_BOOKINGS_FORCE_CANCEL_BUTTON: "adminBookingsForceCancelButton",
    ADMIN_BOOKINGS_FORCE_CANCEL_MODAL_TITLE: "adminBookingsForceCancelModalTitle",
    ADMIN_BOOKINGS_DETAIL_TITLE: "adminBookingsDetailTitle",
    ADMIN_BOOKINGS_DETAIL_PAYMENT_REF_LABEL: "adminBookingsDetailPaymentRefLabel",
    ADMIN_BOOKINGS_DETAIL_PAYOUT_LABEL: "adminBookingsDetailPayoutLabel",
    ADMIN_BOOKINGS_DETAIL_AUDIT_BOOKING_LABEL: "adminBookingsDetailAuditBookingLabel",

    // ---- Reseñas (section 7) ----
    ADMIN_REVIEWS_LOAD_ERROR: "adminReviewsLoadError",
    ADMIN_REVIEWS_EMPTY_TITLE: "adminReviewsEmptyTitle",
    ADMIN_REVIEWS_EMPTY_DESCRIPTION: "adminReviewsEmptyDescription",
    ADMIN_REVIEWS_SEARCH_PLACEHOLDER: "adminReviewsSearchPlaceholder",
    ADMIN_REVIEWS_FILTER_ALL: "adminReviewsFilterAll",
    ADMIN_REVIEWS_FILTER_HIDDEN: "adminReviewsFilterHidden",
    ADMIN_REVIEWS_FILTER_VISIBLE: "adminReviewsFilterVisible",
    ADMIN_REVIEWS_COL_SPACE: "adminReviewsColSpace",
    ADMIN_REVIEWS_COL_GUEST: "adminReviewsColGuest",
    ADMIN_REVIEWS_COL_RATING: "adminReviewsColRating",
    ADMIN_REVIEWS_COL_COMMENT: "adminReviewsColComment",
    ADMIN_REVIEWS_COL_STATUS: "adminReviewsColStatus",
    ADMIN_REVIEWS_COL_ACTIONS: "adminReviewsColActions",
    ADMIN_REVIEWS_STATUS_HIDDEN: "adminReviewsStatusHidden",
    ADMIN_REVIEWS_STATUS_VISIBLE: "adminReviewsStatusVisible",
    ADMIN_REVIEWS_HIDE_BUTTON: "adminReviewsHideButton",
    ADMIN_REVIEWS_UNHIDE_BUTTON: "adminReviewsUnhideButton",
    ADMIN_REVIEWS_DELETE_BUTTON: "adminReviewsDeleteButton",
    ADMIN_REVIEWS_HIDE_MODAL_TITLE: "adminReviewsHideModalTitle",
    ADMIN_REVIEWS_DELETE_MODAL_TITLE: "adminReviewsDeleteModalTitle",
    ADMIN_REVIEWS_UNHIDE_CONFIRM: "adminReviewsUnhideConfirm",
    ADMIN_REVIEWS_HIDDEN_REASON_LABEL: "adminReviewsHiddenReasonLabel",

    // ---- Auditorías de calidad (section 5) ----

    // ---- Bloqueo geográfico (section 10) ----
    ADMIN_GEO_BLOCKING_LOAD_ERROR: "adminGeoBlockingLoadError",
    ADMIN_GEO_BLOCKING_EMPTY_TITLE: "adminGeoBlockingEmptyTitle",
    ADMIN_GEO_BLOCKING_EMPTY_DESCRIPTION: "adminGeoBlockingEmptyDescription",
    ADMIN_GEO_BLOCKING_SELECT_PLACEHOLDER: "adminGeoBlockingSelectPlaceholder",
    ADMIN_GEO_BLOCKING_ADD_BUTTON: "adminGeoBlockingAddButton",
    ADMIN_GEO_BLOCKING_COL_COUNTRY: "adminGeoBlockingColCountry",
    ADMIN_GEO_BLOCKING_COL_BLOCKED_SINCE: "adminGeoBlockingColBlockedSince",
    ADMIN_GEO_BLOCKING_COL_ACTIONS: "adminGeoBlockingColActions",
    ADMIN_GEO_BLOCKING_REMOVE_BUTTON: "adminGeoBlockingRemoveButton",
    ADMIN_GEO_BLOCKING_REMOVE_CONFIRM: "adminGeoBlockingRemoveConfirm",
    ADMIN_GEO_BLOCKING_ALREADY_BLOCKED: "adminGeoBlockingAlreadyBlocked",
    ADMIN_GEO_BLOCKING_DESCRIPTION: "adminGeoBlockingDescription",
    ADMIN_GEO_BLOCKING_SEARCH_PLACEHOLDER: "adminGeoBlockingSearchPlaceholder",
    ADMIN_GEO_BLOCKING_TOGGLE_ALL_LABEL: "adminGeoBlockingToggleAllLabel",
    ADMIN_GEO_BLOCKING_TOGGLE_ALL_HELP: "adminGeoBlockingToggleAllHelp",
    ADMIN_GEO_BLOCKING_NO_MATCHES: "adminGeoBlockingNoMatches",
    ADMIN_GEO_BLOCKING_REFRESH_ALL_BUTTON: "adminGeoBlockingRefreshAllButton",
    ADMIN_GEO_BLOCKING_LAST_SYNCED_LABEL: "adminGeoBlockingLastSyncedLabel",
    ADMIN_GEO_BLOCKING_NEVER_SYNCED: "adminGeoBlockingNeverSynced",

    // ---- Dashboard (section 1) ----
    ADMIN_DASHBOARD_LOAD_ERROR: "adminDashboardLoadError",
    ADMIN_DASHBOARD_ACTIVE_USERS: "adminDashboardActiveUsers",
    ADMIN_DASHBOARD_HOSTS: "adminDashboardHosts",
    ADMIN_DASHBOARD_PUBLISHED_SPACES: "adminDashboardPublishedSpaces",
    ADMIN_DASHBOARD_BOOKINGS_THIS_MONTH: "adminDashboardBookingsThisMonth",
    ADMIN_DASHBOARD_UNRESOLVED_REPORTS: "adminDashboardUnresolvedReports",

    // ---- Anfitriones (section 3) ----
    ADMIN_HOSTS_LOAD_ERROR: "adminHostsLoadError",
    ADMIN_HOSTS_EMPTY_TITLE: "adminHostsEmptyTitle",
    ADMIN_HOSTS_EMPTY_DESCRIPTION: "adminHostsEmptyDescription",
    ADMIN_HOSTS_ACCOUNT_TYPE_FILTER_ALL: "adminHostsAccountTypeFilterAll",
    ADMIN_HOSTS_VERIFICATION_FILTER_ALL: "adminHostsVerificationFilterAll",
    ADMIN_HOSTS_COL_NAME: "adminHostsColName",
    ADMIN_HOSTS_COL_ACCOUNT_TYPE: "adminHostsColAccountType",
    ADMIN_HOSTS_COL_LEGAL_NAME: "adminHostsColLegalName",
    ADMIN_HOSTS_COL_VERIFICATION: "adminHostsColVerification",
    ADMIN_HOSTS_COL_PROFILE_STATUS: "adminHostsColProfileStatus",
    ADMIN_HOSTS_COL_BADGE: "adminHostsColBadge",
    ADMIN_HOSTS_COL_ACTIONS: "adminHostsColActions",
    ADMIN_HOSTS_VIEW_BUTTON: "adminHostsViewButton",
    ADMIN_HOSTS_DETAIL_TITLE: "adminHostsDetailTitle",
    ADMIN_HOSTS_ACCOUNT_TYPE_INDIVIDUAL: "adminHostsAccountTypeIndividual",
    ADMIN_HOSTS_ACCOUNT_TYPE_BUSINESS: "adminHostsAccountTypeBusiness",
    ADMIN_HOSTS_PROFILE_STATUS_PENDING: "adminHostsProfileStatusPending",
    ADMIN_HOSTS_PROFILE_STATUS_VERIFIED: "adminHostsProfileStatusVerified",
    ADMIN_HOSTS_PROFILE_STATUS_REJECTED: "adminHostsProfileStatusRejected",
    ADMIN_HOSTS_EDIT_LEGAL_TITLE: "adminHostsEditLegalTitle",
    ADMIN_HOSTS_SAVE_LEGAL_BUTTON: "adminHostsSaveLegalButton",
    ADMIN_HOSTS_LEGAL_NAME_LABEL: "adminHostsLegalNameLabel",
    ADMIN_HOSTS_TAX_ID_LABEL: "adminHostsTaxIdLabel",
    ADMIN_HOSTS_BUSINESS_REG_NUMBER_LABEL: "adminHostsBusinessRegNumberLabel",
    ADMIN_HOSTS_CONTACT_PHONE_LABEL: "adminHostsContactPhoneLabel",
    ADMIN_HOSTS_BILLING_ADDRESS_LABEL: "adminHostsBillingAddressLabel",
    ADMIN_HOSTS_INSURANCE_POLICY_LABEL: "adminHostsInsurancePolicyLabel",
    ADMIN_HOSTS_FORCE_VERIFICATION_TITLE: "adminHostsForceVerificationTitle",
    ADMIN_HOSTS_FORCE_VERIFICATION_BUTTON: "adminHostsForceVerificationButton",
    ADMIN_HOSTS_VERIFICATION_STATUS_LABEL: "adminHostsVerificationStatusLabel",
    ADMIN_HOSTS_VERIFICATION_REASON_LABEL: "adminHostsVerificationReasonLabel",

    // ---- Reportes (section 8) ----
    ADMIN_REPORTS_LOAD_ERROR: "adminReportsLoadError",
    ADMIN_REPORTS_EMPTY_TITLE: "adminReportsEmptyTitle",
    ADMIN_REPORTS_EMPTY_DESCRIPTION: "adminReportsEmptyDescription",
    ADMIN_REPORTS_STATUS_FILTER_ALL: "adminReportsStatusFilterAll",
    ADMIN_REPORTS_TARGET_TYPE_FILTER_ALL: "adminReportsTargetTypeFilterAll",
    ADMIN_REPORTS_COL_TARGET: "adminReportsColTarget",
    ADMIN_REPORTS_COL_REPORTER: "adminReportsColReporter",
    ADMIN_REPORTS_COL_REASON: "adminReportsColReason",
    ADMIN_REPORTS_COL_STATUS: "adminReportsColStatus",
    ADMIN_REPORTS_COL_APPEALED: "adminReportsColAppealed",
    ADMIN_REPORTS_COL_CREATED: "adminReportsColCreated",
    ADMIN_REPORTS_COL_ACTIONS: "adminReportsColActions",
    ADMIN_REPORTS_STATUS_PENDING: "adminReportsStatusPending",
    ADMIN_REPORTS_STATUS_RESOLVED: "adminReportsStatusResolved",
    ADMIN_REPORTS_STATUS_DISMISSED: "adminReportsStatusDismissed",
    ADMIN_REPORTS_TARGET_TYPE_SPACE: "adminReportsTargetTypeSpace",
    ADMIN_REPORTS_TARGET_TYPE_USER: "adminReportsTargetTypeUser",
    ADMIN_REPORTS_TARGET_TYPE_MESSAGE: "adminReportsTargetTypeMessage",
    ADMIN_REPORTS_TARGET_TYPE_PHOTO: "adminReportsTargetTypePhoto",
    ADMIN_REPORTS_VIEW_PHOTO_LINK: "adminReportsViewPhotoLink",
    ADMIN_REPORTS_VIEW_BUTTON: "adminReportsViewButton",
    ADMIN_REPORTS_DETAIL_TITLE: "adminReportsDetailTitle",
    ADMIN_REPORTS_ACTION_TAKEN_LABEL: "adminReportsActionTakenLabel",
    ADMIN_REPORTS_RESOLVE_TITLE: "adminReportsResolveTitle",
    ADMIN_REPORTS_RESOLVE_BUTTON: "adminReportsResolveButton",
    ADMIN_REPORTS_DISMISS_TITLE: "adminReportsDismissTitle",
    ADMIN_REPORTS_DISMISS_BUTTON: "adminReportsDismissButton",
    ADMIN_REPORTS_APPEAL_TITLE: "adminReportsAppealTitle",
    ADMIN_REPORTS_APPEAL_NOTES_LABEL: "adminReportsAppealNotesLabel",
    ADMIN_REPORTS_APPEAL_BUTTON: "adminReportsAppealButton",
    ADMIN_REPORTS_APPEAL_RECORDED: "adminReportsAppealRecorded",

    // ---- Moderación de fotos (section 9) ----
    ADMIN_PHOTOS_SEARCH_PLACEHOLDER: "adminPhotosSearchPlaceholder",
    ADMIN_PHOTOS_VIEW_PHOTOS_BUTTON: "adminPhotosViewPhotosButton",
    ADMIN_PHOTOS_QUEUE_TITLE: "adminPhotosQueueTitle",
    ADMIN_PHOTOS_QUEUE_LOAD_ERROR: "adminPhotosQueueLoadError",
    ADMIN_PHOTOS_QUEUE_EMPTY_TITLE: "adminPhotosQueueEmptyTitle",
    ADMIN_PHOTOS_QUEUE_EMPTY_DESCRIPTION: "adminPhotosQueueEmptyDescription",
    ADMIN_PHOTOS_SPACE_PHOTOS_TITLE: "adminPhotosSpacePhotosTitle",
    ADMIN_PHOTOS_FLAG_BUTTON: "adminPhotosFlagButton",
    ADMIN_PHOTOS_APPROVE_BUTTON: "adminPhotosApproveButton",
    ADMIN_PHOTOS_REJECT_BUTTON: "adminPhotosRejectButton",
    ADMIN_PHOTOS_REJECT_MODAL_TITLE: "adminPhotosRejectModalTitle",
    ADMIN_PHOTOS_STATUS_PENDING: "adminPhotosStatusPending",
    ADMIN_PHOTOS_STATUS_APPROVED: "adminPhotosStatusApproved",

    // ---- Comunicados (section 15) ----
    ADMIN_ANNOUNCEMENTS_TITLE_LABEL: "adminAnnouncementsTitleLabel",
    ADMIN_ANNOUNCEMENTS_BODY_LABEL: "adminAnnouncementsBodyLabel",
    ADMIN_ANNOUNCEMENTS_SEGMENT_LABEL: "adminAnnouncementsSegmentLabel",
    ADMIN_ANNOUNCEMENTS_SEGMENT_ALL: "adminAnnouncementsSegmentAll",
    ADMIN_ANNOUNCEMENTS_SEGMENT_HOSTS: "adminAnnouncementsSegmentHosts",
    ADMIN_ANNOUNCEMENTS_SEND_BUTTON: "adminAnnouncementsSendButton",
    ADMIN_ANNOUNCEMENTS_SEND_CONFIRM: "adminAnnouncementsSendConfirm",
    ADMIN_ANNOUNCEMENTS_HISTORY_TITLE: "adminAnnouncementsHistoryTitle",
    ADMIN_ANNOUNCEMENTS_HISTORY_LOAD_ERROR: "adminAnnouncementsHistoryLoadError",
    ADMIN_ANNOUNCEMENTS_HISTORY_EMPTY_TITLE: "adminAnnouncementsHistoryEmptyTitle",
    ADMIN_ANNOUNCEMENTS_HISTORY_EMPTY_DESCRIPTION: "adminAnnouncementsHistoryEmptyDescription",
    ADMIN_ANNOUNCEMENTS_COL_TITLE: "adminAnnouncementsColTitle",
    ADMIN_ANNOUNCEMENTS_COL_SEGMENT: "adminAnnouncementsColSegment",
    ADMIN_ANNOUNCEMENTS_COL_RECIPIENTS: "adminAnnouncementsColRecipients",
    ADMIN_ANNOUNCEMENTS_COL_SENT_BY: "adminAnnouncementsColSentBy",
    ADMIN_ANNOUNCEMENTS_COL_DATE: "adminAnnouncementsColDate",

    // ---- Solicitudes RGPD (section 14) ----
    ADMIN_GDPR_LOAD_ERROR: "adminGdprLoadError",
    ADMIN_GDPR_EMPTY_TITLE: "adminGdprEmptyTitle",
    ADMIN_GDPR_EMPTY_DESCRIPTION: "adminGdprEmptyDescription",
    ADMIN_GDPR_DELETE_REQUESTS_NOTE: "adminGdprDeleteRequestsNote",
    ADMIN_GDPR_COL_USER: "adminGdprColUser",
    ADMIN_GDPR_COL_TYPE: "adminGdprColType",
    ADMIN_GDPR_COL_STATUS: "adminGdprColStatus",
    ADMIN_GDPR_COL_REQUESTED_AT: "adminGdprColRequestedAt",
    ADMIN_GDPR_COL_PROCESSED_AT: "adminGdprColProcessedAt",
    ADMIN_GDPR_TYPE_EXPORT: "adminGdprTypeExport",
    ADMIN_GDPR_STATUS_COMPLETED: "adminGdprStatusCompleted",

    // ---- Finanzas (section 16) ----
    ADMIN_FINANCE_LOAD_ERROR: "adminFinanceLoadError",
    ADMIN_FINANCE_SUMMARY_REVENUE: "adminFinanceSummaryRevenue",
    ADMIN_FINANCE_SUMMARY_PLATFORM_FEES: "adminFinanceSummaryPlatformFees",
    ADMIN_FINANCE_SUMMARY_HOST_PAYOUTS: "adminFinanceSummaryHostPayouts",
    ADMIN_FINANCE_SUMMARY_REFUNDED: "adminFinanceSummaryRefunded",
    ADMIN_FINANCE_SUMMARY_TRANSACTION_COUNT: "adminFinanceSummaryTransactionCount",
    ADMIN_FINANCE_TRANSACTIONS_TITLE: "adminFinanceTransactionsTitle",
    ADMIN_FINANCE_STATUS_FILTER_ALL: "adminFinanceStatusFilterAll",
    ADMIN_FINANCE_STATUS_SUCCEEDED: "adminFinanceStatusSucceeded",
    ADMIN_FINANCE_STATUS_REFUNDED: "adminFinanceStatusRefunded",
    ADMIN_FINANCE_STATUS_PARTIALLY_REFUNDED: "adminFinanceStatusPartiallyRefunded",
    ADMIN_FINANCE_EMPTY_TITLE: "adminFinanceEmptyTitle",
    ADMIN_FINANCE_EMPTY_DESCRIPTION: "adminFinanceEmptyDescription",
    ADMIN_FINANCE_COL_SPACE: "adminFinanceColSpace",
    ADMIN_FINANCE_COL_HOST: "adminFinanceColHost",
    ADMIN_FINANCE_COL_GUEST: "adminFinanceColGuest",
    ADMIN_FINANCE_COL_TOTAL: "adminFinanceColTotal",
    ADMIN_FINANCE_COL_PLATFORM_FEE: "adminFinanceColPlatformFee",
    ADMIN_FINANCE_COL_PAYOUT: "adminFinanceColPayout",
    ADMIN_FINANCE_COL_STATUS: "adminFinanceColStatus",
    ADMIN_FINANCE_COL_PAYMENT_REF: "adminFinanceColPaymentRef",
    ADMIN_FINANCE_COL_DATE: "adminFinanceColDate",
    ADMIN_FINANCE_TAB_SUMMARY: "adminFinanceTabSummary",
    ADMIN_FINANCE_TAB_INVOICES: "adminFinanceTabInvoices",
    ADMIN_FINANCE_TAB_OVERTIME: "adminFinanceTabOvertime",
    ADMIN_FINANCE_OVERTIME_EMPTY_TITLE: "adminFinanceOvertimeEmptyTitle",
    ADMIN_FINANCE_OVERTIME_EMPTY_DESCRIPTION: "adminFinanceOvertimeEmptyDescription",
    ADMIN_FINANCE_OVERTIME_COL_AMOUNT: "adminFinanceOvertimeColAmount",
    ADMIN_FINANCE_OVERTIME_STATUS_PENDING: "adminFinanceOvertimeStatusPending",
    ADMIN_FINANCE_OVERTIME_STATUS_FAILED: "adminFinanceOvertimeStatusFailed",
    ADMIN_FINANCE_OVERTIME_VIEW_BOOKING: "adminFinanceOvertimeViewBooking",
    ADMIN_INVOICES_SEARCH_PLACEHOLDER: "adminInvoicesSearchPlaceholder",
    ADMIN_INVOICES_TYPE_FILTER_ALL: "adminInvoicesTypeFilterAll",
    ADMIN_INVOICES_LOAD_ERROR: "adminInvoicesLoadError",
    ADMIN_INVOICES_EMPTY_TITLE: "adminInvoicesEmptyTitle",
    ADMIN_INVOICES_EMPTY_DESCRIPTION: "adminInvoicesEmptyDescription",
    ADMIN_INVOICES_COL_NUMBER: "adminInvoicesColNumber",
    ADMIN_INVOICES_COL_TYPE: "adminInvoicesColType",
    ADMIN_INVOICES_COL_ISSUER: "adminInvoicesColIssuer",
    ADMIN_INVOICES_COL_RECIPIENT: "adminInvoicesColRecipient",
    ADMIN_INVOICES_COL_AMOUNT: "adminInvoicesColAmount",
    ADMIN_INVOICES_COL_ISSUED_AT: "adminInvoicesColIssuedAt",
    ADMIN_INVOICES_COL_KIND: "adminInvoicesColKind",
    ADMIN_INVOICES_LOAD_MORE: "adminInvoicesLoadMore",

    // ===== Publish space wizard =====
    WIZARD_PHASE_STORY_TITLE: "wizardPhaseStoryTitle",
    WIZARD_PHASE_STORY_SUBTITLE: "wizardPhaseStorySubtitle",
    WIZARD_PHASE_LOCATION_SPECS_TITLE: "wizardPhaseLocationSpecsTitle",
    WIZARD_PHASE_LOCATION_SPECS_SUBTITLE: "wizardPhaseLocationSpecsSubtitle",
    WIZARD_PHASE_OPERATOR_TITLE: "wizardPhaseOperatorTitle",
    WIZARD_PHASE_OPERATOR_SUBTITLE: "wizardPhaseOperatorSubtitle",
    WIZARD_PHASE_DELIVERY_TITLE: "wizardPhaseDeliveryTitle",
    WIZARD_PHASE_DELIVERY_SUBTITLE: "wizardPhaseDeliverySubtitle",
    WIZARD_PHASE_EXTRAS_TITLE: "wizardPhaseExtrasTitle",
    WIZARD_PHASE_EXTRAS_SUBTITLE: "wizardPhaseExtrasSubtitle",
    WIZARD_PHASE_ACCESS_RULES_TITLE: "wizardPhaseAccessRulesTitle",
    WIZARD_PHASE_ACCESS_RULES_SUBTITLE: "wizardPhaseAccessRulesSubtitle",
    WIZARD_PHASE_RULES_PHOTOS_TITLE: "wizardPhaseRulesPhotosTitle",
    WIZARD_PHASE_RULES_PHOTOS_SUBTITLE: "wizardPhaseRulesPhotosSubtitle",
    WIZARD_STEP_LABEL: "wizardStepLabel",
    WIZARD_CONTINUE_BUTTON: "wizardContinueButton",
    WIZARD_CELEBRATION_TITLE: "wizardCelebrationTitle",
    WIZARD_CELEBRATION_MESSAGE: "wizardCelebrationMessage",
    WIZARD_CELEBRATION_VIEW_SPACE_BUTTON: "wizardCelebrationViewSpaceButton",
    WIZARD_CELEBRATION_PUBLISH_ANOTHER_BUTTON: "wizardCelebrationPublishAnotherButton",
    WIZARD_REINFORCE_ACCESS_SELF_CHECKIN: "wizardReinforceAccessSelfCheckin",
    WIZARD_REINFORCE_ACCESS_HOST_GREETS: "wizardReinforceAccessHostGreets",
    WIZARD_REINFORCE_ACCESS_HOST_PRESENT_THROUGHOUT: "wizardReinforceAccessHostPresentThroughout",
    WIZARD_REINFORCE_ACCESS_ONSITE_STAFF: "wizardReinforceAccessOnsiteStaff",
    WIZARD_REINFORCE_RENTAL_HOURLY: "wizardReinforceRentalHourly",
    WIZARD_REINFORCE_RENTAL_OVERNIGHT: "wizardReinforceRentalOvernight",
    WIZARD_REINFORCE_RENTAL_BOTH: "wizardReinforceRentalBoth",
    WIZARD_REINFORCE_RENTAL_DAY_PASS: "wizardReinforceRentalDayPass",

    // Fase 6: digital check-in/check-out flow (CheckInOutFlow.tsx). Prefixed
    // CHECK_IN_OUT_, deliberately distinct from the existing
    // HEAVY_DUTY_MACHINERY_BOOKING_CHECKIN_LABEL/CHECKOUT_LABEL pair, which
    // are unrelated (Overnight-stay date labels, not this report flow).
    CHECK_IN_OUT_CHECK_IN_BUTTON: "checkInOutCheckInButton",
    CHECK_IN_OUT_CHECK_OUT_BUTTON: "checkInOutCheckOutButton",
    CHECK_IN_OUT_TITLE_CHECK_IN: "checkInOutTitleCheckIn",
    CHECK_IN_OUT_TITLE_CHECK_OUT: "checkInOutTitleCheckOut",
    CHECK_IN_OUT_INTRO_CHECK_IN: "checkInOutIntroCheckIn",
    CHECK_IN_OUT_INTRO_CHECK_OUT: "checkInOutIntroCheckOut",
    CHECK_IN_OUT_START_BUTTON: "checkInOutStartButton",
    CHECK_IN_OUT_BACK_BUTTON: "checkInOutBackButton",
    CHECK_IN_OUT_PHOTOS_STEP_TITLE: "checkInOutPhotosStepTitle",
    CHECK_IN_OUT_PHOTOS_STEP_SUBTITLE: "checkInOutPhotosStepSubtitle",
    CHECK_IN_OUT_SLOT_FRONT: "checkInOutSlotFront",
    CHECK_IN_OUT_SLOT_BACK: "checkInOutSlotBack",
    CHECK_IN_OUT_SLOT_LEFT_SIDE: "checkInOutSlotLeftSide",
    CHECK_IN_OUT_SLOT_RIGHT_SIDE: "checkInOutSlotRightSide",
    CHECK_IN_OUT_SLOT_CABIN_INTERIOR: "checkInOutSlotCabinInterior",
    CHECK_IN_OUT_SLOT_HOUR_METER: "checkInOutSlotHourMeter",
    CHECK_IN_OUT_RETAKE_LABEL: "checkInOutRetakeLabel",
    CHECK_IN_OUT_PHOTO_PREPARING: "checkInOutPhotoPreparing",
    CHECK_IN_OUT_PHOTOS_MISSING_HINT: "checkInOutPhotosMissingHint",
    CHECK_IN_OUT_CONTINUE_BUTTON: "checkInOutContinueButton",
    CHECK_IN_OUT_DATA_STEP_TITLE: "checkInOutDataStepTitle",
    CHECK_IN_OUT_ENGINE_HOURS_LABEL: "checkInOutEngineHoursLabel",
    CHECK_IN_OUT_FUEL_PERCENT_LABEL: "checkInOutFuelPercentLabel",
    CHECK_IN_OUT_DAMAGE_TOGGLE_LABEL: "checkInOutDamageToggleLabel",
    CHECK_IN_OUT_DAMAGE_NOTES_LABEL: "checkInOutDamageNotesLabel",
    CHECK_IN_OUT_DAMAGE_NOTES_PLACEHOLDER: "checkInOutDamageNotesPlaceholder",
    CHECK_IN_OUT_DAMAGE_CLAIM_AMOUNT_LABEL: "checkInOutDamageClaimAmountLabel",
    CHECK_IN_OUT_REVIEW_STEP_TITLE: "checkInOutReviewStepTitle",
    CHECK_IN_OUT_REVIEW_PHOTOS_COUNT: "checkInOutReviewPhotosCount",
    CHECK_IN_OUT_REVIEW_NO_DAMAGE: "checkInOutReviewNoDamage",
    CHECK_IN_OUT_REVIEW_DAMAGE_CLAIM: "checkInOutReviewDamageClaim",
    CHECK_IN_OUT_IMMUTABLE_WARNING: "checkInOutImmutableWarning",
    CHECK_IN_OUT_SUBMIT_BUTTON: "checkInOutSubmitButton",
    CHECK_IN_OUT_CONFIRM_SHEET_TITLE: "checkInOutConfirmSheetTitle",
    CHECK_IN_OUT_CONFIRM_SHEET_DESCRIPTION: "checkInOutConfirmSheetDescription",
    CHECK_IN_OUT_CONFIRM_SHEET_CONFIRM: "checkInOutConfirmSheetConfirm",
    CHECK_IN_OUT_CONFIRM_SHEET_CANCEL: "checkInOutConfirmSheetCancel",
    CHECK_IN_OUT_UPLOADING: "checkInOutUploading",
    CHECK_IN_OUT_SUBMIT_SUCCESS: "checkInOutSubmitSuccess",
    CHECK_IN_OUT_SUBMIT_ERROR: "checkInOutSubmitError",
    CHECK_IN_OUT_CAPTURE_BUTTON: "checkInOutCaptureButton",
    CHECK_IN_OUT_CAPTURE_NOTICE: "checkInOutCaptureNotice",
    CHECK_IN_OUT_CAPTURE_ERROR: "checkInOutCaptureError",
    CHECK_IN_OUT_CAPTURE_DONE: "checkInOutCaptureDone",
    CHECK_IN_OUT_RETRY_BUTTON: "checkInOutRetryButton",
    CHECK_IN_OUT_ALREADY_SUBMITTED_TITLE: "checkInOutAlreadySubmittedTitle",
    CHECK_IN_OUT_ALREADY_SUBMITTED_AT: "checkInOutAlreadySubmittedAt",
    CHECK_IN_OUT_NOT_AUTHORIZED: "checkInOutNotAuthorized",
    CHECK_IN_OUT_LOCATION_CAPTURING: "checkInOutLocationCapturing",
    CHECK_IN_OUT_LOCATION_CAPTURED: "checkInOutLocationCaptured",
    CHECK_IN_OUT_LOCATION_ERROR: "checkInOutLocationError",
    CHECK_IN_OUT_LOCATION_RETRY_BUTTON: "checkInOutLocationRetryButton",
    CHECK_IN_OUT_LOAD_ERROR: "checkInOutLoadError",
    CHECK_IN_OUT_DONE_BUTTON: "checkInOutDoneButton",

    // ===== TaxonomyPicker (Sector -> MachineryFamily -> MachineryType drill-down, see ITaxonomy.ts) =====
    TAXONOMY_PICKER_DEFAULT_TITLE: "taxonomyPickerDefaultTitle",
    TAXONOMY_PICKER_SEARCH_PLACEHOLDER: "taxonomyPickerSearchPlaceholder",
    TAXONOMY_PICKER_NO_RESULTS: "taxonomyPickerNoResults",
    TAXONOMY_PICKER_CLEAR: "taxonomyPickerClear",
    TAXONOMY_PICKER_SELECTED_COUNT: "taxonomyPickerSelectedCount",
    TAXONOMY_PICKER_MORE_SUFFIX: "taxonomyPickerMoreSuffix",

    // ===== The same assistant for attachments (AccessoryAssistController).
    // The buttons and the failures are shared with machinery -- only the
    // copy that names what is being published differs =====
    ACCESSORY_AI_TITLE: "accessoryAiTitle",
    ACCESSORY_AI_SUBTITLE: "accessoryAiSubtitle",
    ACCESSORY_AI_DONE_SUBTITLE: "accessoryAiDoneSubtitle",
    ACCESSORY_AI_PLACEHOLDER: "accessoryAiPlaceholder",
    ACCESSORY_AI_DESCRIPTION_TOO_SHORT: "accessoryAiDescriptionTooShort",

    // ===== Publishing faster: what the previous listing already answers,
    // and several identical machines in one go (machineryPublishHelper) =====
    MACHINERY_INHERITED_BANNER: "machineryInheritedBanner",
    MACHINERY_INHERITED_BANNER_NOT: "machineryInheritedBannerNot",
    MACHINERY_INHERITED_UNDO: "machineryInheritedUndo",
    MACHINERY_UNITS_LABEL: "machineryUnitsLabel",
    MACHINERY_UNITS_HELP_ONE: "machineryUnitsHelpOne",
    MACHINERY_UNITS_HELP_MANY: "machineryUnitsHelpMany",
    MACHINERY_UNITS_DEFAULT_REFERENCE: "machineryUnitsDefaultReference",
    MACHINERY_UNITS_PUBLISHED: "machineryUnitsPublished",
    MACHINERY_UNITS_PARTIAL: "machineryUnitsPartial",

    // ===== Publishing assistant (MachineryAssistController -- optional, the
    // wizard works identically without any of it) =====
    MACHINERY_AI_TITLE: "machineryAiTitle",
    MACHINERY_AI_SUBTITLE: "machineryAiSubtitle",
    MACHINERY_AI_DONE_SUBTITLE: "machineryAiDoneSubtitle",
    MACHINERY_AI_PLACEHOLDER: "machineryAiPlaceholder",
    MACHINERY_AI_FILL_BUTTON: "machineryAiFillButton",
    MACHINERY_AI_RETRY_BUTTON: "machineryAiRetryButton",
    MACHINERY_AI_CONTINUE_BUTTON: "machineryAiContinueButton",
    MACHINERY_AI_DESCRIPTION_TOO_SHORT: "machineryAiDescriptionTooShort",
    MACHINERY_AI_NO_CATEGORY: "machineryAiNoCategory",
    MACHINERY_AI_LIMIT_REACHED: "machineryAiLimitReached",
    MACHINERY_AI_FAILED: "machineryAiFailed",
    MACHINERY_AI_NOTHING_FILLED: "machineryAiNothingFilled",
    MACHINERY_AI_PLATE_BUTTON: "machineryAiPlateButton",
    MACHINERY_AI_PLATE_NOT_FOUND: "machineryAiPlateNotFound",
    MACHINERY_AI_PLATE_SERIAL_ONLY: "machineryAiPlateSerialOnly",
    MACHINERY_AI_FILLED_TAG: "machineryAiFilledTag",
    MACHINERY_AI_FILLED_HINT: "machineryAiFilledHint",
    MACHINERY_AI_FILLED_CHECK_HINT: "machineryAiFilledCheckHint",
    MACHINERY_AI_BANNER: "machineryAiBanner",
    MACHINERY_AI_BANNER_YOURS: "machineryAiBannerYours",
    MACHINERY_AI_GO_TO_MISSING: "machineryAiGoToMissing",

    // ===== Machinery technical specs (global fields + per-type CustomAttributesJson, see machineryCustomSpecFieldsByType.ts) =====
    MACHINERY_SPEC_SECTION_TITLE: "machinerySpecSectionTitle",
    MACHINERY_ADVANCED_SPECS_SHOW: "machineryAdvancedSpecsShow",
    MACHINERY_ADVANCED_SPECS_HIDE: "machineryAdvancedSpecsHide",
    MACHINERY_SPEC_CUSTOM_SECTION_TITLE: "machinerySpecCustomSectionTitle",
    MACHINERY_SPEC_DETAIL_SECTION_TITLE: "machinerySpecDetailSectionTitle",
    MACHINERY_SPEC_PROPULSION_TYPE_LABEL: "machinerySpecPropulsionTypeLabel",
    MACHINERY_SPEC_PROPULSION_STEEL_TRACKS: "machinerySpecPropulsionSteelTracks",
    MACHINERY_SPEC_PROPULSION_RUBBER_TRACKS: "machinerySpecPropulsionRubberTracks",
    MACHINERY_SPEC_PROPULSION_WHEELS: "machinerySpecPropulsionWheels",
    MACHINERY_SPEC_PROPULSION_STATIONARY: "machinerySpecPropulsionStationary",
    MACHINERY_SPEC_FUEL_TYPE_LABEL: "machinerySpecFuelTypeLabel",
    MACHINERY_SPEC_FUEL_DIESEL: "machinerySpecFuelDiesel",
    MACHINERY_SPEC_FUEL_ELECTRIC: "machinerySpecFuelElectric",
    MACHINERY_SPEC_FUEL_HYBRID: "machinerySpecFuelHybrid",
    MACHINERY_SPEC_FUEL_GASOLINE: "machinerySpecFuelGasoline",
    MACHINERY_SPEC_TRANSPORT_LENGTH_LABEL: "machinerySpecTransportLengthLabel",
    MACHINERY_SPEC_TRANSPORT_WIDTH_LABEL: "machinerySpecTransportWidthLabel",
    MACHINERY_SPEC_TRANSPORT_HEIGHT_LABEL: "machinerySpecTransportHeightLabel",
    MACHINERY_SPEC_HAS_QUICK_HITCH_LABEL: "machinerySpecHasQuickHitchLabel",
    MACHINERY_SPEC_MAX_EXCAVATION_DEPTH_LABEL: "machinerySpecMaxExcavationDepthLabel",
    MACHINERY_SPEC_MAX_HORIZONTAL_REACH_LABEL: "machinerySpecMaxHorizontalReachLabel",
    MACHINERY_SPEC_BUCKET_CAPACITY_LABEL: "machinerySpecBucketCapacityLabel",
    MACHINERY_SPEC_HAS_AUX_HYDRAULIC_LINE_LABEL: "machinerySpecHasAuxHydraulicLineLabel",
    MACHINERY_SPEC_MAX_WORKING_HEIGHT_LABEL: "machinerySpecMaxWorkingHeightLabel",
    MACHINERY_SPEC_MAX_LOAD_CAPACITY_LABEL: "machinerySpecMaxLoadCapacityLabel",
    MACHINERY_SPEC_OUTREACH_LABEL: "machinerySpecOutreachLabel",
    MACHINERY_SPEC_ATTACHMENT_WEIGHT_LABEL: "machinerySpecAttachmentWeightLabel",
    MACHINERY_SPEC_HYDRAULIC_FLOW_LABEL: "machinerySpecHydraulicFlowLabel",
    MACHINERY_SPEC_WORKING_PRESSURE_LABEL: "machinerySpecWorkingPressureLabel",
    MACHINERY_SPEC_TIP_DIAMETER_LABEL: "machinerySpecTipDiameterLabel",
    MACHINERY_SPEC_COMPATIBLE_CARRIER_WEIGHT_LABEL: "machinerySpecCompatibleCarrierWeightLabel",
    MACHINERY_SPEC_BLADE_WIDTH_LABEL: "machinerySpecBladeWidthLabel",
    MACHINERY_SPEC_BLADE_TYPE_LABEL: "machinerySpecBladeTypeLabel",
    MACHINERY_SPEC_BLADE_TYPE_PAT: "machinerySpecBladeTypePat",
    MACHINERY_SPEC_BLADE_TYPE_SEMI_U: "machinerySpecBladeTypeSemiU",
    MACHINERY_SPEC_BLADE_TYPE_STRAIGHT: "machinerySpecBladeTypeStraight",
    MACHINERY_SPEC_HAS_RIPPER_LABEL: "machinerySpecHasRipperLabel",
    MACHINERY_SPEC_HAS_3D_GPS_LABEL: "machinerySpecHas3dGpsLabel",
    MACHINERY_SPEC_UNIT_M: "machinerySpecUnitM",
    MACHINERY_SPEC_UNIT_M3: "machinerySpecUnitM3",
    MACHINERY_SPEC_UNIT_KG: "machinerySpecUnitKg",
    MACHINERY_SPEC_UNIT_L_MIN: "machinerySpecUnitLMin",
    MACHINERY_SPEC_UNIT_BAR: "machinerySpecUnitBar",
    MACHINERY_SPEC_UNIT_MM: "machinerySpecUnitMm",

    // ===== Pre-launch landing, legal pages and the admin waiting list =====
    PRELAUNCH_BADGE: "prelaunchBadge",
    PRELAUNCH_HERO_TITLE: "prelaunchHeroTitle",
    PRELAUNCH_HERO_SUBTITLE: "prelaunchHeroSubtitle",
    PRELAUNCH_FORM_TITLE: "prelaunchFormTitle",
    PRELAUNCH_FORM_SUBTITLE: "prelaunchFormSubtitle",
    PRELAUNCH_INTEREST_LABEL: "prelaunchInterestLabel",
    PRELAUNCH_INTEREST_HAS_MACHINERY: "prelaunchInterestHasMachinery",
    PRELAUNCH_INTEREST_WANTS_MACHINERY: "prelaunchInterestWantsMachinery",
    PRELAUNCH_INTEREST_OFFERS_SERVICES: "prelaunchInterestOffersServices",
    PRELAUNCH_INTEREST_WANTS_SERVICES: "prelaunchInterestWantsServices",
    PRELAUNCH_INTEREST_REQUIRED: "prelaunchInterestRequired",
    PRELAUNCH_EMAIL_LABEL: "prelaunchEmailLabel",
    PRELAUNCH_EMAIL_REQUIRED: "prelaunchEmailRequired",
    PRELAUNCH_PHONE_LABEL: "prelaunchPhoneLabel",
    PRELAUNCH_MESSAGE_LABEL: "prelaunchMessageLabel",
    PRELAUNCH_MESSAGE_PLACEHOLDER: "prelaunchMessagePlaceholder",
    PRELAUNCH_CONSENT_LABEL: "prelaunchConsentLabel",
    PRELAUNCH_CONSENT_REQUIRED: "prelaunchConsentRequired",
    PRELAUNCH_PRIVACY_LINK: "prelaunchPrivacyLink",
    PRELAUNCH_SUBMIT: "prelaunchSubmit",
    PRELAUNCH_SUBMIT_ERROR: "prelaunchSubmitError",
    PRELAUNCH_NO_SPAM: "prelaunchNoSpam",
    PRELAUNCH_DONE_TITLE: "prelaunchDoneTitle",
    PRELAUNCH_DONE_BODY: "prelaunchDoneBody",
    LEGAL_UPDATED_AT: "legalUpdatedAt",
    PRIVACY_LANDING_TITLE: "privacyLandingTitle",
    PRIVACY_LANDING_SCOPE: "privacyLandingScope",
    PRIVACY_LANDING_CONTROLLER_HEADING: "privacyLandingControllerHeading",
    PRIVACY_LANDING_CONTROLLER_BODY: "privacyLandingControllerBody",
    PRIVACY_LANDING_CONTROLLER_CONTACT: "privacyLandingControllerContact",
    PRIVACY_LANDING_DATA_HEADING: "privacyLandingDataHeading",
    PRIVACY_LANDING_DATA_BODY_1: "privacyLandingDataBody1",
    PRIVACY_LANDING_DATA_BODY_2: "privacyLandingDataBody2",
    PRIVACY_LANDING_PURPOSE_HEADING: "privacyLandingPurposeHeading",
    PRIVACY_LANDING_PURPOSE_BODY_1: "privacyLandingPurposeBody1",
    PRIVACY_LANDING_PURPOSE_BODY_2: "privacyLandingPurposeBody2",
    PRIVACY_LANDING_BASIS_HEADING: "privacyLandingBasisHeading",
    PRIVACY_LANDING_BASIS_BODY: "privacyLandingBasisBody",
    PRIVACY_LANDING_SHARING_HEADING: "privacyLandingSharingHeading",
    PRIVACY_LANDING_SHARING_BODY_1: "privacyLandingSharingBody1",
    PRIVACY_LANDING_SHARING_BODY_2: "privacyLandingSharingBody2",
    PRIVACY_LANDING_RETENTION_HEADING: "privacyLandingRetentionHeading",
    PRIVACY_LANDING_RETENTION_BODY: "privacyLandingRetentionBody",
    PRIVACY_LANDING_RIGHTS_HEADING: "privacyLandingRightsHeading",
    PRIVACY_LANDING_RIGHTS_BODY_1: "privacyLandingRightsBody1",
    PRIVACY_LANDING_RIGHTS_BODY_2: "privacyLandingRightsBody2",
    PRIVACY_LANDING_NO_EMAIL_HEADING: "privacyLandingNoEmailHeading",
    PRIVACY_LANDING_NO_EMAIL_BODY: "privacyLandingNoEmailBody",
    REGISTRATION_CLOSED_TITLE: "registrationClosedTitle",
    REGISTRATION_CLOSED_BODY: "registrationClosedBody",
    REGISTRATION_CLOSED_CTA: "registrationClosedCta",
    ADMIN_NAV_SIGNUP_LEADS: "adminNavSignupLeads",
    ADMIN_SIGNUP_LEADS_DESCRIPTION: "adminSignupLeadsDescription",
    ADMIN_SIGNUP_LEADS_UNVERIFIED_NOTICE: "adminSignupLeadsUnverifiedNotice",
    ADMIN_SIGNUP_LEADS_EMPTY: "adminSignupLeadsEmpty",
    ADMIN_SIGNUP_LEADS_LOAD_ERROR: "adminSignupLeadsLoadError",
    ADMIN_SIGNUP_LEADS_COLUMN_EMAIL: "adminSignupLeadsColumnEmail",
    ADMIN_SIGNUP_LEADS_COLUMN_PHONE: "adminSignupLeadsColumnPhone",
    ADMIN_SIGNUP_LEADS_COLUMN_MESSAGE: "adminSignupLeadsColumnMessage",
    ADMIN_SIGNUP_LEADS_COLUMN_INTERESTS: "adminSignupLeadsColumnInterests",
    ADMIN_SIGNUP_LEADS_COLUMN_CREATED: "adminSignupLeadsColumnCreated",
    ADMIN_SIGNUP_LEADS_COLUMN_CONTACTED: "adminSignupLeadsColumnContacted",
    ADMIN_SIGNUP_LEADS_CONTACTED_YES: "adminSignupLeadsContactedYes",
    ADMIN_SIGNUP_LEADS_CONTACTED_NO: "adminSignupLeadsContactedNo",
    ADMIN_SIGNUP_LEADS_MARK_CONTACTED: "adminSignupLeadsMarkContacted",
    ADMIN_SIGNUP_LEADS_MARK_PENDING: "adminSignupLeadsMarkPending",
    ADMIN_SIGNUP_LEADS_TOTAL: "adminSignupLeadsTotal",
    ADMIN_FEATURE_FLAG_LANDING_MODE_LABEL: "adminFeatureFlagLandingModeLabel",
    ADMIN_FEATURE_FLAG_LANDING_MODE_DESCRIPTION: "adminFeatureFlagLandingModeDescription",
    ADMIN_FEATURE_FLAG_REGISTRATION_ENABLED_LABEL: "adminFeatureFlagRegistrationEnabledLabel",
    ADMIN_FEATURE_FLAG_REGISTRATION_ENABLED_DESCRIPTION: "adminFeatureFlagRegistrationEnabledDescription",

    // ===== Comisión por persona (AdminProviderFeeTermsController) =====
    ADMIN_FEE_TERMS_BUTTON: "adminFeeTermsButton",
    ADMIN_FEE_TERMS_COLUMN: "adminFeeTermsColumn",
    ADMIN_FEE_TERMS_STANDARD: "adminFeeTermsStandard",
    ADMIN_FEE_TERMS_TITLE: "adminFeeTermsTitle",
    ADMIN_FEE_TERMS_DEFAULT_NOTE: "adminFeeTermsDefaultNote",
    ADMIN_FEE_TERMS_PERCENT_LABEL: "adminFeeTermsPercentLabel",
    ADMIN_FEE_TERMS_PERCENT_INVALID: "adminFeeTermsPercentInvalid",
    ADMIN_FEE_TERMS_FIXED_LABEL: "adminFeeTermsFixedLabel",
    ADMIN_FEE_TERMS_FIXED_INVALID: "adminFeeTermsFixedInvalid",
    ADMIN_FEE_TERMS_REASON_LABEL: "adminFeeTermsReasonLabel",
    ADMIN_FEE_TERMS_REASON_PLACEHOLDER: "adminFeeTermsReasonPlaceholder",
    ADMIN_FEE_TERMS_REASON_HELP: "adminFeeTermsReasonHelp",
    ADMIN_FEE_TERMS_REASON_REQUIRED: "adminFeeTermsReasonRequired",
    ADMIN_FEE_TERMS_NOT_RETROACTIVE: "adminFeeTermsNotRetroactive",
    ADMIN_FEE_TERMS_SAVE: "adminFeeTermsSave",
    ADMIN_FEE_TERMS_CANCEL: "adminFeeTermsCancel",
    ADMIN_FEE_TERMS_CLEAR: "adminFeeTermsClear",

    // ===== Tarifario del proveedor =====
    RATE_CATALOG_TITLE: "rateCatalogTitle",
    RATE_CATALOG_SUBTITLE: "rateCatalogSubtitle",
    RATE_CATALOG_TAB_PRICES: "rateCatalogTabPrices",
    RATE_CATALOG_TAB_DOCUMENTS: "rateCatalogTabDocuments",
    RATE_CATALOG_SEARCH_PLACEHOLDER: "rateCatalogSearchPlaceholder",
    RATE_CATALOG_EMPTY_TITLE: "rateCatalogEmptyTitle",
    RATE_CATALOG_EMPTY_DESCRIPTION: "rateCatalogEmptyDescription",
    RATE_CATALOG_LOAD_ERROR: "rateCatalogLoadError",
    RATE_SHEET_UPLOAD_CTA: "rateSheetUploadCta",
    RATE_SHEET_UPLOAD_TITLE: "rateSheetUploadTitle",
    RATE_SHEET_UPLOAD_DESCRIPTION: "rateSheetUploadDescription",
    RATE_SHEET_UPLOAD_DROP: "rateSheetUploadDrop",
    RATE_SHEET_UPLOAD_FORMATS: "rateSheetUploadFormats",
    RATE_SHEET_UPLOAD_CONFIRM: "rateSheetUploadConfirm",
    RATE_SHEET_UPLOAD_STARTED: "rateSheetUploadStarted",
    RATE_SHEET_UPLOAD_ERROR: "rateSheetUploadError",
    RATE_SHEET_VAT_QUESTION: "rateSheetVatQuestion",
    RATE_SHEET_VAT_EXCLUDED: "rateSheetVatExcluded",
    RATE_SHEET_VAT_INCLUDED: "rateSheetVatIncluded",
    RATE_SHEET_STATUS_ANALYZING: "rateSheetStatusAnalyzing",
    RATE_SHEET_STATUS_PENDING_REVIEW: "rateSheetStatusPendingReview",
    RATE_SHEET_STATUS_CONFIRMED: "rateSheetStatusConfirmed",
    RATE_SHEET_STATUS_FAILED: "rateSheetStatusFailed",
    RATE_SHEET_REVIEW_CTA: "rateSheetReviewCta",
    RATE_SHEET_NONE_YET: "rateSheetNoneYet",
    RATE_SHEET_ITEMS_CONFIRMED: "rateSheetItemsConfirmed",
    RATE_SHEET_DELETE_TITLE: "rateSheetDeleteTitle",
    RATE_SHEET_DELETE_DESCRIPTION: "rateSheetDeleteDescription",
    RATE_ITEM_ADD: "rateItemAdd",
    RATE_ITEM_EDIT_TITLE: "rateItemEditTitle",
    RATE_ITEM_SAVE: "rateItemSave",
    RATE_ITEM_SAVED: "rateItemSaved",
    RATE_ITEM_SAVE_ERROR: "rateItemSaveError",
    RATE_ITEM_TITLE_LABEL: "rateItemTitleLabel",
    RATE_ITEM_TITLE_REQUIRED: "rateItemTitleRequired",
    RATE_ITEM_REFERENCE_LABEL: "rateItemReferenceLabel",
    RATE_ITEM_KIND_LABEL: "rateItemKindLabel",
    RATE_ITEM_UNIT_LABEL: "rateItemUnitLabel",
    RATE_ITEM_PRICE_LABEL: "rateItemPriceLabel",
    RATE_ITEM_PRICE_REQUIRED: "rateItemPriceRequired",
    RATE_ITEM_PRICE_VAT_NOTE: "rateItemPriceVatNote",
    RATE_ITEM_KIND_MATERIAL: "rateItemKindMaterial",
    RATE_ITEM_KIND_LABOUR: "rateItemKindLabour",
    RATE_ITEM_KIND_TRAVEL: "rateItemKindTravel",
    RATE_ITEM_SOURCE_YOURS: "rateItemSourceYours",
    RATE_ITEM_DELETE_TITLE: "rateItemDeleteTitle",
    RATE_ITEM_DELETE_CONFIRM: "rateItemDeleteConfirm",
    RATE_ITEM_DELETE_CANCEL: "rateItemDeleteCancel",
    RATE_SHEET_REVIEW_TITLE: "rateSheetReviewTitle",
    RATE_SHEET_REVIEW_BACK: "rateSheetReviewBack",
    RATE_SHEET_REVIEW_NOTICE: "rateSheetReviewNotice",
    RATE_SHEET_REVIEW_VAT_ADDED: "rateSheetReviewVatAdded",
    RATE_SHEET_REVIEW_COUNT: "rateSheetReviewCount",
    RATE_SHEET_REVIEW_UNSURE: "rateSheetReviewUnsure",
    RATE_SHEET_REVIEW_CONFLICT: "rateSheetReviewConflict",
    RATE_SHEET_REVIEW_NO_PRICE: "rateSheetReviewNoPrice",
    RATE_SHEET_REVIEW_DROP_ROW: "rateSheetReviewDropRow",
    RATE_SHEET_REVIEW_KEEP_ROW: "rateSheetReviewKeepRow",
    RATE_SHEET_REVIEW_CONFIRM_CTA: "rateSheetReviewConfirmCta",
    RATE_SHEET_REVIEW_CONFIRMED: "rateSheetReviewConfirmed",
    RATE_SHEET_REVIEW_SKIPPED: "rateSheetReviewSkipped",
    RATE_SHEET_REVIEW_MISSING_PRICES: "rateSheetReviewMissingPrices",
    RATE_SHEET_REVIEW_NOTHING_SELECTED: "rateSheetReviewNothingSelected",
    RATE_SHEET_REVIEW_LOAD_ERROR: "rateSheetReviewLoadError",
    RATE_SHEET_REVIEW_SAVE_ERROR: "rateSheetReviewSaveError",
    ASSISTANT_GUIDE_TAB: "assistantGuideTab",
    ASSISTANT_GUIDE_INTRO: "assistantGuideIntro",
    ASSISTANT_GUIDE_DEFAULT_NOTICE: "assistantGuideDefaultNotice",
    ASSISTANT_GUIDE_PLACEHOLDER: "assistantGuidePlaceholder",
    ASSISTANT_GUIDE_REMOVE: "assistantGuideRemove",
    ASSISTANT_GUIDE_ADD: "assistantGuideAdd",
    ASSISTANT_GUIDE_SAVE: "assistantGuideSave",
    ASSISTANT_GUIDE_SAVED: "assistantGuideSaved",
    ASSISTANT_GUIDE_MAX: "assistantGuideMax",
    ASSISTANT_GUIDE_EMPTY_HINT: "assistantGuideEmptyHint",
    ASSISTANT_GUIDE_CAP_NOTE: "assistantGuideCapNote",
    ASSISTANT_GUIDE_LOAD_ERROR: "assistantGuideLoadError",
    ASSISTANT_GUIDE_SAVE_ERROR: "assistantGuideSaveError",
    ASSISTANT_GUIDE_RATE_NOTE: "assistantGuideRateNote",
    VISIT_FEE_TAB: "visitFeeTab",
    VISIT_FEE_INTRO: "visitFeeIntro",
    VISIT_FEE_SWITCH: "visitFeeSwitch",
    VISIT_FEE_AMOUNT_LABEL: "visitFeeAmountLabel",
    VISIT_FEE_SAVE: "visitFeeSave",
    VISIT_FEE_SAVED: "visitFeeSaved",
    VISIT_FEE_SAVE_ERROR: "visitFeeSaveError",
    VISIT_FEE_LOAD_ERROR: "visitFeeLoadError",
    VISIT_FEE_AMOUNT_REQUIRED: "visitFeeAmountRequired",
    VISIT_FEE_MAX: "visitFeeMax",
    VISIT_FEE_OFF_NOTE: "visitFeeOffNote",
    VISIT_FEE_ON_NOTE: "visitFeeOnNote",
    VISIT_FEE_LINE_TITLE: "visitFeeLineTitle",
    VISIT_FEE_LOCKED_HINT: "visitFeeLockedHint",
    VISIT_FEE_CARD_TAG: "visitFeeCardTag",
    SERVICE_VISIT_FEE_NOTICE: "serviceVisitFeeNotice",
    SERVICE_SAVE_CARD_BUTTON: "serviceSaveCardButton",
    SERVICE_SAVE_CARD_ERROR: "serviceSaveCardError",
    SERVICE_SAVE_CARD_DONE: "serviceSaveCardDone",
    SERVICE_HOLD_NOT_A_CHARGE: "serviceHoldNotACharge",
    SERVICE_COMPLETED_BUTTON: "serviceCompletedButton",
    SERVICE_COMPLETED_CONFIRM_TITLE: "serviceCompletedConfirmTitle",
    SERVICE_COMPLETED_CONFIRM_HELD: "serviceCompletedConfirmHeld",
    SERVICE_COMPLETED_CONFIRM_PAID: "serviceCompletedConfirmPaid",
    SERVICE_COMPLETED_CONFIRM_BUTTON: "serviceCompletedConfirmButton",
    SERVICE_COMPLETED_KEEP_OPEN: "serviceCompletedKeepOpen",
    SERVICE_COMPLETED_SUCCESS: "serviceCompletedSuccess",
    SERVICE_COMPLETED_ERROR: "serviceCompletedError",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_SERVICE_COMPLETED: "heavyDutyMachineryNotifTitleServiceCompleted",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_SERVICE_COMPLETED: "heavyDutyMachineryNotifBodyServiceCompleted",
    SERVICE_REQUEST_CONFIRM_HOURS_LEFT: "serviceRequestConfirmHoursLeft",
    SERVICE_REQUEST_WAITING_FOR_VISIT_DEADLINE: "serviceRequestWaitingForVisitDeadline",
    SERVICE_REQUEST_CONFIRM_DEADLINE: "serviceRequestConfirmDeadline",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_NEW_SERVICE_REQUEST: "heavyDutyMachineryNotifTitleNewServiceRequest",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_NEW_SERVICE_REQUEST: "heavyDutyMachineryNotifBodyNewServiceRequest",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_SERVICE_REQUEST_QUOTED: "heavyDutyMachineryNotifTitleServiceRequestQuoted",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_SERVICE_REQUEST_QUOTED: "heavyDutyMachineryNotifBodyServiceRequestQuoted",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_SERVICE_REQUEST_ACCEPTED: "heavyDutyMachineryNotifTitleServiceRequestAccepted",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_SERVICE_REQUEST_ACCEPTED: "heavyDutyMachineryNotifBodyServiceRequestAccepted",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_SERVICE_REQUEST_DECLINED: "heavyDutyMachineryNotifTitleServiceRequestDeclined",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_SERVICE_REQUEST_DECLINED: "heavyDutyMachineryNotifBodyServiceRequestDeclined",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_SERVICE_REQUEST_CANCELLED: "heavyDutyMachineryNotifTitleServiceRequestCancelled",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_SERVICE_REQUEST_CANCELLED: "heavyDutyMachineryNotifBodyServiceRequestCancelled",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_SERVICE_REQUEST_EXPIRED: "heavyDutyMachineryNotifTitleServiceRequestExpired",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_SERVICE_REQUEST_EXPIRED: "heavyDutyMachineryNotifBodyServiceRequestExpired",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_SERVICE_VISIT_SCHEDULED: "heavyDutyMachineryNotifTitleServiceVisitScheduled",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_SERVICE_VISIT_SCHEDULED: "heavyDutyMachineryNotifBodyServiceVisitScheduled",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_SERVICE_VISIT_NOT_CONFIRMED: "heavyDutyMachineryNotifTitleServiceVisitNotConfirmed",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_SERVICE_VISIT_NOT_CONFIRMED: "heavyDutyMachineryNotifBodyServiceVisitNotConfirmed",
    HEAVY_DUTY_MACHINERY_NOTIF_TITLE_SERVICE_VISIT_MISSED: "heavyDutyMachineryNotifTitleServiceVisitMissed",
    HEAVY_DUTY_MACHINERY_NOTIF_BODY_SERVICE_VISIT_MISSED: "heavyDutyMachineryNotifBodyServiceVisitMissed",
    SERVICES_SEARCH_RESULTS_SUFFIX: "servicesSearchResultsSuffix",
    SERVICES_SEARCH_RESULTS_SUFFIX_SINGULAR: "servicesSearchResultsSuffixSingular",
    SERVICES_SEARCH_MOBILE_LOADING_MESSAGE: "servicesSearchMobileLoadingMessage",
    HOMEPAGE_SEARCH_LABEL_CATEGORY_SERVICE: "homepageSearchLabelCategoryService",
    HOMEPAGE_SEARCH_CATEGORY_PLACEHOLDER_SERVICE: "homepageSearchCategoryPlaceholderService",
    SERVICE_CATEGORY_SECTOR_GENERAL: "serviceCategorySectorGeneral",
    SERVICE_FILTERS_CATEGORY_LABEL: "serviceFiltersCategoryLabel",
    SERVICE_FILTERS_CATEGORY_PLACEHOLDER: "serviceFiltersCategoryPlaceholder",
    SERVICE_FILTERS_ANY: "serviceFiltersAny",
    SERVICE_FILTERS_REQUEST_MODE_LABEL: "serviceFiltersRequestModeLabel",
    SERVICE_FILTERS_REQUEST_MODE_HINT: "serviceFiltersRequestModeHint",
    SERVICE_FILTERS_REQUEST_MODE_INSTANT: "serviceFiltersRequestModeInstant",
    SERVICE_FILTERS_REQUEST_MODE_QUOTE: "serviceFiltersRequestModeQuote",
    SERVICE_FILTERS_PRICING_MODE_LABEL: "serviceFiltersPricingModeLabel",
    SERVICE_CARD_QUOTE_ONLY_PRICE: "serviceCardQuoteOnlyPrice",
    SERVICE_CARD_FIXED_JOB_SUFFIX: "serviceCardFixedJobSuffix",
    SERVICE_CARD_QUOTE_BADGE: "serviceCardQuoteBadge",
    MESSAGES_QUOTE_REQUEST_SUBTITLE: "messagesQuoteRequestSubtitle",
    MESSAGES_QUOTE_REQUEST_CARD_TITLE: "messagesQuoteRequestCardTitle",
    MESSAGES_QUOTE_REQUEST_OPEN: "messagesQuoteRequestOpen",
};